webpackJsonp([35783957827783],{

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Adp (props) {
	    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"fill":"#D0271D","d":"M145.5,50.35h-8.38v8.37h8.38c2,0,3.59,1.62,3.59,3.6c0,2-1.59,3.59-3.59,3.59h-8.38v8.39h8.38\n\t\t\tc6.61,0,11.97-5.37,11.97-11.98C157.47,55.72,152.11,50.35,145.5,50.35 M97.74,94.66c10.02,0,18.67-5.87,22.72-14.37h10.68v14.37\n\t\t\th5.98V80.28h8.38c9.93,0,17.96-8.04,17.96-17.96c0-9.91-8.03-17.95-17.96-17.95h-14.36v21.55h-8.53\n\t\t\tc-1.73-12.18-12.21-21.55-24.87-21.55H68.26L38.95,94.66h6.99l8.37-14.37h30.14v14.37H97.74z M171.85,62.32\n\t\t\tc0,14.55-11.81,26.33-26.35,26.33v14.37h-22.74V91.82c-6.15,6.88-15.08,11.21-25.02,11.21H76.06V88.66H59.13l-8.38,14.37h-26.6\n\t\t\tl39.1-67.04h34.5c9.95,0,18.87,4.34,25.02,11.22V35.99h22.74C160.05,35.99,171.85,47.79,171.85,62.32 M76.06,50.35v15.56H62.71\n\t\t\tl-4.88,8.39h26.63V50.35H76.06z M116.89,69.51c0,10.58-8.58,19.15-19.15,19.15h-7.31v-8.37h7.31c5.95,0,10.77-4.82,10.77-10.78\n\t\t\tc0-5.94-4.82-10.78-10.77-10.78h-7.31v-8.37h7.31C108.31,50.35,116.89,58.93,116.89,69.51 M153.06,98.35V97.1h0.91\n\t\t\tc0.61,0,0.78,0.19,0.78,0.56c0,0.37-0.17,0.67-0.88,0.69H153.06z M153.7,99.12c0.26,0.03,0.51,0,0.71,0.21\n\t\t\tc0.21,0.23,0.21,0.62,0.27,1.04c0.04,0.29,0.11,0.59,0.17,0.88h0.97c-0.16-0.44-0.22-0.95-0.29-1.41\n\t\t\tc-0.07-0.54-0.15-0.84-0.83-0.97v-0.03c0.66-0.13,1-0.57,1-1.13c0-1.11-0.93-1.35-1.82-1.35h-1.59v4.9h0.77v-2.12H153.7z\n\t\t\t M153.94,103.03c2.31,0,4.15-1.87,4.15-4.19c0-2.29-1.85-4.15-4.15-4.15c-2.31,0-4.18,1.86-4.18,4.15\n\t\t\tC149.76,101.16,151.63,103.03,153.94,103.03 M153.94,102.28c-1.91,0-3.44-1.53-3.44-3.44c0-1.88,1.54-3.43,3.44-3.43\n\t\t\tc1.89,0,3.42,1.55,3.42,3.43C157.37,100.75,155.83,102.28,153.94,102.28"}))));
	}
	
	Adp.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Adp;
	
	Adp.default = Adp;


/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Basf (props) {
	    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,[React.createElement("g",{"key":0},[React.createElement("path",{"style":{"fill":"#231F20"},"d":"M74.3,58.78c0,0,15.07,0,18.1,0c6.64,0,9.68,4.43,9.68,8.48c0,2.91-1.12,4.8-4.13,6.55\n\t\t\t\tc3.79,1.4,5.86,3.93,5.86,7.83c0,4.67-3.39,9.62-11.38,9.62c-4.43,0-18.13,0-18.13,0L74.3,58.78z M84.18,83.93c0,0,4.21,0,6.55,0\n\t\t\t\tc2.33,0,3.38-1.67,3.38-3.14c0,0.68,0.3-2.69-3.05-2.69c-1.76,0-6.88,0-6.88,0V83.93z M84.2,71.57c0,0,3.05,0,5.26,0\n\t\t\t\tc2.41,0,3.36-1.12,3.36-2.76c0-0.38-0.12-2.5-2.67-2.5c1.17,0-5.95,0-5.95,0V71.57z","key":0}),React.createElement("path",{"style":{"fill":"#231F20"},"d":"M114.09,58.78h10.46l11.92,32.44h-10.74l-1.57-4.86h-10.02l-1.33,4.83h-10.66L114.09,58.78z M118.89,68.41\n\t\t\t\tl-2.76,10.83h5.9L118.89,68.41z","key":1}),React.createElement("path",{"style":{"fill":"#231F20"},"d":"M153.16,68.43h9.98c0-5.51-4.14-10.62-13.98-10.62c-10.79,0-14.13,5.95-14.13,10.31\n\t\t\t\tc0,7.02,8.6,8.89,8.86,8.98c1.29,0.4,6.62,1.83,7.95,2.31c1.15,0.41,2.26,1.34,2.26,2.57c0,1.9-2.26,2.81-4.14,2.81\n\t\t\t\tc-1.21,0-5.26-0.4-5.26-4.7h-10.31c0,5.71,3.93,12.1,14.95,12.1c12.17,0,14.71-7.26,14.71-11.12c0-3.15-1.78-6.64-5.9-8.31\n\t\t\t\tc-2.48-1-6.58-1.88-8.64-2.48c-1.04-0.3-4.5-1.01-4.5-3.12c0-2.71,4.46-2.36,3.81-2.36C150.84,64.81,153.16,65.95,153.16,68.43z","key":2}),React.createElement("polygon",{"style":{"fill":"#231F20"},"points":"165.75,58.78 190.66,58.78 190.66,67.35 175.7,67.35 175.7,73.06 189.04,73.06 189.04,81.25 \n\t\t\t\t175.66,81.25 175.66,91.25 165.71,91.25 \t\t\t","key":3})]),React.createElement("path",{"style":{"fill":"#231F20"},"d":"M9.34,58.78v32.48h32.48V58.78H9.34z M31.83,81.27H19.34V68.78h12.49V81.27z","key":1}),React.createElement("rect",{"x":"51.81","y":"68.78","style":{"fill":"#231F20"},"width":"12.49","height":"12.49","key":2})])));
	}
	
	Basf.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Basf;
	
	Basf.default = Basf;


/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Bnsf (props) {
	    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{ style=\"fill:#EF5423;\"fill:#EF5423;}\n\t.st1{fill:#231F20;}\n"),React.createElement("g",{"key":1},[React.createElement("path",{"style":{"fill":"#EF5423"},"d":"M24.99,56.94h22.46c9.98,0,12.9,1.59,10.56,4.52c-1.88,2.36-6.14,3.46-10.91,4.01l-0.04,0.05\n\t\tc4.53,0.14,8.06,1.32,5.68,4.3c-1.07,1.35-2.93,2.48-4.91,3.13c-2.91,0.96-5.36,1.35-12.47,1.35H11.13L24.99,56.94z M26.88,70.44\n\t\th5.03c4.46,0,6.32-0.44,7.39-1.79c1.08-1.35,0.07-2.02-4.4-2.02l-4.91,0.02L26.88,70.44z M32.2,63.75h4.75\n\t\tc3.74,0,5.49-0.78,6.34-1.85c0.91-1.14,0.68-1.57-3.36-1.57l-4.83-0.04L32.2,63.75z","key":0}),React.createElement("path",{"style":{"fill":"#EF5423"},"d":"M68.08,56.94h20.06l1.76,11.63h0.14l8.75-11.63h12.34L97.41,74.29H77.98l-1.69-12.35h0.18l-9.76,12.35H54.36\n\t\tL68.08,56.94z","key":1}),React.createElement("path",{"style":{"fill":"#EF5423"},"d":"M122.12,68.72c-0.72,0.96-0.23,1.56,0.27,2.02c0.55,0.46,2.04,0.79,3.87,0.79c2.48,0,6.14-0.35,6.86-1.25\n\t\tc0.25-0.31,0.05-1.08-0.14-1.3c-0.99-1.11-16.05-1.92-18.84-3.97c-1.12-0.82-0.69-2.04,0.09-3.03c3.03-3.8,10.91-5.73,24.08-5.73\n\t\tc13.99,0,16.69,2.27,14.01,5.85h-13.13c0.68-0.96,0.33-1.66-0.38-2.02c-0.67-0.36-2.02-0.57-3.76-0.57c-2.92,0-5.15,0.35-5.86,1.24\n\t\tc-0.21,0.26-0.21,1.01,0.05,1.2c1.28,1.08,15.88,1.85,18.6,3.92c0.8,0.6,1.37,1.54,0.02,3.22c-2.74,3.44-10.11,5.79-25.1,5.79\n\t\tc-17.86,0-16.62-2.95-14.32-6.17H122.12z","key":2}),React.createElement("path",{"style":{"fill":"#EF5423"},"d":"M164.05,56.94h30.25l-3.31,3.96h-15.99l-2.9,3.3h15.58l-2.96,3.79h-15.58l-5.19,6.3h-13.76L164.05,56.94z","key":3}),React.createElement("polygon",{"style":{"fill":"#231F20"},"points":"177.6,79.06 0.73,87.37 8.31,77.8 178.6,77.8 \t","key":4}),React.createElement("path",{"style":{"fill":"#231F20"},"d":"M96.2,86.06l4.56-0.02c1.67-0.01,2.24,0.83,1.47,2.05c-0.94,1.34-1.77,1.86-3.49,1.99l-0.01,0.02\n\t\tc1.68,0.07,1.27,0.86,0.35,2.28c-0.42,0.64-0.61,1.03-0.71,1.33l-1.83,0.01c0.06-0.22,0.39-0.77,0.69-1.21\n\t\tc0.99-1.51,0.87-1.82-0.79-1.81l-1.59,0.01l-2.14,3.04l-1.92,0L96.2,86.06z M95.82,89.26l1.78,0.01c1.29,0,2.13-0.16,2.9-0.92\n\t\tc0.55-0.85,0.17-1.28-1.07-1.21l-2.16,0.01L95.82,89.26z","key":5}),React.createElement("path",{"style":{"fill":"#231F20"},"d":"M110.82,85.99l2.79-0.01l-1.53,7.67l-2.02,0.01l0.34-1.72l-4.38,0.02L104,93.68l-2.47,0.01L110.82,85.99z\n\t\t M110.67,90.68l0.77-3.34l-3.93,3.35L110.67,90.68z","key":6}),React.createElement("path",{"style":{"fill":"#231F20"},"d":"M156.28,85.88l2.8-0.01l-1.54,7.78l-2.03,0.01l0.34-1.75l-4.41,0.02l-2.03,1.75l-2.49,0.01L156.28,85.88z\n\t\t M156.13,90.64l0.78-3.38l-3.96,3.4L156.13,90.64z","key":7}),React.createElement("path",{"style":{"fill":"#231F20"},"d":"M120.95,85.94l2.08-0.01l-5.41,7.68l-2.08,0.01L120.95,85.94z","key":8}),React.createElement("path",{"style":{"fill":"#231F20"},"d":"M128.44,85.9l1.84-0.01l-4.34,6.22l4.18-0.02l-1.08,1.51l-6-0.02L128.44,85.9z","key":9}),React.createElement("path",{"style":{"fill":"#231F20"},"d":"M142.07,85.83l2.15-0.01l-2.18,6h0.02l6.19-6.01l1.71-0.01l-8.02,7.8h-2.24l2.26-6.22h-0.02l-6.34,6.2l-2.1,0\n\t\tl2.72-7.73l1.83-0.01l-2.22,5.99h0.02L142.07,85.83z","key":10}),React.createElement("path",{"style":{"fill":"#231F20"},"d":"M173.07,85.81l-6.67,4.77l-2.11,3.01l-2.05,0.01l2.14-3.01l-0.36-4.72l2.22-0.02l0.1,2.92l3.91-2.94\n\t\tL173.07,85.81z","key":11}),React.createElement("polygon",{"style":{"fill":"#231F20"},"points":"143.67,85.83 141.74,85.82 135.24,92.11 134.3,93.52 135.7,93.52 \t","key":12}),React.createElement("polygon",{"style":{"fill":"#231F20"},"points":"149.95,85.83 147.9,85.82 141.4,92.11 140.58,93.52 141.98,93.52 \t","key":13}),React.createElement("g",{"key":14},React.createElement("path",{"style":{"fill":"#231F20"},"d":"M197.49,56.96c0.3,0,0.59,0.08,0.88,0.23c0.28,0.15,0.51,0.37,0.67,0.66c0.16,0.29,0.24,0.58,0.24,0.89\n\t\t\tc0,0.31-0.08,0.6-0.23,0.89c-0.16,0.28-0.38,0.5-0.66,0.66c-0.28,0.16-0.58,0.24-0.89,0.24c-0.31,0-0.6-0.08-0.89-0.24\n\t\t\tc-0.28-0.16-0.5-0.38-0.66-0.66c-0.16-0.28-0.24-0.58-0.24-0.89c0-0.31,0.08-0.61,0.24-0.89c0.16-0.29,0.38-0.51,0.67-0.66\n\t\t\tC196.9,57.04,197.19,56.96,197.49,56.96z M197.49,57.26c-0.25,0-0.49,0.06-0.73,0.19c-0.24,0.13-0.42,0.31-0.56,0.55\n\t\t\tc-0.13,0.24-0.2,0.49-0.2,0.75c0,0.26,0.07,0.5,0.2,0.74c0.13,0.24,0.32,0.42,0.55,0.55c0.24,0.13,0.48,0.2,0.74,0.2\n\t\t\tc0.26,0,0.5-0.07,0.74-0.2c0.24-0.13,0.42-0.32,0.55-0.55c0.13-0.24,0.2-0.48,0.2-0.74c0-0.26-0.07-0.51-0.2-0.75\n\t\t\tc-0.13-0.24-0.32-0.42-0.56-0.55C197.98,57.32,197.74,57.26,197.49,57.26z M196.71,59.73v-1.92h0.66c0.23,0,0.39,0.02,0.49,0.05\n\t\t\tc0.1,0.04,0.18,0.1,0.24,0.19c0.06,0.09,0.09,0.18,0.09,0.28c0,0.14-0.05,0.26-0.15,0.37c-0.1,0.1-0.23,0.16-0.4,0.17\n\t\t\tc0.07,0.03,0.12,0.06,0.16,0.1c0.08,0.08,0.17,0.2,0.28,0.38l0.23,0.38h-0.38l-0.17-0.3c-0.13-0.24-0.24-0.39-0.32-0.45\n\t\t\tc-0.06-0.04-0.14-0.07-0.25-0.06h-0.18v0.82H196.71z M197.01,58.65h0.38c0.18,0,0.3-0.03,0.37-0.08c0.07-0.05,0.1-0.12,0.1-0.21\n\t\t\tc0-0.06-0.02-0.11-0.05-0.15c-0.03-0.05-0.08-0.08-0.13-0.1c-0.06-0.02-0.16-0.03-0.31-0.03h-0.35V58.65z"}))])]);
	}
	
	Bnsf.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Bnsf;
	
	Bnsf.default = Bnsf;


/***/ }),

/***/ 884:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Centrica (props) {
	    return React.createElement("svg",props,React.createElement("path",{"className":"st0","style":{"fill":"#123A78"},"d":"M133.68,57.8c-2.88,1.84-4.07,5.19-2.64,7.35c1.44,2.16,4.88,2.32,7.83,0.48c2.88-1.92,4-5.19,2.64-7.35\n\tc-0.77-1.2-2.15-1.81-3.71-1.81C136.47,56.48,135.01,56.92,133.68,57.8 M97.08,61.4c-3.04,0.08-4.07,0.08-4.07,0.08l-1.6,7.19h-4.32\n\tc0,0,1.28,0.8,2,2.24c0.56,1.36,0.8,3.2,0.4,5.35c-0.72,4.07-1.6,7.99-1.6,7.99c-1.52,6.95,1.28,9.19,7.83,9.19\n\tc1.68,0,4.07-0.16,5.75-0.48l1.36-6.55c-1.52,0.24-2.79,0.32-3.67,0.32c-1.36,0-2.16-0.88-2.08-1.92c0-0.88,0.24-1.84,0.4-2.64\n\tl1.6-7.35h6.23l1.44-6.15h-6.55l1.68-7.43C101.88,61.24,100.44,61.32,97.08,61.4 M3.03,81.86c0,5.28,2.24,11.67,13.1,11.67\n\tc6.39,0,12.39-3.92,13.82-10.79h-9.19c-0.72,2.08-2.32,4.39-4.63,4.39c-2.8,0-3.52-2.08-3.28-5.51c0.16-1.76,1.2-7.99,5.43-7.99\n\tc3.04,0,3.28,3.12,3.28,4.32h9.19c0.08-6.95-4.95-10.71-12.15-10.71C9.02,67.23,3.03,74.75,3.03,81.86 M196.97,81.86 M31.8,82.42\n\tc0,6.47,3.83,11.11,12.78,11.11c9.19,0,12.31-6.47,12.95-8.07h-8.95c-0.64,1.28-1.6,2.16-3.6,2.16c-1.76,0-2.72-0.88-3.2-1.76\n\tc-0.48-0.96-0.72-2.08-0.64-3.44h17.34c0.32-1.2,0.48-2.56,0.48-4.16c0-7.35-5.43-10.71-11.91-10.71\n\tC40.03,67.55,31.8,71.95,31.8,82.42 M46.74,73.23c2.64,0,3.92,1.52,3.44,4.4h-8.23C42.58,75.15,44.26,73.23,46.74,73.23\n\t M166.68,83.45c0,4.4,1.76,10.07,8.87,10.07c3.2,0,6.4-1.68,7.75-3.52v0.08c0,0.96,0.08,2.08,0.48,2.88h9.27\n\tc-0.48-1.28-0.48-3.44,0.08-5.99c0.48-2.16,3.84-18.3,3.84-18.3h-9.27l-0.72,3.12c-1.12-2.24-3.52-3.76-7.19-3.76\n\tC171.24,68.03,166.68,76.34,166.68,83.45 M176.43,82.74c0-3.83,2.16-8.39,5.44-8.39c2.72,0,3.68,1.84,3.68,4.32\n\tc0,5.12-2.48,8.31-5.52,8.31C177.87,86.97,176.43,85.77,176.43,82.74 M138,82.34c0.08,5.19,2.48,11.18,13.18,11.18\n\tc6.31,0,12.31-3.52,13.83-10.39h-9.19c-0.72,2.08-2.32,4-4.72,4c-2.64,0-3.43-1.68-3.19-5.12c0.08-1.84,1.12-7.68,5.43-7.68\n\tc3.04,0,3.27,2.88,3.2,4h9.19c0.08-6.95-4.88-10.31-12.15-10.31C144.07,68.03,138,75.14,138,82.34 M71.43,72.11l0.96-3.44h-8.95\n\tl-5.03,24.29h9.27l2.72-12.87c0.56-2.56,1.52-4.63,4.47-4.63c1.52,0,2.64,0.8,2.64,2.32c0,0.96-0.48,2.64-0.72,4.07l-2.4,11.11h9.11\n\tl2.96-13.75c0.4-1.76,0.64-3.52,0.64-4.64c0-5.03-4-6.55-7.19-6.55C75.91,68.03,73.35,69.95,71.43,72.11 M117.06,72.91v-0.08\n\tl0.96-4.15h-8.95l-5.03,24.29h9.27l2.16-10.15c0.96-4.48,2.88-6.23,5.83-6.23c1.44,0,2.32,0.08,3.84,0.64l1.76-8.31\n\tc-0.72-0.32-1.52-0.4-2.64-0.4C121.29,68.51,118.5,70.59,117.06,72.91 M129.28,68.67l-5.03,24.29h9.27l5.03-24.29H129.28z"}));
	}
	
	Centrica.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Centrica;
	
	Centrica.default = Centrica;


/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Dupont (props) {
	    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"className":"st0","style":{"fillRule":"evenodd","clipRule":"evenodd","fill":"#E4001C"},"d":"M113.22,49.02c2.78-0.37,5.66-0.16,8.35,0.67c2.13,0.64,3.99,2.25,4.71,4.39c0.62,1.67,0.71,3.47,0.72,5.23\n\t\tc-0.01,10.56,0.01,21.12-0.01,31.68c-0.03,2.66-0.51,5.59-2.51,7.52c-2.12,2.07-5.24,2.51-8.07,2.64c-2.83,0.09-6-0.27-8.09-2.38\n\t\tc-1.85-1.9-2.32-4.67-2.34-7.22c-0.01-11.02-0.01-22.05-0.01-33.07c-0.01-2.25,0.35-4.63,1.75-6.46\n\t\tC109.01,50.26,111.12,49.32,113.22,49.02L113.22,49.02z M114.87,56.18L114.87,56.18c-1.23,0.33-1.64,1.71-1.61,2.85\n\t\tc-0.02,10.55,0,21.11-0.01,31.66c0.01,1.02,0.1,2.28,1.09,2.85c1.2,0.62,2.69,0.55,3.94,0.13c1.13-0.36,1.52-1.64,1.46-2.72\n\t\tc0-10.65,0.01-21.29,0-31.94c0.01-1-0.27-2.18-1.27-2.63C117.36,55.89,116.04,55.86,114.87,56.18z","key":0}),React.createElement("path",{"className":"st0","style":{"fillRule":"evenodd","clipRule":"evenodd","fill":"#E4001C"},"d":"M80.9,49.55c3.38-0.18,6.77-0.37,10.15-0.39c2.73,0.02,5.66,0.5,7.77,2.36c1.88,1.66,2.59,4.24,2.62,6.67\n\t\tc0.02,5.15,0,10.3,0.01,15.44c0,2.19-0.35,4.49-1.62,6.33c-1.03,1.5-2.68,2.48-4.41,2.95c-2.39,0.69-4.9,0.56-7.36,0.58\n\t\tc0,5.76,0,11.51,0,17.27c-2.39-0.07-4.77-0.18-7.16-0.31C80.89,83.48,80.89,66.51,80.9,49.55L80.9,49.55z M88.05,56.33L88.05,56.33\n\t\tc0.01,6.68,0,13.37,0,20.05c1.6-0.07,3.3,0.25,4.81-0.41c1.07-0.47,1.36-1.74,1.35-2.8c0.02-4.35,0-8.7,0.01-13.04\n\t\tc0-1.18-0.01-2.67-1.18-3.34C91.51,55.98,89.71,56.32,88.05,56.33z","key":1}),React.createElement("path",{"className":"st0","style":{"fillRule":"evenodd","clipRule":"evenodd","fill":"#E4001C"},"d":"M68.16,50.48c2.38-0.23,4.77-0.42,7.16-0.59c0,13.42,0,26.83,0,40.25c0.01,2.06-0.31,4.21-1.41,5.99\n\t\tc-1.04,1.75-2.9,2.93-4.88,3.32c-2.35,0.47-4.76,0.13-7.07-0.37c-2.04-0.48-4.14-1.31-5.44-3.03c-1.27-1.68-1.55-3.87-1.55-5.91\n\t\tc-0.01-12.69,0-25.39,0-38.08c2.29-0.34,4.58-0.62,6.87-0.92c0,12.36,0.01,24.71,0,37.07c0.02,1.05-0.06,2.19,0.48,3.14\n\t\tc0.53,0.89,1.61,1.19,2.58,1.31c0.92,0.12,2.05,0.1,2.68-0.7c0.57-0.75,0.58-1.74,0.59-2.63C68.15,76.38,68.16,63.43,68.16,50.48z","key":2}),React.createElement("path",{"className":"st0","style":{"fillRule":"evenodd","clipRule":"evenodd","fill":"#E4001C"},"d":"M132.12,50.57c2.27,0.22,4.53,0.47,6.8,0.76c2.63,8.59,5.27,17.19,7.9,25.78c-0.15-8.24-0.33-16.48-0.48-24.72\n\t\tc2.21,0.35,4.42,0.74,6.62,1.15c-0.01,14.3,0,28.61-0.01,42.91c-2.04,0.38-4.08,0.72-6.12,1.05c-2.8-9.17-5.57-18.36-8.37-27.53\n\t\tc0.17,9.55,0.37,19.11,0.56,28.66c-2.3,0.28-4.59,0.55-6.9,0.78C132.13,83.13,132.13,66.85,132.12,50.57z","key":3}),React.createElement("path",{"className":"st0","style":{"fillRule":"evenodd","clipRule":"evenodd","fill":"#E4001C"},"d":"M156.47,54.24c5.7,1.17,11.35,2.63,16.85,4.52c-0.01,2.09-0.01,4.18,0,6.28c-1.74-0.48-3.48-0.96-5.22-1.41\n\t\tc-0.01,9.74,0,19.48,0,29.23c-2.13,0.61-4.28,1.16-6.42,1.7c0.01-10.82,0.01-21.64,0-32.47c-1.73-0.37-3.47-0.72-5.21-1.04\n\t\tC156.47,58.78,156.47,56.51,156.47,54.24z","key":4}),React.createElement("path",{"className":"st0","style":{"fillRule":"evenodd","clipRule":"evenodd","fill":"#E4001C"},"d":"M30.24,57.62c3.41-1.02,6.84-2.11,10.4-2.45c2.41-0.21,5.05,0.25,6.88,1.93c1.74,1.59,2.39,4.02,2.39,6.31\n\t\tc0.01,7.72,0,15.44,0,23.15c0.01,2.35-0.69,4.86-2.53,6.45c-1.99,1.72-4.81,2.07-7.33,1.73c-3.34-0.46-6.59-1.42-9.81-2.38\n\t\tC30.25,80.78,30.25,69.2,30.24,57.62L30.24,57.62z M36.53,62.45L36.53,62.45c0,8.35,0,16.71,0,25.06c1.68,0.37,3.41,1.01,5.15,0.68\n\t\tc1.14-0.21,1.8-1.37,1.74-2.46c0.03-7.07,0.01-14.13,0.01-21.2c0.06-1.09-0.38-2.38-1.55-2.68C40.09,61.39,38.28,62.1,36.53,62.45z\n\t\t","key":5}),React.createElement("path",{"className":"st0","style":{"fillRule":"evenodd","clipRule":"evenodd","fill":"#E4001C"},"d":"M11.57,66.27c2.29-1.77,4.84-3.18,7.45-4.42c-0.01,8.75,0,17.49,0,26.24c-3.8-1.85-7.6-4.01-10.4-7.25\n\t\tc-1.67-1.96-2.81-4.59-2.31-7.21C6.89,70.54,9.18,68.14,11.57,66.27z","key":6}),React.createElement("path",{"className":"st0","style":{"fillRule":"evenodd","clipRule":"evenodd","fill":"#E4001C"},"d":"M180.99,61.84c3.55,1.69,7.04,3.69,9.8,6.53c1.63,1.72,2.96,3.9,3.01,6.33c0.1,2.55-1.25,4.91-2.94,6.73\n\t\tc-2.76,2.91-6.29,4.93-9.87,6.66C180.98,79.34,180.99,70.6,180.99,61.84z","key":7})]));
	}
	
	Dupont.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Dupont;
	
	Dupont.default = Dupont;


/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Ets (props) {
	    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"style":{"fill":"#004B8D"},"d":"M149.02,95.48l-0.17,0.13c-12.5,9.53-25.09,15.32-40.84,18.76c-24.13,5.27-46.6,2.13-58.64-8.2\n\t\tc-5.42-4.64-8.45-10.45-9.02-17.27c-1.46-17.55,11.69-35.69,35.2-48.54l0.23-0.13l-0.27-0.66l-0.23,0.09\n\t\tC47.66,50.78,28.28,71.5,29.76,91.2c0.6,8.04,4.2,15.17,10.42,20.58c12.82,11.16,35.52,14.63,60.73,9.25\n\t\tc20.31-4.32,36.47-13.39,48.41-24.77l0.23-0.23L149.02,95.48z","key":0}),React.createElement("path",{"style":{"fill":"#892629"},"d":"M167.35,47.85c-4.8-10.69-15.33-17.97-29.64-20.46c-23.14-4.06-50.91,5.9-64.84,22.02l-0.18,0.21l0.43,0.6\n\t\tl0.22-0.18c9.25-7.7,22.93-13.55,36.61-15.65c20.32-3.1,37.37,2,45.59,13.65c8,11.32,5.72,33.16-4.76,45.8l-0.19,0.24l0.52,0.61\n\t\tl0.21-0.19C167.29,79.32,174.98,64.92,167.35,47.85z","key":1}),React.createElement("path",{"style":{"fill":"#004B8D"},"d":"M82.05,78.64H66.73l-1.64,8.79h17.13l-1.36,7.21h-25.7l7.21-38.24h24.62l-1.42,7.21h-16l-1.47,7.83h15.32\n\t\tL82.05,78.64z","key":2}),React.createElement("path",{"style":{"fill":"#004B8D"},"d":"M97.62,63.67h-9.38l1.42-7.26h32.52c-1.95,0.4-3.67,1.59-5.3,3.22c-1.85,1.85-2.2,4.05-2.2,4.05h-8.55\n\t\tl-5.79,30.98h-8.51L97.62,63.67z","key":3}),React.createElement("path",{"style":{"fill":"#004B8D"},"d":"M114.96,85.29c2.61,1.53,6.24,2.78,10.27,2.78c3.12,0,6.24-1.31,6.24-4.31c0-2.04-1.76-3.4-5.62-5.11\n\t\tc-4.43-1.92-9.02-4.93-9.02-10.43c0-7.89,7.32-12.48,15.88-12.48c5.22,0,8.28,1.13,10.16,2.1l-2.78,7.03\n\t\tc-1.31-0.68-4.48-1.98-8.11-1.87c-4.08,0-6.07,1.87-6.07,3.69c0,2.39,2.89,3.75,6.18,5.28c5.16,2.27,8.57,5.33,8.57,10.38\n\t\tc0,8.73-7.66,12.99-16.56,12.99c-5.79-0.11-10.04-1.59-12.2-3.17L114.96,85.29z","key":4}),React.createElement("g",{"key":5},React.createElement("path",{"style":{"fill":"#004B8D"},"d":"M165.32,103.64c-1.03,1.04-2.27,1.55-3.72,1.55c-1.45,0-2.69-0.51-3.71-1.55c-1.02-1.02-1.52-2.26-1.52-3.72\n\t\t\tc0-1.45,0.51-2.69,1.54-3.71c1.02-1.02,2.25-1.53,3.7-1.53c1.46,0,2.7,0.51,3.72,1.53c1.03,1.02,1.54,2.26,1.54,3.71\n\t\t\tC166.86,101.37,166.34,102.61,165.32,103.64z M158.41,96.72c-0.88,0.89-1.32,1.95-1.32,3.2c0,1.26,0.44,2.34,1.31,3.22\n\t\t\tc0.88,0.88,1.95,1.33,3.2,1.33c1.26,0,2.32-0.44,3.2-1.33c0.88-0.88,1.32-1.96,1.32-3.22c0-1.25-0.44-2.31-1.32-3.2\n\t\t\tc-0.88-0.88-1.95-1.33-3.2-1.33C160.35,95.39,159.29,95.84,158.41,96.72z M161.5,97.01c0.72,0,1.24,0.08,1.57,0.21\n\t\t\tc0.59,0.25,0.89,0.74,0.89,1.46c0,0.52-0.19,0.9-0.56,1.14c-0.2,0.13-0.48,0.22-0.83,0.28c0.45,0.07,0.78,0.26,0.99,0.56\n\t\t\tc0.21,0.31,0.31,0.61,0.31,0.9v0.42c0,0.13,0,0.28,0.02,0.42c0.01,0.15,0.03,0.26,0.05,0.31l0.04,0.07h-0.95\n\t\t\tc-0.01-0.02-0.01-0.04-0.02-0.06c0-0.02-0.01-0.04-0.01-0.06l-0.02-0.19v-0.46c0-0.66-0.18-1.1-0.55-1.32\n\t\t\tc-0.21-0.12-0.59-0.18-1.13-0.18h-0.8v2.27h-1.01v-5.77H161.5z M162.6,97.93c-0.25-0.15-0.67-0.22-1.23-0.22h-0.87v2.09h0.92\n\t\t\tc0.43,0,0.75-0.05,0.97-0.13c0.4-0.15,0.6-0.46,0.6-0.9C162.98,98.35,162.85,98.07,162.6,97.93z"}))]));
	}
	
	Ets.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Ets;
	
	Ets.default = Ets;


/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Firmenich (props) {
	    return React.createElement("svg",props,React.createElement("path",{"style":{"fill":"#174A7D"},"className":"st0","d":"M48.9,77.83v12.69h4.3V77.83c0-2.59,2.12-4.71,4.73-4.71c1.67,0,3.14,0.87,3.98,2.17\n\tc0.4-1.52,1.15-2.9,2.15-4.05c-1.61-1.49-3.77-2.4-6.14-2.4C52.95,68.85,48.9,72.88,48.9,77.83z M24.69,53.05h41.18v-4.28H1.76v4.28\n\th18.63v16.03H9.55v4.28h10.84v27.88h4.3V73.36h14.63v17.16h4.3V69.08H24.69V53.05z M87.74,68.85c-2.75,0-5.22,1.23-6.88,3.17\n\tc-1.66-1.94-4.13-3.17-6.88-3.17c-4.98,0-9.03,4.03-9.03,8.98v12.69h4.3V77.83c0-2.59,2.12-4.71,4.73-4.71\n\tc2.61,0,4.73,2.11,4.73,4.71v12.69H83V77.83c0-2.59,2.12-4.71,4.73-4.71c2.61,0,4.73,2.11,4.73,4.71v12.69h4.3V77.83\n\tC96.77,72.88,92.72,68.85,87.74,68.85z M39.32,63.72h4.3v-5.36h-4.3V63.72z M167.73,86.79c-3.89,0-7.06-3.15-7.06-7.02\n\tc0-3.87,3.17-7.02,7.06-7.02c2.37,0,4.58,1.18,5.89,3.15l3.41-2.24c-2.07-3.11-5.55-4.97-9.3-4.97c-6.15,0-11.15,4.97-11.15,11.09\n\tc0,6.11,5,11.09,11.15,11.09c3.84,0,7.37-1.93,9.43-5.16l-3.45-2.17C172.4,85.57,170.17,86.79,167.73,86.79z M148.39,63.72h4.3\n\tv-5.36h-4.3V63.72z M189.21,68.85c-1.73,0-3.35,0.49-4.73,1.34V48.77h-4.3v41.75h4.3V77.83c0-2.59,2.12-4.71,4.73-4.71\n\tc2.61,0,4.73,2.11,4.73,4.71v23.4h4.3v-23.4C198.24,72.88,194.19,68.85,189.21,68.85z M148.39,90.52h4.3V69.08h-4.3V90.52z\n\t M134.96,68.85c-4.98,0-9.03,4.03-9.03,8.98v12.69h4.3V77.83c0-2.59,2.12-4.71,4.73-4.71c2.61,0,4.73,2.11,4.73,4.71v12.69h4.3\n\tV77.83C144,72.88,139.94,68.85,134.96,68.85z M122.2,80.03v-0.26c0-6.02-4.93-10.92-10.99-10.92c-6.06,0-10.98,4.9-10.98,10.92\n\tc0,6.02,4.93,10.92,10.98,10.92c3.49,0,6.68-1.59,8.77-4.37l-3.32-1.92c-1.31,1.62-3.3,2.55-5.46,2.55c-3.17,0-5.93-2.08-6.88-5.17\n\tl-0.03-0.07c0,0,17.91,0,17.93,0C122.21,81.68,122.2,81.4,122.2,80.03z M104.28,77.82l0.08-0.11c0.91-3.06,3.66-5.12,6.85-5.12\n\tc3.17,0,5.93,2.08,6.88,5.17c0-0.01,0.01,0.04,0.03,0.07H104.28z"}));
	}
	
	Firmenich.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Firmenich;
	
	Firmenich.default = Firmenich;


/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Ieee (props) {
	    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"style":{"fill":"#006CA3"},"d":"M71.12,94.71v-38.3h10.61v38.3H71.12z","key":0}),React.createElement("path",{"style":{"fill":"#006CA3"},"d":"M87.3,94.71v-38.3h29.18v7.43H97.91v7.9h17.08v7.43H97.91v8.12h18.57v7.43H87.3z","key":1}),React.createElement("path",{"style":{"fill":"#006CA3"},"d":"M122.42,94.71v-38.3h29.18v7.43h-18.57v7.9h17.08v7.43h-17.08v8.12h18.57v7.43H122.42z","key":2}),React.createElement("path",{"style":{"fill":"#006CA3"},"d":"M157.54,94.71v-38.3h29.18v7.43h-18.57v7.9h17.08v7.43h-17.08v8.12h18.57v7.43H157.54z","key":3}),React.createElement("g",{"key":4},[React.createElement("path",{"style":{"fill":"#006CA3"},"d":"M47.61,95.86h-0.29v0.46h0.36c0.18,0,0.29-0.04,0.29-0.25C47.97,95.88,47.76,95.86,47.61,95.86z","key":0}),React.createElement("path",{"style":{"fill":"#006CA3"},"d":"M47.62,95.13c-0.71,0-1.27,0.55-1.27,1.36c0,0.82,0.57,1.37,1.27,1.36v0c0.69,0,1.27-0.55,1.27-1.37\n\t\t\tC48.89,95.68,48.3,95.13,47.62,95.13z M47.95,97.45l-0.44-0.8h-0.19v0.8h-0.41v-1.91h0.71c0.49,0,0.79,0.14,0.79,0.58\n\t\t\tc0,0.35-0.21,0.48-0.46,0.5l0.49,0.84H47.95z","key":1}),React.createElement("path",{"style":{"fill":"#006CA3"},"d":"M63.52,73.45l-0.14-0.02c-4.34-2.95-8.38-6.29-12.19-10.07l-4.21-4.4c-1.7-1.89-3.36-3.98-4.94-5.98\n\t\t\tl-1.92-2.71c-0.24-0.14-0.53-0.38-0.79-0.45c-0.56-0.25-1.18,0.05-1.63,0.4l-3.47,4.51c-5.56,6.89-12.14,13.32-19.32,18.24\n\t\t\tc-0.56,0.45-1.41,0.88-1.59,1.61c-0.19,0.66,0.15,1.2,0.56,1.61c5.75,3.96,11.25,8.66,16.14,14.02c0.87,0.92,1.57,1.82,2.42,2.68\n\t\t\tc1.43,1.9,3.11,3.82,4.43,5.86c0.41,0.43,0.48,1.14,1.13,1.35c0.51,0.18,1.13,0.29,1.61,0l0.48-0.48\n\t\t\tc5.95-8.43,13.49-16,21.92-22.11c0.85-0.75,2.46-1.03,2.48-2.43C64.45,74.43,64.07,73.8,63.52,73.45z M57.76,75.7\n\t\t\tc-0.96,2.4-2.91,4.31-4.62,6.41c-3.69,3.97-7.58,7.82-11.94,10.88c-0.88,0.62-2.07,1.2-3.13,0.71c-3.21-1.68-5.91-4.43-8.72-6.93\n\t\t\tc-3.26-3.02-6.52-6.53-8.99-10.21c-0.36-0.52-0.47-1.15-0.46-1.83c0.32-1.27,1.19-2.32,2.01-3.39c2.91-3.71,6.49-7.24,10.1-10.46\n\t\t\tc0.08-0.08,0.24-0.26,0.36-0.34c1.55-1.34,3.09-2.53,4.71-3.69c1.69-1.32,3.82-0.22,5.24,0.99c1.49,1.14,3.04,2.43,4.41,3.75\n\t\t\tl0.25,0.14c3.77,3.5,7.28,7.39,10.15,11.51C57.61,73.94,58.02,74.75,57.76,75.7z","key":2}),React.createElement("path",{"style":{"fill":"#006CA3"},"d":"M42.33,59.28c-1.34-0.94-2.89-2.59-4.62-1.41c-5.37,3.71-10.54,8.74-14.7,13.88\n\t\t\tc-0.85,1.25-2.33,2.43-1.66,4.09c0.48,1.22,1.56,2.1,2.26,3.19c4.08,4.9,8.9,9.47,13.93,13.15c2.21,1.41,3.78-0.87,5.5-1.92\n\t\t\tc3.51-2.77,6.77-6.15,9.85-9.43v-0.08c1.23-1.49,2.54-2.96,3.5-4.57c0.42-0.79,0.21-1.87-0.26-2.56\n\t\t\tC52.4,68.23,47.51,63.46,42.33,59.28z M38.34,62.76l0.47-1.5h0.06c0.96,2.76,1.96,5.51,3,8.24l-2.07,0.04l-0.05,0.25l0.31,7.39\n\t\t\tv0.12c-0.76,0.13-1.7,0.09-2.46,0.02l-0.06-0.08l0.34-7.62v-0.06c-0.58-0.06-1.3,0-1.89-0.06L38.34,62.76z M37.11,87.33\n\t\t\tc0.2-2.72,0.23-5.22,0.38-7.92c0.95,0.09,1.77,0.06,2.64,0.02l0.06,0.36l0.34,7.56C39.39,87.51,38.18,87.42,37.11,87.33z\n\t\t\t M45.77,77.9c-4.94,1.54-11.14,1.47-15.82-0.59c-0.85-0.41-1.92-1.05-2.2-2.03c-0.21-1.81,1.73-2.81,3.04-3.47\n\t\t\tc0.78-0.34,1.56-0.72,2.42-0.76c0.8,0.59,1.63,1.06,2.46,1.59c-1.6,0.42-3.51,0.79-4.25,2.54c0.13,1.33,1.63,1.75,2.68,2.08\n\t\t\tc3.77,1,7.85,0.87,11.47-0.45c0.68-0.4,1.76-0.88,1.67-1.87c-0.12-1.06-1.33-1.53-2.17-1.86c-0.52,0.07-1.01,0.19-1.49,0.34\n\t\t\tc-0.26-0.73-0.48-1.47-0.79-2.17c1.6,0.42,3.2,0.86,4.85,1.15v0.04c-0.34,0.04-0.72,0.15-1.05,0.28v0.06\n\t\t\tc0.94,0.47,2.24,1.25,2.26,2.48C48.63,76.75,47,77.43,45.77,77.9z","key":3}),React.createElement("path",{"style":{"fill":"#006CA3"},"d":"M48.41,96.12c0-0.44-0.29-0.58-0.79-0.58h-0.71v1.91h0.41v-0.8h0.19l0.44,0.8h0.48l-0.49-0.84\n\t\t\tC48.2,96.6,48.41,96.47,48.41,96.12z M47.68,96.32h-0.36v-0.46h0.29c0.16,0,0.37,0.01,0.37,0.21\n\t\t\tC47.97,96.29,47.87,96.32,47.68,96.32z","key":4}),React.createElement("path",{"style":{"fill":"#006CA3"},"d":"M47.62,94.72c-0.95,0-1.79,0.65-1.79,1.78s0.84,1.78,1.79,1.78c0.94,0,1.78-0.65,1.78-1.78\n\t\t\tS48.56,94.72,47.62,94.72z M47.62,97.87L47.62,97.87c-0.71,0-1.27-0.55-1.27-1.37c0-0.82,0.57-1.36,1.27-1.36\n\t\t\tc0.69,0,1.27,0.55,1.27,1.36C48.89,97.32,48.3,97.87,47.62,97.87z","key":5})])]));
	}
	
	Ieee.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Ieee;
	
	Ieee.default = Ieee;


/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function JohnsonJohnson (props) {
	    return React.createElement("svg",props,React.createElement("path",{"style":{"fill":"#EC1C24"},"className":"st0","d":"M8.58,58.41C7.65,60.76,6.03,64.4,6.12,69.1c0.04,1.91,0.47,4.46,0.9,7.04c-0.39,0.49-0.79,1.02-1.18,1.56\n\tc-1.86-2.28-2.96-4.81-3-9.14c-0.05-5.79,3.31-9.97,5.39-10.44C8.54,58.04,8.73,58.04,8.58,58.41z M74.65,71.02\n\tc-1.37,0.21-2.01-0.44-2.06-1c-0.04-0.39,0.31-0.59,0.7-0.5C73.86,69.66,74.34,70.21,74.65,71.02z M60.27,75.53\n\tc0.21,0.63,0.34,1.21,0.34,1.72c0,0.76-0.4,1.17-0.72,1.09c-0.29-0.07-0.52-0.39-0.45-1.03C59.49,76.73,59.86,76.09,60.27,75.53z\n\t M7.32,78c0.31,1.94,0.55,3.8,0.55,5.3c0,2.93-0.72,5.79-2.05,7.02c-1.05,0.99-2.5,0.39-2.53-1.62C3.19,84.37,5.28,80.66,7.32,78z\n\t M101.8,76.01c-1.02-1.26-1.89-1.98-2.9-2.07c-0.73-0.07-1.14,0.18-1.21,0.62c-0.12,0.83,0.86,1.45,2.19,1.53\n\tC100.53,76.14,101.17,76.09,101.8,76.01z M9.94,75C9.95,74.99,9.94,75,9.94,75c1.34-1.41,3.39-3.33,3.9-3.51\n\tc-1.12,3.68,0.53,8.24,4.75,8.28c3.15,0.03,5.57-2.58,5.57-6.18c0-0.45-0.03-0.89-0.09-1.3c1.18-0.22,2.23-0.51,3.22-1.12\n\tc0,2.91,0,6,0,7.28c0,0.94,0.68,1.31,1.29,1.31c0.81,0,1.24-0.61,1.56-1.27c1.21-2.51,3.11-5.84,3.86-7.14\n\tc0.44-0.77,0.63-0.69,0.63,0.1c0,1.19,0,4.46,0,6.19c0,1.68,0.87,2.12,1.62,2.12c0.74-0.01,1.21-0.42,1.66-1.08\n\tc1.88-2.73,3.89-5.85,4.7-7.23c0.33-0.56,0.67-0.71,0.67,0.11c0,1.45,0,4.72,0,6.48c0,1.15,0.39,1.72,1.3,1.72\n\tc0.82,0,1.37-0.61,1.69-1.27c1.2-2.51,2.99-5.8,3.75-7.1c0.44-0.77,0.64-0.69,0.64,0.1c0,1.19,0,4.42,0,6.15\n\tc0,1.68,0.87,2.11,1.62,2.12c1.01,0.01,1.68-0.75,2.33-1.58c1.2-1.53,2.94-4.35,3.99-6.12c0.35,0.58,0.75,1.28,1.1,2.04\n\tc-1.08,1.29-1.77,2.55-1.76,3.52c0,0.97,0.64,2.15,1.95,2.15c1.32,0,3.23-1.31,3.16-3.83c-0.02-0.87-0.25-1.76-0.56-2.62\n\tc1.5-1.47,3.25-2.88,4.58-3.21c-0.6,0.83-1.17,1.97-1.14,4.05c0.03,1.83,1.17,5.61,5.12,5.61c3.21,0,5.58-2.56,5.58-6.16\n\tc0-0.59-0.06-1.15-0.15-1.66c0.77-0.33,1.41-0.81,1.93-1.23c1.02-0.82,1.47-0.58,1.47,0.25c0,0,0,5.32,0,7.09\n\tc0,1.15,0.4,1.72,1.3,1.72c0.82,0,1.4-0.61,1.72-1.27c1.2-2.51,2.95-5.83,3.71-7.14c0.44-0.77,0.64-0.69,0.64,0.1\n\tc0,1.19,0,3.9,0,5.62c0,2.37,1.58,2.68,2.33,2.68c1.65,0,2.49-1.61,3.95-4.08c0.42-0.71-0.48-1.08-0.78-0.76\n\tc-0.68,0.74-1.02,1.19-1.7,1.83c-0.36,0.33-0.69,0.05-0.69-0.27c0-0.66,0-5.23,0-6.34c0-1.7-0.75-2.41-1.72-2.41\n\tc-0.79,0-1.46,0.34-2.13,1.34c-1.22,1.82-2.57,4.48-3.26,5.79c-0.21,0.4-0.31,0.36-0.31-0.1v-4.62c0-1.34-0.34-2.41-1.77-2.41\n\tc-1.49,0-2.25,1.02-3.32,1.79c-0.81,0.58-1.27,0.88-1.75,1.08c-0.74-1.81-2.1-2.78-3.18-2.75c-1.13,0.03-1.93,0.76-1.95,1.91\n\tc-0.03,1.26,1,2.95,4.04,2.59c0.06,0.39,0.09,0.83,0.08,1.29c-0.03,1.78-1.04,3.46-3.03,3.52c-2.01,0.06-3.2-1.93-3.22-4.18\n\tc-0.02-1.7,0.51-3.13,1.36-4.11c0.31-0.37,0.62-0.69,0.55-0.91c-0.07-0.18-0.24-0.23-0.44-0.22c-0.68,0.06-2.02,0.12-3.99,1.19\n\tc-1.5,0.8-3.03,1.91-4.36,3.08c-0.67-1.43-1.46-2.72-1.84-3.68c-0.17-0.41-0.26-0.89-0.54-0.88c-0.27,0.02-0.37,0.26-0.55,0.79\n\tc-0.66,1.89-4.2,7.51-4.89,8.32c-0.26,0.3-0.35,0.26-0.35-0.07c0-0.66,0-5.23,0-6.34c0-1.7-0.66-2.41-1.63-2.41\n\tc-0.79,0-1.46,0.34-2.13,1.34c-1.22,1.82-2.66,4.48-3.35,5.79c-0.21,0.4-0.32,0.36-0.32-0.1v-4.62c0-1.7-0.67-2.41-1.63-2.41\n\tc-0.79,0-1.55,0.32-2.17,1.34c-1.55,2.55-4.06,6.56-4.52,7.21c-0.18,0.26-0.35,0.27-0.35-0.06c0-0.66,0-4.97,0-6.08\n\tc0-1.7-0.67-2.41-1.63-2.41c-0.79,0-1.39,0.34-2.07,1.32c-1.21,1.82-2.71,4.48-3.4,5.78c-0.22,0.41-0.32,0.38-0.32-0.09\n\tc0-1.17,0-2.95,0-5.41c2.77-3.01,3.77-6.63,3.68-9.06c-0.08-1.96-0.88-3.05-2.19-3.05c-2.51,0-4.45,3.9-4.45,8.57\n\tc0,0.67,0,2.08,0,3.76c-1.16,0.73-2.24,1.1-3.57,1.33c-0.71-2.01-2.14-3.08-3.29-3.05c-1.12,0.04-1.92,0.76-1.94,1.91\n\tc-0.03,1.4,1.18,2.79,4.05,2.72c0.05,0.37,0.07,0.75,0.07,1.17c-0.02,1.78-1.04,3.48-3.03,3.54c-2.01,0.06-3.2-1.95-3.23-4.19\n\tc-0.01-1.71,0.51-3.12,1.37-4.1c0.3-0.37,0.62-0.69,0.54-0.91c-0.06-0.18-0.24-0.22-0.44-0.22c-1.4,0.06-4.42,1.84-8.07,5.49\n\tc-0.31-2.89-0.7-5.74-0.68-8.5c0.02-3.06,0.6-5.68,0.76-6.45c0.1-0.47,0.12-0.77,0.1-0.97c-0.02-0.29-0.16-0.44-0.54-0.45\n\tc-1.42-0.04-3.71,1.09-5.68,3.17C1.64,61.99-0.02,65.06,0,68.56C0.03,73.53,1.82,75.92,4.97,79c-1.92,3.06-3.47,6.72-3.44,9.98\n\tc0.02,2.37,0.54,4.16,2.29,4.16c2.62,0,6.19-5.11,6.34-13.11C10.19,78.34,10.1,76.66,9.94,75C9.95,74.99,9.94,75,9.94,75z\n\t M30.26,64.78c0-5.42,1.06-6.19,1.38-6.23c0.47-0.08,0.77,0.37,0.66,2.4c-0.12,2.39-0.91,4.95-2.03,6.47\n\tC30.26,66.72,30.26,65.42,30.26,64.78z M20.12,70.01c-0.04-0.39,0.32-0.59,0.7-0.51c0.57,0.14,1.04,0.69,1.36,1.49\n\tC20.65,71.1,20.18,70.57,20.12,70.01z M114.61,58.12c-2.09,0.47-5.44,4.65-5.39,10.44c0.03,4.34,1.13,6.86,2.99,9.14\n\tc0.38-0.54,0.78-1.08,1.18-1.56c-0.43-2.58-0.87-5.13-0.9-7.04c-0.09-4.7,1.53-8.33,2.46-10.69\n\tC115.1,58.04,114.91,58.04,114.61,58.12z M179.66,69.53c-0.37-0.1-0.73,0.11-0.69,0.5c0.05,0.56,0.69,1.21,2.06,1\n\tC180.71,70.21,180.23,69.66,179.66,69.53z M165.8,77.3c-0.06,0.64,0.16,0.97,0.46,1.03c0.31,0.07,0.72-0.33,0.72-1.09\n\tc0-0.51-0.13-1.09-0.34-1.72C166.23,76.09,165.87,76.73,165.8,77.3z M109.65,88.71c0.05,2.01,1.49,2.61,2.54,1.62\n\tc1.32-1.24,2.05-4.09,2.05-7.02c0-1.5-0.24-3.36-0.55-5.3C111.65,80.66,109.57,84.37,109.65,88.71z M136.63,67.42\n\tc1.11-1.51,1.92-4.08,2.04-6.47c0.1-2.03-0.18-2.47-0.65-2.4c-0.33,0.04-1.39,0.82-1.39,6.23\n\tC136.63,65.42,136.63,66.72,136.63,67.42z M128.56,70.99c-0.32-0.8-0.8-1.34-1.36-1.49c-0.38-0.08-0.73,0.12-0.7,0.51\n\tC126.55,70.57,127.02,71.1,128.56,70.99z M199.89,75.69c-1.46,2.47-2.29,4.08-3.94,4.08c-0.75,0-2.34-0.31-2.34-2.68\n\tc0-1.72,0-4.44,0-5.62c0-0.79-0.2-0.87-0.64-0.1c-0.75,1.3-2.51,4.62-3.71,7.14c-0.32,0.66-0.9,1.27-1.71,1.27\n\tc-0.92,0-1.32-0.57-1.32-1.72c0-1.77,0-7.09,0-7.09c0-0.83-0.44-1.07-1.46-0.25c-0.51,0.42-1.15,0.9-1.93,1.23\n\tc0.1,0.51,0.16,1.07,0.16,1.66c0,3.6-2.37,6.16-5.58,6.16c-3.95,0-5.1-3.78-5.13-5.61c-0.03-2.08,0.53-3.22,1.14-4.05\n\tc-1.33,0.33-3.09,1.74-4.58,3.21c0.32,0.87,0.54,1.75,0.56,2.62c0.06,2.52-1.85,3.83-3.16,3.83c-1.32,0-1.95-1.17-1.96-2.15\n\tc0-0.97,0.68-2.22,1.76-3.52c-0.35-0.76-0.75-1.46-1.1-2.04c-1.05,1.77-2.79,4.58-3.98,6.12c-0.65,0.83-1.32,1.59-2.34,1.58\n\tc-0.75-0.01-1.62-0.43-1.62-2.12c0-1.73,0-4.96,0-6.15c0-0.79-0.2-0.87-0.64-0.1c-0.75,1.29-2.55,4.58-3.74,7.1\n\tc-0.32,0.66-0.87,1.27-1.68,1.27c-0.91,0-1.31-0.57-1.31-1.72c0-1.77,0-5.04,0-6.48c0-0.82-0.34-0.67-0.67-0.11\n\tc-0.81,1.39-2.81,4.5-4.7,7.23c-0.46,0.66-0.93,1.07-1.66,1.08c-0.76,0-1.63-0.43-1.63-2.12c0-1.73,0-5,0-6.19\n\tc0-0.79-0.19-0.87-0.63-0.1c-0.75,1.3-2.65,4.63-3.86,7.14c-0.31,0.66-0.73,1.27-1.56,1.27c-0.6,0-1.28-0.37-1.28-1.31\n\tc0-1.28,0-4.37,0-7.28c-1,0.6-2.05,0.9-3.23,1.12c0.06,0.41,0.09,0.84,0.09,1.3c0,3.6-2.42,6.21-5.57,6.18\n\tc-4.23-0.04-5.87-4.6-4.76-8.28c-0.51,0.19-2.55,2.11-3.89,3.51l0,0c0.15,1.66,0.25,3.34,0.22,5.03c-0.15,8-3.72,13.11-6.34,13.11\n\tc-1.75,0-2.28-1.79-2.3-4.16c-0.03-3.26,1.52-6.93,3.44-9.98c-0.91-0.89-1.72-1.73-2.39-2.59c-0.73-0.21-1.44-0.21-1.65-0.21\n\tc-1,0.01-2.14,0.25-3.26,0.53c-0.1,1.44-0.34,3.2-1.15,3.03c-0.54-0.11-0.38-1.13-0.48-2.64c-0.68,0.16-1.32,0.26-1.89,0.28\n\tc-2.62,0.06-5.68-0.77-5.68-2.84c0-0.98,0.66-1.97,2.84-1.97c1.85,0,3.26,0.55,4.5,1.81c-0.24-1.71-0.96-2.46-1.2-2.82\n\tc-0.2-0.31-0.16-0.4,0.07-0.53c0.21-0.12,1.1-0.61,1.49-0.71c0.16-0.05,0.42-0.03,0.54,0.09c0.61,0.61,1.06,2.7,1.01,5.13\n\tc0.87-0.18,2.46-0.56,4.01-0.34c-1.11-1.78-1.71-3.79-1.74-6.66c-0.01-3.5,1.64-6.56,3.72-8.53c1.98-2.08,4.27-3.2,5.69-3.17\n\tc0.38,0.01,0.52,0.16,0.54,0.45c0.02,0.2-0.01,0.5-0.11,0.97c-0.16,0.77-0.73,3.39-0.76,6.45c-0.02,2.76,0.37,5.6,0.69,8.5\n\tc3.64-3.65,6.67-5.44,8.07-5.49c0.2,0,0.38,0.04,0.44,0.22c0.08,0.22-0.24,0.54-0.55,0.91c-0.85,0.98-1.38,2.39-1.36,4.1\n\tc0.02,2.25,1.21,4.25,3.22,4.19c1.98-0.06,3-1.76,3.03-3.54c0.01-0.41-0.02-0.8-0.06-1.17c-2.87,0.07-4.09-1.32-4.05-2.72\n\tc0.02-1.15,0.82-1.88,1.94-1.91c1.15-0.03,2.59,1.05,3.3,3.05c1.32-0.23,2.41-0.6,3.57-1.33c0-1.67,0-3.09,0-3.76\n\tc0-4.67,1.94-8.57,4.45-8.57c1.32,0,2.11,1.09,2.19,3.05c0.09,2.42-0.9,6.05-3.68,9.06c0,2.46,0,4.24,0,5.41\n\tc0,0.46,0.11,0.5,0.32,0.09c0.69-1.3,2.18-3.96,3.4-5.78c0.66-0.98,1.27-1.32,2.06-1.32c0.97,0,1.63,0.71,1.63,2.41\n\tc0,1.11,0,5.43,0,6.08c0,0.33,0.17,0.32,0.35,0.06c0.45-0.65,2.98-4.66,4.53-7.21c0.62-1.02,1.37-1.34,2.16-1.34\n\tc0.96,0,1.63,0.71,1.63,2.41v4.62c0,0.46,0.1,0.5,0.31,0.1c0.7-1.31,2.14-3.97,3.36-5.79c0.67-0.99,1.34-1.34,2.13-1.34\n\tc0.96,0,1.62,0.71,1.62,2.41c0,1.11,0,5.68,0,6.34c0,0.32,0.1,0.36,0.36,0.07c0.68-0.81,4.24-6.43,4.89-8.32\n\tc0.18-0.53,0.28-0.77,0.56-0.79c0.28-0.01,0.36,0.47,0.54,0.88c0.39,0.96,1.18,2.26,1.84,3.68c1.32-1.18,2.86-2.28,4.35-3.08\n\tc1.97-1.07,3.32-1.13,4-1.19c0.19-0.01,0.37,0.04,0.44,0.22c0.06,0.22-0.24,0.54-0.54,0.91c-0.87,0.98-1.39,2.42-1.38,4.11\n\tc0.03,2.25,1.22,4.24,3.22,4.18c1.99-0.06,3-1.74,3.03-3.52c0.02-0.46-0.02-0.9-0.08-1.29c-3.04,0.36-4.06-1.33-4.03-2.59\n\tc0.01-1.15,0.82-1.88,1.95-1.91c1.08-0.03,2.44,0.95,3.18,2.75c0.48-0.2,0.94-0.5,1.75-1.08c1.07-0.77,1.83-1.79,3.32-1.79\n\tc1.44,0,1.78,1.07,1.78,2.41v4.62c0,0.46,0.1,0.5,0.31,0.1c0.69-1.31,2.05-3.97,3.26-5.79c0.67-0.99,1.35-1.34,2.13-1.34\n\tc0.97,0,1.72,0.71,1.72,2.41c0,1.11,0,5.68,0,6.34c0,0.32,0.33,0.6,0.69,0.27c0.68-0.64,1.03-1.09,1.7-1.83\n\tC199.41,74.6,200.31,74.97,199.89,75.69z"}));
	}
	
	JohnsonJohnson.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = JohnsonJohnson;
	
	JohnsonJohnson.default = JohnsonJohnson;


/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Lg (props) {
	    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polygon",{"style":{"fill":"#6B6B6B"},"points":"106.8,112.98 106.8,114.58 99.33,114.58 99.33,102.07 101.32,102.07 101.32,112.98 \t","key":0}),React.createElement("path",{"style":{"fill":"#6B6B6B"},"d":"M108.06,105.88h1.95v8.7h-1.95V105.88z M108.04,102.2h1.97v1.75h-1.97V102.2z","key":1}),React.createElement("g",{"key":2},[React.createElement("path",{"style":{"fill":"#6B6B6B"},"d":"M117.71,105.88v1.48h-3v7.22h-1.96v-7.22h-1.28v-1.48h1.25v-1.05c0-2.62,1.44-3.42,3.46-3.42\n\t\t\tc0.7,0,1.44,0.1,2,0.33l-0.43,1.4c-0.44-0.16-0.89-0.25-1.36-0.25c-1.24,0-1.71,0.58-1.71,1.93v1.05H117.71z","key":0}),React.createElement("path",{"style":{"fill":"#6B6B6B"},"d":"M120.35,109.36h3.79c0-1.65-0.58-2.35-1.69-2.35C120.95,107.02,120.41,107.82,120.35,109.36 M118.31,110.18\n\t\t\tc0-3.03,1.38-4.51,4.16-4.51c3.05,0,3.68,1.81,3.68,4.26v0.78h-5.82c0.04,1.85,0.76,2.64,2.49,2.64c1.3,0,2.12-0.41,2.8-0.7\n\t\t\tl0.41,1.25c-0.66,0.39-2.14,0.88-3.52,0.88C119.4,114.79,118.31,113.27,118.31,110.18","key":1}),React.createElement("path",{"style":{"fill":"#6B6B6B"},"d":"M126.37,105.63c0.82-1.4,0.97-2.61,0.97-4.09h1.83c-0.02,2.22-0.54,3.51-1.57,4.87L126.37,105.63z","key":2}),React.createElement("path",{"style":{"fill":"#6B6B6B"},"d":"M134.47,109.79c1.07,0.37,1.93,0.93,1.93,2.35c0,1.79-1.4,2.65-3.74,2.65c-1.32,0-2.43-0.25-3.29-0.62\n\t\t\tl0.6-1.42c0.68,0.33,1.62,0.6,2.71,0.6c1.03,0,1.83-0.21,1.83-1.03c0-0.49-0.37-0.82-1.11-1.09c-0.68-0.23-1.46-0.45-2.06-0.68\n\t\t\tc-1.05-0.39-1.85-0.97-1.85-2.28c0-1.85,1.64-2.59,3.64-2.59c1.4,0,2.39,0.27,3.19,0.58l-0.6,1.42c-0.7-0.35-1.58-0.58-2.59-0.58\n\t\t\tc-1.24,0-1.77,0.39-1.77,0.97c0,0.47,0.33,0.74,1.07,1.03C132.89,109.28,133.86,109.57,134.47,109.79","key":3}),React.createElement("path",{"style":{"fill":"#6B6B6B"},"d":"M152.8,113.95c-1.11,0.51-2.72,0.84-4.47,0.84c-4.03-0.02-5.83-2.26-5.83-6.46c0-4.38,2.29-6.46,6.01-6.46\n\t\t\tc1.77,0,3.33,0.56,4.3,1.73l-1.21,1.09c-0.7-0.74-1.67-1.25-3.06-1.25c-2.7,0-3.99,1.81-3.99,5.08c0,3.02,1.29,4.67,3.89,4.67\n\t\t\tc0.93,0,1.75-0.13,2.43-0.31v-3.36h-2.88v-1.54h4.82V113.95z","key":4})]),React.createElement("polygon",{"style":{"fill":"#6B6B6B"},"points":"106.8,112.98 106.8,114.58 99.33,114.58 99.33,102.07 101.32,102.07 101.32,112.98 \t","key":3}),React.createElement("g",{"key":4},[React.createElement("path",{"style":{"fill":"#6B6B6B"},"d":"M160.73,110.12c0-1.69-0.37-3.07-2.04-3.07c-1.85,0-2.43,1.15-2.43,3.29c0,1.71,0.39,3.06,2.02,3.06\n\t\t\tC160.17,113.41,160.73,112.28,160.73,110.12 M154.26,110.2c0-3.03,1.4-4.53,4.43-4.53c3.09,0,4.04,1.75,4.04,4.61\n\t\t\tc0,3.03-1.4,4.51-4.45,4.51C155.19,114.79,154.26,113.06,154.26,110.2","key":0}),React.createElement("path",{"style":{"fill":"#6B6B6B"},"d":"M170.4,110.12c0-1.69-0.37-3.07-2.04-3.07c-1.85,0-2.42,1.15-2.42,3.29c0,1.71,0.39,3.06,2.01,3.06\n\t\t\tC169.85,113.41,170.4,112.28,170.4,110.12 M163.94,110.2c0-3.03,1.4-4.53,4.42-4.53c3.09,0,4.03,1.75,4.03,4.61\n\t\t\tc0,3.03-1.4,4.51-4.44,4.51C164.86,114.79,163.94,113.06,163.94,110.2","key":1}),React.createElement("path",{"style":{"fill":"#6B6B6B"},"d":"M179.56,112.73v-5.24c-0.49-0.29-0.96-0.39-1.44-0.39c-1.5,0-2.47,0.84-2.47,3.23c0,1.81,0.62,3.05,2.22,3.05\n\t\t\tC178.54,113.37,179.05,113.17,179.56,112.73 M173.64,110.43c0-2.78,1.15-4.75,4.17-4.75c0.66,0,1.19,0.1,1.75,0.37v-4.38\n\t\t\tl1.96-0.24v10.88l0.17,2.28H180l-0.17-0.57c-0.76,0.56-1.6,0.78-2.57,0.78C174.77,114.79,173.64,113.15,173.64,110.43","key":2})]),React.createElement("polygon",{"style":{"fill":"#6B6B6B"},"points":"109.22,46.73 99.33,46.73 99.33,89.53 129.7,89.53 129.7,81.2 109.22,81.2 \t","key":5}),React.createElement("g",{"key":6},React.createElement("path",{"style":{"fill":"#6B6B6B"},"d":"M151.45,73.22h8.05v7.48c-1.48,0.57-4.38,1.13-7.13,1.13c-8.9,0-11.87-4.52-11.87-13.7\n\t\t\tc0-8.76,2.82-13.91,11.72-13.91c4.95,0,7.77,1.55,10.1,4.52l6.15-5.65c-3.75-5.37-10.32-6.99-16.46-6.99\n\t\t\tc-13.84,0-21.12,7.56-21.12,21.96c0,14.34,6.57,22.11,21.05,22.11c6.64,0,13.14-1.7,16.67-4.17V65.24h-17.16V73.22z"})),React.createElement("g",{"key":7},[React.createElement("path",{"className":"st1","style":{"fill":"#A50034"},"d":"M51.42,101.42c18.29,0,33.11-14.83,33.11-33.11c0-18.29-14.82-33.1-33.11-33.1\n\t\t\tc-18.28,0-33.11,14.82-33.11,33.1C18.31,86.59,33.14,101.42,51.42,101.42","key":0}),React.createElement("polygon",{"style":{"fill":"#FFFFFF"},"points":"50.11,53.78 50.11,82.8 59.33,82.8 59.33,80.21 52.74,80.21 52.74,53.78 \t\t","key":1}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M40.85,61.7c2.2,0,3.98-1.78,3.98-3.97c0-2.19-1.78-3.97-3.98-3.97c-2.18,0-3.96,1.78-3.96,3.97\n\t\t\tC36.89,59.92,38.67,61.7,40.85,61.7","key":2}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M52.74,40.61c-0.33-0.01-0.99-0.02-1.32-0.02c-15.27,0-27.7,12.43-27.7,27.71c0,7.4,2.87,14.36,8.1,19.59\n\t\t\tC37.07,93.13,44.03,96,51.42,96c7.4,0,14.36-2.88,19.6-8.12c5.23-5.23,8.1-12.19,8.1-19.59v-1.26l-1.11,0.01H59.35v2.57h17.15\n\t\t\tv0.37C75.61,83.06,64.7,93.42,51.42,93.42c-6.7,0-13.01-2.61-17.76-7.36c-4.75-4.74-7.36-11.05-7.36-17.76\n\t\t\tc0-6.71,2.61-13.02,7.36-17.76c4.75-4.75,11.05-7.36,17.76-7.36c0.3,0,1.01,0.01,1.32,0.02V40.61z","key":3})])]));
	}
	
	Lg.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Lg;
	
	Lg.default = Lg;


/***/ }),

/***/ 890:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Merck (props) {
	    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("g",{"key":0},[React.createElement("path",{"style":{"fill":"#009893"},"d":"M18.08,61c0-7.73,6.27-14,14-14c7.73,0,14,6.27,14,14H18.08z","key":0}),React.createElement("path",{"style":{"fill":"#009893"},"d":"M4.08,75c0-7.73,6.27-14,14-14c0,7.73,6.27,14,14,14c-7.73,0-14,6.27-14,14C10.35,89,4.08,82.73,4.08,75","key":1}),React.createElement("path",{"style":{"fill":"#009893"},"d":"M46.08,89c0,7.73-6.27,14-14,14c-7.73,0-14-6.27-14-14H46.08z","key":2}),React.createElement("path",{"style":{"fill":"#009893"},"d":"M46.08,61c7.73,0,14,6.27,14,14c0,7.73-6.27,14-14,14c0-7.73-6.27-14-14-14C39.81,75,46.08,68.73,46.08,61","key":3})]),React.createElement("polygon",{"style":{"fill":"#009893"},"points":"103.76,89 97.34,89 97.34,70.17 89.11,89 80.46,70.15 80.46,89 74.46,89 74.46,61 83.03,61 \n\t\t89.21,75.49 95.09,61 103.76,61 \t","key":1}),React.createElement("polygon",{"style":{"fill":"#009893"},"points":"111.68,61 113.22,61 123.11,61 123.11,65.91 113.22,65.91 113.22,72.34 122.71,72.34 122.71,77.13 \n\t\t113.22,77.13 113.22,84.25 123.11,84.25 123.11,89 113.22,89 111.68,89 106.96,89 106.96,61 \t","key":2}),React.createElement("g",{"key":3},React.createElement("path",{"style":{"fill":"#009893"},"d":"M169.55,62.4c-8.28-4.91-22.34,0.49-22.34,12.6c0,10.42,10.88,18.76,22.34,13.18v-6\n\t\t\tc-8.82,6.18-16.49-0.01-16.37-6.95c0.09-4.61,3.18-8.99,9.17-9.33c2.94-0.17,4.94,0.56,7.2,2.73V62.4z"})),React.createElement("rect",{"x":"172.19","y":"61.27","style":{"fill":"#009893"},"width":"5.95","height":"27.73","key":4}),React.createElement("polygon",{"style":{"fill":"#009893"},"points":"189.09,89 178.74,73.96 187.66,61.33 194.61,61.33 185.61,73.98 195.92,89 \t","key":5}),React.createElement("path",{"style":{"fill":"#009893"},"d":"M135.61,73.83c2.37,0,4.2-1.84,4.2-4c0-1.13-0.25-4.17-4.88-4.17h-2.74v8.17H135.61z M125.9,61h6.29h4.74\n\t\tc6.49,0,9.17,5.22,9.17,8.41c0,3.2-1.24,6.39-5.05,7.83L149.27,89h-6.7l-10.39-15.04V89h-6.29V61z","key":6})]));
	}
	
	Merck.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Merck;
	
	Merck.default = Merck;


/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Ohaus (props) {
	    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#EC174F;}\n"),React.createElement("g",{"key":1},[React.createElement("g",{"key":0},[React.createElement("g",{"key":0},[React.createElement("path",{"style":{"fill":"#EC174F"},"d":"M153.99,115.45c-0.17-0.27-0.32-0.48-0.44-0.6c-0.07-0.07-0.16-0.12-0.26-0.17\n\t\t\t\tc0.26-0.01,0.47-0.11,0.63-0.26c0.16-0.16,0.24-0.36,0.24-0.58c0-0.16-0.05-0.3-0.14-0.44c-0.1-0.14-0.22-0.23-0.39-0.29\n\t\t\t\tc-0.16-0.05-0.41-0.08-0.78-0.08h-1.03v3.02h0.49v-1.29h0.29c0.17,0.01,0.31,0.04,0.4,0.11c0.12,0.09,0.29,0.33,0.51,0.71\n\t\t\t\tl0.28,0.47h0.58L153.99,115.45z M152.91,114.33h-0.6v-0.91h0.56c0.24,0,0.41,0.02,0.5,0.06c0.09,0.02,0.16,0.08,0.21,0.15\n\t\t\t\tc0.05,0.07,0.08,0.15,0.08,0.25c0,0.13-0.05,0.25-0.16,0.33C153.38,114.29,153.19,114.33,152.91,114.33z","key":0}),React.createElement("g",{"key":1},React.createElement("path",{"style":{"fill":"#EC174F"},"d":"M155.47,113.07c-0.25-0.45-0.6-0.79-1.05-1.03c-0.45-0.25-0.92-0.37-1.39-0.37c-0.47,0-0.93,0.12-1.38,0.37\n\t\t\t\t\tc-0.45,0.24-0.81,0.58-1.05,1.03c-0.25,0.46-0.38,0.92-0.38,1.41c0,0.48,0.12,0.94,0.37,1.39c0.25,0.45,0.6,0.8,1.05,1.04\n\t\t\t\t\tc0.44,0.25,0.91,0.37,1.39,0.37c0.49,0,0.95-0.13,1.4-0.37c0.46-0.25,0.8-0.6,1.04-1.04c0.25-0.45,0.37-0.92,0.37-1.39\n\t\t\t\t\tC155.85,114,155.73,113.54,155.47,113.07z M155.07,115.65c-0.21,0.38-0.5,0.67-0.87,0.87c-0.37,0.2-0.76,0.31-1.17,0.31\n\t\t\t\t\tc-0.4,0-0.79-0.11-1.16-0.31c-0.37-0.21-0.66-0.5-0.87-0.87c-0.2-0.37-0.3-0.76-0.3-1.16c0-0.41,0.1-0.8,0.31-1.18\n\t\t\t\t\tc0.21-0.37,0.5-0.66,0.87-0.86c0.37-0.2,0.75-0.3,1.15-0.3c0.39,0,0.78,0.1,1.16,0.3c0.37,0.2,0.66,0.49,0.87,0.86\n\t\t\t\t\tc0.22,0.39,0.32,0.77,0.32,1.18C155.38,114.89,155.28,115.28,155.07,115.65z"}))]),React.createElement("g",{"key":1},[React.createElement("g",{"key":0},React.createElement("path",{"style":{"fill":"#EC174F"},"d":"M61.25,112.79c-1.41-0.99-3.48-1.5-6.22-1.5h-2.66v0c-2.72,0.01-4.76,0.52-6.17,1.5\n\t\t\t\t\tc-1.37,0.99-2.06,2.47-2.06,4.43V122c0,1.96,0.69,3.43,2.06,4.43c1.41,0.99,3.48,1.5,6.23,1.5h2.66v0\n\t\t\t\t\tc2.72-0.01,4.76-0.52,6.16-1.5c1.37-0.99,2.06-2.47,2.06-4.43v-4.79C63.32,115.25,62.63,113.78,61.25,112.79z M58,122.09\n\t\t\t\t\tc0,0.93-0.52,1.6-1.21,1.99c-0.62,0.34-1.64,0.51-3.06,0.56c-1.41-0.05-2.43-0.22-3.06-0.56c-0.69-0.39-1.21-1.05-1.21-1.99\n\t\t\t\t\tl0-4.97c0-0.93,0.52-1.6,1.21-1.99c0.62-0.34,1.65-0.52,3.06-0.56c1.41,0.04,2.43,0.22,3.06,0.56c0.69,0.39,1.21,1.05,1.21,1.99\n\t\t\t\t\tL58,122.09z"})),React.createElement("path",{"style":{"fill":"#EC174F"},"d":"M121.51,123.4h-4.19c-1.37,0-2.28-0.17-2.74-0.53c-0.46-0.35-0.68-1.06-0.68-2.12v-9.08h-5.19v10.05\n\t\t\t\tc0,2.03,0.64,3.5,1.93,4.43c1.28,0.93,3.37,1.38,6.26,1.38h2.84h1.77h5.21v-15.86h-5.21V123.4z","key":1}),React.createElement("path",{"style":{"fill":"#EC174F"},"d":"M146.93,118.47c-1.13-0.8-2.78-1.21-4.93-1.21h-4.71c-0.85,0-1.53-0.02-1.95-0.19\n\t\t\t\tc-0.34-0.13-0.52-0.41-0.52-0.8c0-0.41,0.23-0.64,0.69-0.82c0.55-0.21,1.41-0.21,2.91-0.21h9.18v-3.57h-11.16\n\t\t\t\tc-2.38,0-4.14,0.4-5.27,1.21c-1.14,0.8-1.71,2.06-1.71,3.76c0,1.68,0.61,3,1.55,3.66c0.94,0.66,2.61,1.1,5.28,1.1h4.5\n\t\t\t\tc0.96,0,1.63,0.06,2.11,0.23c0.45,0.17,0.68,0.49,0.68,0.96c0,0.41-0.16,0.74-0.66,0.93c-0.47,0.18-1.16,0.26-2.13,0.26h-10.99\n\t\t\t\tv3.77h13.45c1.58,0,2.87-0.46,3.88-1.38c1-0.92,1.5-2.11,1.5-3.59C148.63,121.05,148.07,119.28,146.93,118.47z","key":2}),React.createElement("path",{"style":{"fill":"#EC174F"},"d":"M78.83,118.16H71.7c0,0.06,0-6.49,0-6.49h-5.44v15.86h5.44c0,0,0-5.02,0-5.07h7.13c0,0.05,0,5.07,0,5.07\n\t\t\t\th5.44v-15.86h-5.44C78.83,111.67,78.83,118.22,78.83,118.16z","key":3}),React.createElement("path",{"style":{"fill":"#EC174F"},"d":"M103.66,113.18c-1.33-0.99-3.26-1.51-5.85-1.51h-2.5v0c-2.55,0.01-4.47,0.52-5.79,1.5\n\t\t\t\tc-1.29,0.99-1.94,2.47-1.94,4.43v9.93h5l0.08-5.07h7.84l0.08,5.07h5v-9.93C105.6,115.65,104.95,114.17,103.66,113.18z\n\t\t\t\t M92.74,118.16l0.01-0.65c0-0.93,0.32-1.6,0.97-1.99c0.59-0.33,1.55-0.51,2.87-0.56c1.33,0.04,2.29,0.22,2.87,0.56\n\t\t\t\tc0.64,0.39,0.97,1.06,0.97,1.99l0.01,0.65H92.74z","key":4})])]),React.createElement("g",{"key":1},[React.createElement("path",{"style":{"fill":"#EC174F"},"d":"M129.36,29.67c-4.98-4.46-13.2-4.87-22.58-1.95l0.05-0.06c-4.5,1.37-2.9-1.06-0.97-2.11\n\t\t\tc1.51-0.83,6.93-2.77,9.37-3.48H44.25V63.4c16.64-16.89,37.51-30.04,51.94-35.48c3.8-1.43,3.99,0.42-0.03,2.82\n\t\t\tc-13.38,8-34.85,27.64-40.65,46.55c-3.11,9.43-2.44,17.6,2.76,22.25c10.33,9.26,34.62,1.12,54.25-18.17\n\t\t\tC132.15,62.07,139.69,38.93,129.36,29.67z","key":0}),React.createElement("path",{"style":{"fill":"#EC174F"},"d":"M122.01,86.77c-14.44,10.97-28.58,16.59-28.58,16.59h55.31V58.37C144.37,65.43,133.02,78.41,122.01,86.77z","key":1})])])]);
	}
	
	Ohaus.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Ohaus;
	
	Ohaus.default = Ohaus;


/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Pfitzer (props) {
	    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#0082CA;}\n"),React.createElement("g",{"key":1},[React.createElement("path",{"style":{"fill":"#0082CA"},"d":"M135.64,75.27c1.41-0.98,2.55-2.37,2.84-4.16c0.29-1.85-1.73-2.26-3.84-1.58c-3.83,1.24-6.22,4.83-6.35,7.85\n\t\tC128.29,77.37,131.99,77.81,135.64,75.27z","key":0}),React.createElement("path",{"style":{"fill":"#0082CA"},"d":"M57.23,58.07h-3.35l-4.35,16.07c3.97,0.05,4.72-0.25,5.35-0.38c3.76-0.75,5.43-3.66,5.43-3.66\n\t\tc0.71-0.92,2.79-6.31,2.26-8.33C61.9,59.26,59.71,58.36,57.23,58.07z","key":1}),React.createElement("path",{"style":{"fill":"#0082CA"},"d":"M145.54,35.55c-13.18-4.82-62.71-13-102.55,18.82c-15.08,12.04-24.92,31.74-8.15,48.72\n\t\tc10.07,10.2,24.43,13.24,25.05,13.24c0.63,0,13.03-47.47,13.03-47.47s2.57-10.99,5.51-16.37c2.94-5.36,8.89-7.56,10.77-7.75\n\t\tc3.25-0.32,6.34-0.04,8.2,0.59c3.19,1.09,4.58,3.43,4.82,4.4c1.16,4.72-2.26,6.73-4.51,6.84c-2.51,0.12-4.03-1.28-4.38-2.22\n\t\tc-0.38-1-0.61-3,0.55-4.17c0.83-0.83,0.45-2.52-0.17-2.96c0,0-2.25-0.74-4.79,0.97c-1.67,1.12-3.91,6.28-4.35,7.78\n\t\tc-0.25,0.84-2.44,9.81-2.44,9.81l15.91,0.06l-6.7,24.49h-7.89l5.26-20.36h-8.02l-12.66,47.9c14.08,1.29,45.03,5.8,82.81-17.57\n\t\tC170.29,88.27,193.57,53.12,145.54,35.55z M66.8,73.83c0,0-3.07,3.35-11.17,4.46c-3.19,0.44-7.52,0.31-7.52,0.31l-3.01,11.74h-8.27\n\t\tl9.93-35.97l12.43,0.15c0,0,9.46,0.56,11.27,6.5C72.29,66.95,68.1,72.35,66.8,73.83z M117.14,90.65l-20.76-0.16\n\t\tc0.18-5.06,5.6-10.9,6.35-11.4c0.75-0.5,9.27-9.12,9.27-9.12l-11.37,0.03l1.1-4.22h20.33c-1.82,5.09-3.42,6.02-5.73,8.43\n\t\tc-3.13,3.28-6.83,5.84-10.71,11.34l12.71-0.06L117.14,90.65z M129.05,91.34c-8.82-0.5-10.13-8.82-8.65-13.42\n\t\tc2.84-8.86,9.6-11.15,10.89-11.57c11.47-3.75,13.53,2.97,13.54,4c0.02,5.81-5.42,8.4-9.49,9.34c-2.23,0.51-4.04,0.88-7.55,0.79\n\t\tc0,0-0.45,1.49-0.06,2.71c0.19,0.61,0.62,1.75,2.94,3.12c0,0,3.02,0.98,5.51-0.56c2.2-1.36,4.1-3.03,4.1-3.03l2.44,3.22\n\t\tC142.73,85.94,137.96,91.84,129.05,91.34z M166.71,74.27c-2.09-0.12-3.15-1.67-3.36-2.31c0,0,0.36-3.38-3.74-1.23\n\t\tc-0.71,0.37-1.89,1.94-3.13,3.87c-1.6,2.5-4.92,15.96-4.92,15.96h-8.08l6.48-24.83l7.98,0.08l-1.23,4.87c0,0,3.7-4.3,6.54-4.96\n\t\tc1.9-0.44,4.56-0.66,6.43,1.85C171.13,69.54,169.96,74.46,166.71,74.27z","key":2})])]);
	}
	
	Pfitzer.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Pfitzer;
	
	Pfitzer.default = Pfitzer;


/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Philips (props) {
	    return React.createElement("svg",props,React.createElement("path",{"className":"st0","style":{"fill":"#0B5ED7"},"d":"M71.66,59.49h-9.47v12.33h-9.86V59.49h-9.47v31.03h9.47v-12.2h9.86v12.2h9.47V59.49L71.66,59.49z M104.61,84.28\n\tv-24.8h-9.47v31.03h17.12l1.43-6.23H104.61L104.61,84.28z M88.13,59.49h-9.47v31.03h9.47V59.49L88.13,59.49z M126.53,59.49h-9.47\n\tv31.03h9.47V59.49L126.53,59.49z M173.23,67.41c0-1.69,1.69-2.47,4.41-2.47c2.98,0,6.23,0.65,8.43,1.56l-0.78-6.75\n\tc-2.46-0.52-4.67-0.91-8.69-0.91c-7.65,0-12.84,3.02-12.84,9.35c0,10.91,14.79,8.7,14.79,13.76c0,1.95-1.43,2.99-4.93,2.99\n\tc-3.11,0-7.91-1.04-10.77-2.47l1.04,7.14c2.85,1.04,6.75,1.56,9.86,1.56c7.91,0,14.4-2.6,14.4-10.39\n\tC188.15,70.39,173.23,72.34,173.23,67.41L173.23,67.41z M146.51,83.11c8.82,0,14.4-4.54,14.4-12.46c0-8.7-5.97-11.81-15.7-11.81\n\tc-3.76,0-8.3,0.26-11.54,0.65v31.03h9.47v-7.4H146.51L146.51,83.11z M151.56,70.78c0,4.02-1.95,6.75-6.88,6.75h-1.56V64.71\n\tc0.55-0.03,1.07-0.03,1.56-0.03C149.36,64.68,151.56,66.89,151.56,70.78L151.56,70.78z M24.7,83.11c8.82,0,14.4-4.54,14.4-12.46\n\tc0-8.7-5.97-11.81-15.7-11.81c-3.76,0-8.3,0.26-11.55,0.65v31.03h9.47v-7.4H24.7L24.7,83.11z M29.76,70.78\n\tc0,4.02-1.95,6.75-6.88,6.75h-1.56V64.71c0.55-0.03,1.07-0.03,1.56-0.03C27.55,64.68,29.76,66.89,29.76,70.78L29.76,70.78z"}));
	}
	
	Philips.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Philips;
	
	Philips.default = Philips;


/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Priceline (props) {
	    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#0077FF;}\n"),React.createElement("g",{"key":1},React.createElement("g",null,[React.createElement("rect",{"x":"48.89","y":"62.6","className":"st0","width":"7.75","height":"26.66","key":0}),React.createElement("rect",{"x":"113.22","y":"51.15","className":"st0","width":"7.85","height":"38.12","key":1}),React.createElement("rect",{"x":"126.38","y":"62.6","className":"st0","width":"7.75","height":"26.66","key":2}),React.createElement("path",{"className":"st0","d":"M147.34,65.05c0.76-0.82,1.27-1.43,2.65-2.09c1.22-0.51,2.95-0.96,4.84-0.96c1.58,0,3.36,0.3,4.74,1.07\n\t\t\tc2.8,1.48,3.51,3.88,3.51,8.01v18.2h-7.79V74.28c0-2.4-0.05-3.26-0.36-3.98c-0.61-1.43-1.99-2.04-3.52-2.04\n\t\t\tc-4.13,0-4.13,3.31-4.13,6.63v14.38h-7.85V62.71h7.9V65.05z","key":3}),React.createElement("path",{"className":"st0","d":"M184.96,72.65c-0.15-1.12-0.36-2.6-1.48-3.77c-0.97-0.97-2.45-1.48-3.82-1.48c-1.89,0-3.21,0.92-3.98,1.73\n\t\t\tc-1.07,1.17-1.32,2.4-1.58,3.52H184.96z M192.76,82.48c-0.92,1.38-1.83,2.7-3.21,3.98c-2.29,2.14-5.76,3.77-10.05,3.77\n\t\t\tc-7.9,0-13.46-5.05-13.46-13.77c0-6.42,3.16-14.67,13.66-14.67c1.58,0,6.17,0.15,9.59,3.82c3.46,3.72,3.67,8.92,3.77,11.93h-19.01\n\t\t\tc-0.06,3.32,1.83,6.63,6.06,6.63c4.28,0,5.76-2.81,6.73-4.69L192.76,82.48z","key":4}),React.createElement("path",{"className":"st0","d":"M78.83,81.17c-0.02-0.07-0.15-0.05-0.2,0.04c-0.16,0.28-0.35,0.56-0.62,0.86c-1.63,1.83-3.57,1.83-3.98,1.83\n\t\t\tc-4.18,0-5.92-4.43-5.92-7.95c0-3.21,1.43-8.05,5.66-8.05c1.22,0,2.19,0.41,2.96,0.92c1.07,0.77,1.6,1.54,2.02,2.34\n\t\t\tc0.05,0.09,0.17,0.12,0.19,0.06c0.64-2.18,1.74-4.27,3.42-5.92c-3.06-2.85-6.63-3.35-8.94-3.35c-8.87,0-13.36,6.52-13.36,14.27\n\t\t\tc0,10.86,8.11,13.92,13.21,13.92c3.01,0,5.6-0.97,7.65-2.4c0.45-0.32,0.85-0.65,1.21-0.98C80.61,85.31,79.48,83.43,78.83,81.17","key":5}),React.createElement("path",{"className":"st0","d":"M57.02,55.96c0,2.33-1.89,4.22-4.22,4.22c-2.33,0-4.21-1.89-4.21-4.22c0-2.33,1.88-4.22,4.21-4.22\n\t\t\tC55.13,51.74,57.02,53.63,57.02,55.96","key":6}),React.createElement("path",{"className":"st0","d":"M134.5,55.96c0,2.33-1.89,4.22-4.22,4.22c-2.33,0-4.22-1.89-4.22-4.22c0-2.33,1.89-4.22,4.22-4.22\n\t\t\tC132.61,51.74,134.5,53.63,134.5,55.96","key":7}),React.createElement("path",{"className":"st0","d":"M196.45,64.12H197c0.44,0,0.74-0.06,0.74-0.49c0-0.33-0.29-0.46-0.7-0.46h-0.59V64.12z M195.99,62.75h1.17\n\t\t\tc0.69,0,1.04,0.29,1.04,0.88c0,0.59-0.37,0.83-0.77,0.89l0.88,1.37h-0.52l-0.87-1.37h-0.47v1.37h-0.46V62.75z M196.97,66.59\n\t\t\tc1.21,0,2.22-1.03,2.22-2.26c0-1.23-1.01-2.26-2.22-2.26c-1.21,0-2.22,1.03-2.22,2.26C194.75,65.56,195.76,66.59,196.97,66.59\n\t\t\t M196.97,61.65c1.48,0,2.67,1.19,2.67,2.67c0,1.48-1.19,2.67-2.67,2.67c-1.48,0-2.68-1.19-2.68-2.67\n\t\t\tC194.29,62.85,195.49,61.65,196.97,61.65","key":8}),React.createElement("g",{"key":9},[React.createElement("path",{"className":"st0","d":"M14.05,67.6c-1.43,0-2.91,0.61-4.03,2.14C8.9,71.22,8.4,73.52,8.4,76.01c0,3.36,0.87,5.46,1.88,6.58\n\t\t\t\tc0.92,0.97,2.24,1.53,3.52,1.53c3.82,0,5.5-4.13,5.5-8.31c0-3.51-0.97-7.23-4.18-8.05C14.77,67.65,14.41,67.6,14.05,67.6\n\t\t\t\t M7.84,65.25c0.25-0.31,0.51-0.61,0.76-0.87c1.33-1.28,3.72-2.34,6.68-2.34c6.52,0,11.57,4.94,11.57,13.81\n\t\t\t\tc0,5.45-2.4,13.92-11.53,13.92c-2.95,0-4.48-0.97-6.58-2.24V98.5h-7.9V62.76h6.99V65.25z","key":0}),React.createElement("path",{"className":"st0","d":"M37.79,65.41c1.73-1.48,3.62-2.65,7.7-3.05v6.93l-2.6,0.41c-3.77,0.67-4.9,1.23-4.9,4.59v14.99h-7.85V62.6\n\t\t\t\th7.65V65.41z","key":1})]),React.createElement("path",{"className":"st0","d":"M101.71,72.65c-0.15-1.12-0.36-2.6-1.48-3.77c-0.97-0.97-2.45-1.48-3.83-1.48c-1.89,0-3.21,0.92-3.97,1.73\n\t\t\tc-1.07,1.17-1.33,2.4-1.58,3.52H101.71z M109.52,82.48c-0.92,1.38-1.83,2.7-3.21,3.98c-2.29,2.14-5.77,3.77-10.07,3.77\n\t\t\tc-7.9,0-13.46-5.05-13.46-13.77c0-6.42,3.16-14.67,13.66-14.67c1.59,0,6.19,0.15,9.61,3.82c3.46,3.72,3.67,8.92,3.77,11.93H90.79\n\t\t\tc-0.05,3.32,1.84,6.63,6.07,6.63c4.3,0,5.78-2.81,6.75-4.69L109.52,82.48z","key":10})]))]);
	}
	
	Priceline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Priceline;
	
	Priceline.default = Priceline;


/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Prudential (props) {
	    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,[React.createElement("path",{"style":{"fill":"#004987"},"d":"M35.95,79.43l-1.53,0.27l0.4-3.04l-0.4-0.59l0.4-3.45l3.92,1.59L35.95,79.43z M42.2,88.56h-5.12l4.85-7.61\n\t\t\tl1.46-4.96l3.06,1.06C46.18,80.89,44.93,84.79,42.2,88.56 M40.41,80.69l-1.93,1.66l-3.85,6.22H32.1l2.52-4.43l1.99-1.65l2.85-8.01\n\t\t\tl3.06,1.26L40.41,80.69z M33.83,65.21l-10.16-5.9l-3.72-0.66v2.71l2.86,2.65l-3.99-0.33c0,0,0.13,0.2,3.45,3.71l15.15,2.51\n\t\t\tl2.66,1.72l-6.91,0.33l-2.85,10.39l-9.37,6.22h-6.11l2.06-4.03l-0.34-0.13l-5.51,4.17H9.71l5.65-7.87\n\t\t\tc0.26-2.25,0.13-1.26,0.46-5.29l-0.87-1.19l-2.26,8.73l-4.72,5.63h-1.2l2.8-3.9l3.92-11.98l-1,0.46l-1.73,4.77l-1.19,0.66\n\t\t\tc0,0-2.8,6.74-4.26,10.06c-2.12-3.05-4.52-7.15-4.52-14.29c0-10.72,9.23-22.03,23.12-22.03c13.35,0,20.46,10.59,21.66,16.08\n\t\t\tL33.83,65.21z M30.7,88.56h-3.19l5.91-7.35l0.6,1.13L30.7,88.56z M23.8,97.7c-5.65,0-12.56-1.98-17.54-8.07h35.01\n\t\t\tC37.22,94.86,30.24,97.7,23.8,97.7 M23.93,53.76C10.91,53.76,2.4,64.41,2.4,74.34c0,5.69,1.4,8.54,2.92,11.25\n\t\t\tc1.93-5.16,5.78-15.42,5.78-15.42s1.8-0.93,1.8-0.79l2.59-6.55l1.66-0.86l2.06-4.37l4.52,0.72l9.16,5.1l10.3,2.85\n\t\t\tC40.54,59.52,33.03,53.76,23.93,53.76","key":0}),React.createElement("path",{"style":{"fill":"#004987"},"d":"M191.12,89.62v-0.99h0.2c0.43,0,0.89-0.1,1.19-0.33c0.27-0.23,0.43-0.46,0.43-1.65V70.37\n\t\t\tc0-0.46,0-1.49-0.5-1.98c-0.3-0.3-0.86-0.44-1.23-0.44h-0.6v-0.98l6.38-0.5v20.18c0,1.09,0.17,1.42,0.44,1.65\n\t\t\tc0.3,0.23,0.86,0.33,1.49,0.33h0.27v0.99H191.12z M170.96,71.69c-1.4,0-2.52-1.13-2.52-2.52c0-1.39,1.12-2.48,2.52-2.48\n\t\t\tc1.4,0,2.52,1.09,2.52,2.48C173.48,70.57,172.35,71.69,170.96,71.69 M185.01,89.62l-0.07-2.51c-0.27,1.29-2.26,2.98-4.48,2.98\n\t\t\tc-3.48,0-4.59-2.45-4.59-4.01c0-3.67,3.69-4.89,8.77-5.88v-2.62c0-1.78-0.77-2.84-3.12-2.84c-1.59,0-2.96,0.96-3.16,1.52v0.07\n\t\t\tc0.2-0.3,0.64-0.4,0.96-0.4c1.16,0,1.96,0.66,1.96,1.81c0,0.9-0.93,1.89-2.23,1.89c-1.06,0-2.33-0.7-2.33-2.32\n\t\t\tc0-2.18,2.56-3.67,5.85-3.67c2.93,0,6.11,0.82,6.11,5.35v7.61c0,1.12,0.17,1.49,0.43,1.69c0.3,0.23,0.69,0.33,1.12,0.33h0.34v0.99\n\t\t\tH185.01z M166.94,89.62v-0.99h0.5c0.47,0,1-0.03,1.3-0.47c0.3-0.42,0.3-1.32,0.3-2.34v-8.3c0-0.66,0.07-1.59-0.5-2.05\n\t\t\tc-0.34-0.3-0.96-0.33-1.56-0.33h-0.33v-1.03h6.47v11.71c0,1.02-0.03,1.92,0.3,2.34c0.29,0.44,0.8,0.47,1.26,0.47h0.63v0.99H166.94\n\t\t\tz M166.07,88.14c-0.66,1.39-1.92,1.95-3.82,1.95c-3.36,0-3.92-2.41-3.92-4.34V75.13h-2.79v-1.03h0.26c3.62,0,5.55-4.8,5.55-7.14\n\t\t\th1.03v7.14h3.12v1.03h-3.06v11.11c0,1.06,0.14,2.09,1.29,2.09c0.5,0,0.84-0.23,1.07-0.6c0.63-0.89,0.6-2.68,0.6-3.87h1.23\n\t\t\tC166.64,85.69,166.51,87.21,166.07,88.14 M150.17,89.62V78.08c0-2.28-1.09-2.45-2-2.45c-0.63,0-1.36,0.36-1.86,1.16\n\t\t\tc-0.43,0.73-0.66,2.05-0.66,3.34v5.73c0,1.32-0.07,1.98,0.23,2.31c0.27,0.3,0.62,0.47,1.5,0.47h0.46v0.99h-8.47v-0.99h0.5\n\t\t\tc0.73,0,1.2-0.17,1.46-0.47c0.3-0.33,0.24-0.99,0.24-2.31v-7.97c0-1.03,0.03-1.89-0.27-2.32c-0.33-0.43-0.83-0.47-1.3-0.47h-0.63\n\t\t\tv-0.99h5.91l0.07,2.41h0.04c0.56-1.46,1.99-2.87,4.38-2.87c3.59,0,4.45,1.95,4.45,5.19v7.05c0,1.29-0.03,1.85,0.27,2.28\n\t\t\tc0.3,0.44,0.87,0.47,1.3,0.47h0.63v0.99H150.17z M128.74,81.35c0,0-0.1,1.63,0.23,3.51c0.33,1.88,1.13,3.87,3.36,3.87\n\t\t\tc3.09,0,4.55-2.71,4.55-4.4h1.29c0,2.22-2.16,5.76-6.41,5.76c-4.98,0-7.44-3.51-7.44-8.24c0-4.9,3.22-8.2,7.31-8.2\n\t\t\tc4.85,0,6.74,3.5,6.74,7.7H128.74z M117.75,89.62l-0.07-2.41c-0.29,1.03-1.79,2.88-4.35,2.88c-4.91,0-6.21-4.47-6.21-8.24\n\t\t\tc0-3.74,2.27-8.2,6.75-8.2c2.23,0,3.12,0.89,3.45,1.55v-4.83c0-0.86,0-1.49-0.5-1.98c-0.3-0.3-0.77-0.44-1.53-0.44h-0.3v-0.98\n\t\t\tl6.38-0.5v20.18c0,1.09,0.17,1.42,0.43,1.65c0.3,0.23,0.87,0.33,1.46,0.33h0.43v0.99H117.75z M100.47,89.62l-0.06-2.41h-0.04\n\t\t\tc-0.4,1.26-2.09,2.88-4.35,2.88c-3.75,0-4.59-2.19-4.59-5.06v-6.68c0-1.95-0.07-2.68-0.2-2.88c-0.09-0.17-0.26-0.37-1.13-0.37\n\t\t\th-0.24v-0.99h5.66v11.35c0,2.48,1.36,2.54,2.02,2.54c1.13,0,2.02-0.99,2.36-2.31c0.2-0.76,0.2-1.62,0.2-2.48v-4.86\n\t\t\tc0-1.36,0.03-2.48-0.26-2.81c-0.27-0.3-0.63-0.43-1.66-0.43h-0.33v-0.99h6.31v11.78c0,1.03,0.07,1.85,0.37,2.28\n\t\t\tc0.3,0.44,0.76,0.47,1.23,0.47h0.6v0.99H100.47z M87.06,77.55c-1.17,0-1.86-0.83-1.86-1.48c0-0.24,0-0.5,0.17-0.86h-0.03\n\t\t\tc-1.59,1.32-1.96,6.35-1.96,8.31v2.38c0,1.03,0,1.85,0.3,2.28c0.3,0.44,1.06,0.47,1.49,0.47h1.49v0.99H76.16v-0.99h0.99\n\t\t\tc1.06,0,1.59-0.17,1.86-0.6c0.37-0.6,0.3-2.18,0.3-2.18V79.8c0-1.99-0.07-3.48-0.3-4c-0.27-0.56-0.66-0.7-1.56-0.7h-0.36v-0.99\n\t\t\th5.64l0.17,3.97h0.03c0.17-1.92,1.3-4.43,3.89-4.43c1.39,0,2.26,0.66,2.26,1.95C89.08,76.59,88.35,77.58,87.06,77.55 M67.69,79.8\n\t\t\th-1.6v6.74c0,0.69,0.06,1.26,0.4,1.62c0.3,0.3,0.83,0.47,1.79,0.47h0.83v0.99H58.59v-0.99h0.93c0.8,0,1.46-0.13,1.8-0.4\n\t\t\tc0.33-0.3,0.5-0.8,0.5-1.69V70.24c0-1.06-0.17-1.79-0.7-2.05c-0.33-0.2-0.97-0.24-1.83-0.24h-0.7v-0.98h9.1\n\t\t\tc4.65,0,8.66,1.65,8.66,6.44C76.36,77.98,72.41,79.8,67.69,79.8 M184.64,81.19c-2.96,0.56-4.59,1.32-4.59,4.34\n\t\t\tc0,1.75,0.9,2.64,1.9,2.64c1.4,0,1.89-0.82,2.19-1.42c0.33-0.6,0.5-1.88,0.5-3.07V81.19z M131.6,74.5c-2.72,0-2.76,4.24-2.82,5.79\n\t\t\th5.44C134.26,78.61,134.12,74.5,131.6,74.5 M117.31,80.13c0-1.92-0.27-5.19-2.76-5.19c-2.82,0-2.86,4.7-2.86,6.91\n\t\t\tc0,1.92,0.14,6.45,2.76,6.45c1,0,1.83-0.62,2.23-1.56c0.27-0.66,0.63-1.65,0.63-3.41V80.13z M67.69,67.95h-1.6v10.76h1.6\n\t\t\tc3.68,0,4.35-2.62,4.35-5.3C72.04,70.73,71.38,67.95,67.69,67.95","key":1})])));
	}
	
	Prudential.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Prudential;
	
	Prudential.default = Prudential;


/***/ }),

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Quest (props) {
	    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M50,59.31c3.35,3.35,3.27,8.22,2.93,10.82c-0.53,4.01-2.33,8.18-5.09,11.88l-12.73,0l6.37,6.37\n\t\t\tc-4.48,3.34-9.59,5.26-14.29,5.26c-2.43,0-5.87-0.54-8.42-3.09c-3.35-3.35-3.27-8.22-2.93-10.82c0.7-5.31,3.63-10.88,8.04-15.29\n\t\t\tc5.14-5.14,11.78-8.21,17.69-8.21C42.58,56.22,46.9,56.21,50,59.31z"})),React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M54.26,88.42l4.46,4.47c3.7-5.01,5.88-11.19,5.88-17.89c0-4.65-1.06-9.06-2.94-13\n\t\tc-0.02-0.03-0.06-0.06-0.1-0.07c-0.06-0.01-0.13,0.04-0.14,0.11c0,0.02,0,0.04,0,0.06C63.42,70.22,60.87,80.15,54.26,88.42z","key":1}),React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M7.02,87.5c0.03,0.07,0.11,0.09,0.17,0.06c0.05-0.03,0.09-0.09,0.07-0.15C5.17,78.2,8.8,66.78,17.52,58.06\n\t\tc7.11-7.11,16.02-10.84,24.06-10.84c1.82,0,3.6,0.2,5.29,0.58c0.07,0.01,0.14-0.03,0.15-0.11c0.01-0.06-0.03-0.11-0.08-0.13\n\t\tc-3.8-1.73-8.03-2.7-12.48-2.7C17.81,44.86,4.32,58.35,4.32,75C4.32,79.46,5.29,83.69,7.02,87.5","key":2}),React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M34.46,105.14c6.7,0,12.89-2.19,17.9-5.89l-4.47-4.46c-6.44,5.15-13.89,7.84-20.7,7.84\n\t\tc-1.94,0-3.84-0.22-5.64-0.66c-0.01,0-0.03-0.01-0.05-0.01c-0.06,0-0.12,0.05-0.12,0.12c0,0.05,0.03,0.1,0.07,0.12\n\t\tC25.39,104.08,29.81,105.14,34.46,105.14z","key":3}),React.createElement("g",{"key":4},[React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M118.05,68.83c0,2.66-1.59,4.25-3.86,4.25c-2.34,0-3.67-1.52-3.67-4.19v-9.74h-3.93v10.91\n\t\t\tc0,3.99,2.24,6.59,6.1,6.59c2.66,0,4.25-1.4,5.36-3.02v2.66h3.93V59.16h-3.93V68.83z","key":0}),React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M169.14,62.53l-3.37-3.38h-2.23v-4.71h-3.93v17.11c0,3.76,2.04,5.03,4.93,5.03c1.46,0,2.56-0.33,3.54-0.88\n\t\t\tV72.5c-0.78,0.39-1.56,0.58-2.44,0.58c-1.33,0-2.11-0.62-2.11-2.14v-8.41H169.14z","key":1}),React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M151.53,66.17c-2.01-0.65-3.86-1.17-3.86-2.4v-0.06c0-1.01,0.88-1.72,2.4-1.72c1.2,0,2.63,0.44,4.05,1.18\n\t\t\tl2.35-2.35c-1.82-1.2-4.15-1.95-6.3-1.95c-3.41,0-6.1,1.98-6.1,5.23v0.06c0,3.28,2.83,4.32,5.36,5.03\n\t\t\tc2.01,0.62,3.83,1.07,3.83,2.4v0.06c0,1.14-0.97,1.85-2.66,1.85c-1.59,0-3.38-0.59-5.08-1.74l-2.28,2.28l0,0\n\t\t\tc2.14,1.69,4.84,2.57,7.27,2.57c3.57,0,6.36-1.79,6.36-5.39v-0.06C156.86,68.09,154.03,66.95,151.53,66.17z","key":2}),React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M133.23,58.8c-4.9,0-8.38,4.03-8.38,8.96c0,5.32,3.83,8.93,8.8,8.93c3.07,0,5.28-1.21,6.89-3.08l-2.18-2.18\n\t\t\tl-0.01,0c-1.36,1.33-2.72,2.05-4.64,2.05c-2.53,0-4.48-1.56-4.93-4.35h12.6c0.03-0.39,0.06-0.71,0.06-1.07\n\t\t\tC141.45,63.09,138.69,58.8,133.23,58.8z M128.79,66.32c0.42-2.54,2.08-4.3,4.41-4.3c2.52,0,4,1.87,4.32,4.3H128.79z","key":3}),React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M103.05,64.9c0-6.43-4.87-11.72-11.85-11.72c-6.98,0-11.92,5.36-11.92,11.78c0,6.43,4.87,11.72,11.85,11.72\n\t\t\tc2.66,0,5-0.81,6.92-2.14l1.99,1.78h5.92l-5.21-4.41C102.21,69.94,103.05,67.5,103.05,64.9z M97.7,69.26h-5.73l3.13,2.66\n\t\t\tc-1.07,0.68-2.4,1.1-3.9,1.1c-4.51,0-7.73-3.67-7.73-8.12c0-4.45,3.15-8.05,7.66-8.05c4.51,0,7.73,3.67,7.73,8.12\n\t\t\tC98.86,66.56,98.47,68.05,97.7,69.26z","key":4})]),React.createElement("g",{"key":5},[React.createElement("rect",{"x":"96.77","y":"81.72","style":{"fill":"#4B7637"},"width":"1.23","height":"1.23","key":0}),React.createElement("rect",{"x":"96.89","y":"85.55","style":{"fill":"#4B7637"},"width":"0.99","height":"10.3","key":1}),React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M86.19,81.72h-4.7v14.13h4.7c4.44,0,7.51-3.09,7.51-7.06v-0.04C93.7,84.76,90.63,81.72,86.19,81.72z\n\t\t\t M92.61,88.82c0,3.37-2.48,6.06-6.42,6.06h-3.65V82.69h3.65c3.94,0,6.42,2.75,6.42,6.1V88.82z","key":2}),React.createElement("rect",{"x":"167.67","y":"85.55","style":{"fill":"#4B7637"},"width":"0.99","height":"10.3","key":3}),React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M187.11,90.11c-1.47-0.43-2.86-0.85-2.86-2v-0.04c0-1.03,0.93-1.8,2.34-1.8c1.02,0,2.07,0.36,2.98,0.91\n\t\t\tl0.71-0.71c-1.03-0.68-2.42-1.13-3.65-1.13c-2,0-3.39,1.19-3.39,2.85v0.04c0,1.84,1.86,2.34,3.53,2.83\n\t\t\tc1.43,0.41,2.72,0.85,2.72,2.06v0.04c0,1.19-1.09,1.96-2.48,1.96c-1.27,0-2.47-0.45-3.57-1.27l-0.7,0.7\n\t\t\tc1.09,0.89,2.73,1.49,4.22,1.49c1.98,0,3.55-1.17,3.55-3.01V93C190.5,91.18,188.76,90.58,187.11,90.11z","key":4}),React.createElement("rect",{"x":"167.55","y":"81.72","style":{"fill":"#4B7637"},"width":"1.23","height":"1.23","key":5}),React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M105.32,85.39c-1.41,0-2.52,0.36-3.65,0.89l0.36,0.87c0.95-0.49,1.98-0.83,3.23-0.83\n\t\t\tc2.12,0,3.39,1.07,3.39,3.15v0.44c-0.99-0.26-1.98-0.44-3.41-0.44c-2.67,0-4.5,1.21-4.5,3.35v0.04c0,2.14,2.06,3.23,3.98,3.23\n\t\t\tc1.96,0,3.23-0.97,3.94-1.96v1.72h0.97v-6.42C109.62,86.76,107.96,85.39,105.32,85.39z M108.67,91.99c0,1.88-1.8,3.17-3.9,3.17\n\t\t\tc-1.57,0-2.99-0.87-2.99-2.36v-0.04c0-1.43,1.21-2.4,3.39-2.4c1.47,0,2.62,0.24,3.49,0.47V91.99z","key":6}),React.createElement("polygon",{"style":{"fill":"#4B7637"},"points":"195.02,82.26 194.29,84.11 193.55,82.26 192.88,82.26 192.88,84.95 193.36,84.95 193.36,83.15 \n\t\t\t194.07,84.91 194.08,84.95 194.45,84.95 195.17,83.16 195.17,84.95 195.68,84.95 195.68,82.26 \t\t","key":7}),React.createElement("polygon",{"style":{"fill":"#4B7637"},"points":"190.47,82.71 191.25,82.71 191.25,84.95 191.78,84.95 191.78,82.71 192.55,82.71 192.55,82.26 \n\t\t\t190.47,82.26 \t\t","key":8}),React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M176.76,95.16c-2.36,0-4.24-1.98-4.24-4.46v-0.04c0-2.46,1.82-4.42,4.16-4.42c1.53,0,2.53,0.78,3.42,1.68\n\t\t\tl0.71-0.72c-0.97-1.01-2.18-1.9-4.12-1.9c-2.95,0-5.25,2.5-5.25,5.39v0.04c0,2.89,2.28,5.35,5.25,5.35c1.87,0,3.11-0.83,4.15-2\n\t\t\tl-0.65-0.64C179.34,94.41,178.21,95.16,176.76,95.16z","key":9}),React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M121.81,87.61c-0.85-1.21-2.24-2.3-4.3-2.3c-2.48,0-4.95,1.92-4.95,4.88v0.04c0,2.95,2.46,4.84,4.95,4.84\n\t\t\tc2.04,0,3.41-1.11,4.3-2.38v1.49c0,2.65-1.68,4-4.04,4c-1.46,0-2.83-0.47-4.03-1.36l-0.71,0.72c1.41,1.05,3.01,1.57,4.72,1.57\n\t\t\tc2.92,0,5.04-1.74,5.04-4.86v-8.7h-0.99V87.61z M121.87,90.22c0,2.34-2.12,3.92-4.26,3.92c-2.12,0-3.98-1.61-3.98-3.94v-0.04\n\t\t\tc0-2.4,1.82-3.9,3.98-3.9c2.14,0,4.26,1.53,4.26,3.92V90.22z","key":10}),React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M131.09,85.31c-1.88,0-3.03,0.95-3.71,2.16v-1.92h-0.99v10.3h0.99v-5.96c0-2.14,1.55-3.67,3.57-3.67\n\t\t\tc2.08,0,3.27,1.39,3.27,3.51v6.12h0.99v-6.3C135.21,87.09,133.69,85.31,131.09,85.31z","key":11}),React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M164.67,86.46l-0.91-0.91h-2.69v-3.29h-0.99V93.2c0,1.96,1.29,2.83,2.89,2.83c0.65,0,1.15-0.12,1.67-0.36\n\t\t\tv-0.93c-0.58,0.26-1.01,0.36-1.51,0.36c-1.19,0-2.06-0.53-2.06-2v-6.64H164.67z","key":12}),React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M154.06,90.11c-1.48-0.43-2.87-0.85-2.87-2v-0.04c0-1.03,0.93-1.8,2.34-1.8c1.02,0,2.07,0.36,2.98,0.91\n\t\t\tl0.71-0.71c-1.03-0.68-2.42-1.13-3.65-1.13c-2,0-3.39,1.19-3.39,2.85v0.04c0,1.84,1.85,2.34,3.53,2.83\n\t\t\tc1.43,0.41,2.73,0.85,2.73,2.06v0.04c0,1.19-1.09,1.96-2.48,1.96c-1.27,0-2.48-0.45-3.58-1.27l-0.7,0.7\n\t\t\tc1.09,0.89,2.73,1.49,4.22,1.49c1.98,0,3.55-1.17,3.55-3.01V93C157.45,91.18,155.71,90.58,154.06,90.11z","key":13}),React.createElement("path",{"style":{"fill":"#4B7637"},"d":"M142.82,85.31c-3.07,0-5.31,2.5-5.31,5.39v0.04c0,2.89,2.22,5.35,5.27,5.35c3.07,0,5.31-2.5,5.31-5.39v-0.04\n\t\t\tC148.09,87.77,145.86,85.31,142.82,85.31z M147.02,90.74c0,2.42-1.76,4.42-4.2,4.42c-2.38,0-4.24-1.98-4.24-4.46v-0.04\n\t\t\tc0-2.42,1.76-4.42,4.2-4.42c2.38,0,4.24,1.98,4.24,4.46V90.74z","key":14})])]));
	}
	
	Quest.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Quest;
	
	Quest.default = Quest;


/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Ricoh (props) {
	    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{ style=\"fill:#D91E48;\"fill:#D91E48;}\n"),React.createElement("g",{"key":1},[React.createElement("path",{"style":{"fill":"#D91E48"},"d":"M78.5,75c0,6.82,5.05,11.85,13.48,11.85c3.56,0,6.92-0.56,10.39-2.18l3.15,4.31\n\t\tc-4.36,2.31-8.56,3.51-15.02,3.51c-13.46,0-23.35-6.48-23.35-17.49v0c0-11,9.9-17.49,23.35-17.49c6.45,0,10.16,0.94,14.71,2.89\n\t\tl-3.24,4.96c-3.44-1.83-6.44-2.21-10-2.21C83.55,63.16,78.5,68.18,78.5,75","key":0}),React.createElement("path",{"style":{"fill":"#D91E48"},"d":"M129.85,57.51c-13.03,0-22.43,6.49-22.43,17.49c0,11.01,9.4,17.49,22.43,17.49c13.03,0,22.43-6.48,22.43-17.49\n\t\tC152.28,63.99,142.89,57.51,129.85,57.51z M129.85,87.05c-7.17,0-11.13-5.38-11.13-12.05s3.96-12.05,11.13-12.05\n\t\tc7.17,0,11.13,5.38,11.13,12.05S137.02,87.05,129.85,87.05z","key":1}),React.createElement("polygon",{"style":{"fill":"#D91E48"},"points":"186.16,77.53 186.16,91.61 196.93,91.61 196.93,58.39 186.16,58.39 186.16,71.05 169.7,71.05 \n\t\t169.7,58.39 158.96,58.39 158.96,91.61 169.7,91.61 169.7,77.53 \t","key":2}),React.createElement("rect",{"x":"49.32","y":"58.39","style":{"fill":"#D91E48"},"width":"11.34","height":"33.22","key":3}),React.createElement("path",{"style":{"fill":"#D91E48"},"d":"M16.79,73.59l0,3.18c5.34,4.12,10.77,9.61,14.76,14.84h12.69c-4.42-5.19-11.19-11.35-16.18-14.45\n\t\tc5.86-0.24,12.39-2.62,12.39-9.34c0-8.63-9.22-10.21-18.54-10.21c-7.62,0-14.64,0.35-18.83,0.69v33.3h10.58v-28.3\n\t\tc1.96-0.21,4.06-0.44,8.31-0.44c5.45,0,8.21,1.8,8.21,4.95C30.16,70.5,29.02,73.71,16.79,73.59z","key":4})])]);
	}
	
	Ricoh.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Ricoh;
	
	Ricoh.default = Ricoh;


/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Sothebys (props) {
	    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M15.6,88.58c-2.89,0-5.45-0.72-7.33-1.69l-1.88,1.69H5.52L4.94,77.87l1.01-0.1c3.04,6.95,6.61,9.16,9.93,9.16\n\t\tc3.47,0,5.5-2.26,5.5-5.3c0-2.89-1.11-4.29-5.64-6.17c-1.54-0.63-3.33-1.25-4.82-1.98c-3.38-1.69-5.16-4.34-5.16-7.86\n\t\tc0-5.74,4.97-9.21,9.84-9.21c2.41,0,4.05,0.68,5.64,1.59l1.88-1.64h0.82l0.82,9.45l-0.97,0.15c-2.65-5.31-5.5-7.91-8.63-7.91\n\t\tc-2.75,0-4.58,1.83-4.58,4.68c0,2.27,0.96,4,4.39,5.5c1.69,0.77,3.67,1.45,5.45,2.32c3.91,1.88,5.74,4.34,5.74,7.91\n\t\tC26.16,84.81,20.8,88.58,15.6,88.58","key":0}),React.createElement("path",{"d":"M41.11,66.68c-3.38,0-5.45,3.76-5.45,10.37c0,6.51,2.22,10.22,5.64,10.22c3.52,0,5.45-3.76,5.45-10.37\n\t\tC46.75,70.4,44.68,66.68,41.11,66.68 M40.91,88.62c-7.33,0-10.95-5.26-10.95-11.67c0-5.93,4.15-11.62,11.57-11.62\n\t\tc7.33,0,10.85,5.21,10.85,11.57C52.39,82.89,48.34,88.62,40.91,88.62","key":1}),React.createElement("path",{"d":"M62.86,88.43c-3.81,0-5.02-1.88-5.02-5.35V68.66h-3.57v-0.67l4.44-3.52l3.52-4.58h0.72v6.27h7.33v2.51h-7.33v12.49\n\t\tc0,1.93,0.29,3.09,1.25,3.76c0.82,0.58,1.93,0.77,3.52,0.77c0.77,0,1.74-0.05,2.65-0.1l0.05,0.68\n\t\tC68.55,87.42,65.46,88.43,62.86,88.43","key":2}),React.createElement("path",{"d":"M85.38,69c-1.83,0-3.23,0.34-5.02,1.21v15.96l2.7,1.01v0.68h-10.9v-0.68l3.04-1.01V57.04l-3.33-2.17v-0.48l8.29-2.27\n\t\tl0.19,0.15v16.88l0.19,0.1c2.85-2.7,5.45-3.91,8.05-3.91c4.34,0,6.17,3.28,6.17,6.7v14.13l3.04,1.01v0.68h-10.9v-0.68l2.7-1.01\n\t\tV74.01C89.63,70.88,88.37,69,85.38,69","key":3}),React.createElement("path",{"d":"M114.56,73.67c-0.19-4.53-1.5-6.99-4.34-6.99c-2.8,0-4.97,2.94-5.21,7.43L114.56,73.67z M104.97,75.31\n\t\tc0,6.13,1.74,10.13,7.18,10.13c2.41,0,4.39-0.48,7.28-1.54l0.29,0.58c-2.94,2.56-6.22,4.15-9.31,4.15\n\t\tc-6.61,0-10.95-4.53-10.95-11.24c0-6.9,5.21-12.06,11.09-12.06c6.37,0,9.45,4.29,9.4,9.98H104.97z","key":4}),React.createElement("path",{"d":"M133.61,68.71c-1.45,0-2.65,0.29-3.81,0.77v15.29c1.49,1.54,3.42,2.22,5.26,2.22c2.84,0,5.21-2.55,5.21-9.35\n\t\tC140.27,71.65,137.71,68.71,133.61,68.71 M132.79,88.62c-2.51,0-5.83-0.58-8.15-1.25V57.04l-3.38-2.17v-0.48l8.34-2.27l0.19,0.14\n\t\tv16.15l0.19,0.1c1.69-1.69,4-3.18,6.99-3.18c4.58,0,8.73,4.19,8.73,11.09C145.72,83.32,140.51,88.62,132.79,88.62","key":5}),React.createElement("path",{"d":"M158.93,89.35c-2.41,5.93-4.68,8.54-7.67,8.54c-2.56,0-3.76-1.49-3.76-3.04c0-1.49,1.35-2.75,2.89-2.75\n\t\tc1.64,0,2.6,0.87,3.76,2.31c0.91-1.01,2.02-2.75,2.65-4.1l0.82-1.83l-8.54-20.59l-2.94-1.16V66.1h11.77v0.63l-3.09,1.16l5.21,14.13\n\t\th0.24l4.73-13.79l-2.8-1.5V66.1h8.29v0.63l-3.13,1.59L158.93,89.35z","key":6}),React.createElement("path",{"d":"M186.43,88.62c-2.65,0-4.92-0.43-7.14-1.3l-0.05-6.37l0.97-0.1c2.6,4.58,4.58,6.32,7.14,6.32c2.27,0,3.67-1.44,3.67-3.66\n\t\tc0-2.51-2.56-3.47-5.31-4.58c-3.04-1.3-6.27-2.75-6.27-6.75c0-3.81,3.38-6.85,8.29-6.85c1.88,0,4.53,0.39,5.84,0.87l0.15,5.74\n\t\tl-0.92,0.24c-2.36-3.91-3.91-5.4-6.13-5.4c-2.02,0-3.28,1.35-3.28,3.09c0,2.51,2.6,3.52,5.35,4.63c3.04,1.25,6.32,2.7,6.32,6.8\n\t\tC195.06,85.78,191.11,88.62,186.43,88.62","key":7}),React.createElement("polygon",{"points":"175.51,62.05 170.99,72.99 172.05,72.99 180.64,62.05 \t","key":8})]));
	}
	
	Sothebys.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = Sothebys;
	
	Sothebys.default = Sothebys;


/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function SteveMadden (props) {
	    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polygon",{"style":{"fill":"#231F20"},"points":"22.63,89.53 22.63,64.54 17.53,64.54 17.53,60.47 32.39,60.47 32.39,64.54 27.36,64.54 27.36,89.53 \t\n\t\t","key":0}),React.createElement("polygon",{"style":{"fill":"#231F20"},"points":"34.88,60.47 47,60.47 47,64.54 39.61,64.54 39.61,71.51 45.34,71.51 45.34,75.58 39.61,75.58 \n\t\t39.61,85.46 47.62,85.46 47.62,89.53 34.88,89.53 \t","key":1}),React.createElement("polygon",{"style":{"fill":"#231F20"},"points":"53.8,89.53 49.03,60.47 54.01,60.47 56.63,80.56 59.24,60.47 64.22,60.47 59.45,89.53 \t","key":2}),React.createElement("polygon",{"style":{"fill":"#231F20"},"points":"66.67,60.47 78.79,60.47 78.79,64.54 71.4,64.54 71.4,71.51 77.13,71.51 77.13,75.58 71.4,75.58 \n\t\t71.4,85.46 79.41,85.46 79.41,89.53 66.67,89.53 \t","key":3}),React.createElement("polygon",{"style":{"fill":"#231F20"},"points":"99.88,89.53 96.47,67.65 96.26,67.65 96.51,71.51 96.51,89.53 91.78,89.53 91.78,60.47 99.25,60.47 \n\t\t102.03,79.23 102.2,79.23 104.98,60.47 112.45,60.47 112.45,89.53 107.72,89.53 107.72,71.51 107.97,67.65 107.76,67.65 \n\t\t104.36,89.53 \t","key":4}),React.createElement("path",{"style":{"fill":"#231F20"},"d":"M126.52,89.53l-0.83-5.35h-5.06l-0.83,5.35h-4.9l5.35-29.05h5.81l5.35,29.05H126.52z M125.15,80.1l-1.95-11.58\n\t\th-0.08l-1.95,11.58H125.15z","key":5}),React.createElement("path",{"style":{"fill":"#231F20"},"d":"M6.49,79.86v2.61c0,1.41,0.12,1.95,0.29,2.28c0.46,1,1.29,1.12,2.07,1.12c0.5,0,1.33-0.04,1.83-0.58\n\t\tc0.41-0.5,0.46-1.41,0.46-1.95v-1.91c0-1.16-0.41-2.28-1.49-3.28l-4.86-4.48c-0.75-0.71-1.41-1.37-1.95-2.28\n\t\tc-0.71-1.2-0.95-2.41-0.95-3.74v-2.32c0-1.37,0.66-2.74,1.58-3.61c1.66-1.54,4.4-1.66,5.44-1.66c1.66,0,3.65,0.25,5.19,1.74\n\t\tc1.54,1.49,1.66,3.32,1.66,4.44v2.95h-4.73v-2.41c0-0.66,0.04-1.33-0.54-1.99c-0.42-0.46-0.96-0.66-1.62-0.66\n\t\tc-0.58,0-1.33,0.17-1.74,0.58c-0.46,0.46-0.5,1-0.5,1.54v1.33c0,1.04,0.29,1.58,1.16,2.37l4.86,4.44c1.58,1.45,3.24,3.07,3.24,6.14\n\t\tv3.32c0,1.37-0.17,2.99-1.66,4.44c-1.54,1.49-3.36,1.66-5.11,1.66c-1.54,0-3.28-0.25-4.86-1.33c-2.16-1.49-2.49-3.69-2.49-5.15\n\t\tv-3.61H6.49z","key":6}),React.createElement("path",{"style":{"fill":"#231F20"},"d":"M133.87,60.47h8.93c0.91,0,2.57,0.08,3.94,1.41c1.58,1.54,1.58,3.4,1.58,5.15v15.52c0,1.7-0.12,3.99-1.91,5.6\n\t\tc-1.33,1.25-2.91,1.37-4.07,1.37h-8.47V60.47z M140.93,85.58c1.16,0,1.91-0.54,2.2-1c0.42-0.58,0.46-1.95,0.46-2.61v-14.2\n\t\tc0-0.75,0.04-1.74-0.5-2.45c-0.54-0.71-1.24-0.79-1.95-0.79h-2.53v21.04H140.93z","key":7}),React.createElement("path",{"style":{"fill":"#231F20"},"d":"M151.09,60.47h8.93c0.91,0,2.57,0.08,3.94,1.41c1.58,1.54,1.58,3.4,1.58,5.15v15.52c0,1.7-0.12,3.99-1.91,5.6\n\t\tc-1.33,1.25-2.91,1.37-4.07,1.37h-8.47V60.47z M158.15,85.58c1.16,0,1.91-0.54,2.2-1c0.42-0.58,0.46-1.95,0.46-2.61v-14.2\n\t\tc0-0.75,0.04-1.74-0.5-2.45c-0.54-0.71-1.24-0.79-1.95-0.79h-2.53v21.04H158.15z","key":8}),React.createElement("polygon",{"style":{"fill":"#231F20"},"points":"168.32,60.47 180.44,60.47 180.44,64.54 173.05,64.54 173.05,71.51 178.78,71.51 178.78,75.58 \n\t\t173.05,75.58 173.05,85.46 181.06,85.46 181.06,89.53 168.32,89.53 \t","key":9}),React.createElement("polygon",{"style":{"fill":"#231F20"},"points":"193.18,89.53 188.24,72.39 188.08,72.43 188.28,75.71 188.28,89.53 183.55,89.53 183.55,60.47 \n\t\t188.78,60.47 193.64,76.87 193.76,76.87 193.51,73.8 193.51,60.47 198.24,60.47 198.24,89.53 \t","key":10})]));
	}
	
	SteveMadden.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 150","style":{"enableBackground":"new 0 0 200 150"},"xmlSpace":"preserve"};
	
	module.exports = SteveMadden;
	
	SteveMadden.default = SteveMadden;


/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ArrowRightBlack (props) {
	    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"square"},React.createElement("g",{"id":"home","transform":"translate(-789.000000, -4075.000000)","stroke":"#454D58"},React.createElement("g",{"id":"Group-27-Copy","transform":"translate(790.000000, 4074.000000)"},[React.createElement("path",{"d":"M0,13 L34,13","id":"Line-5","key":0}),React.createElement("g",{"id":"Group-26","transform":"translate(22.000000, 0.000000)","key":1},[React.createElement("path",{"d":"M-1.78248558,7 L15.2175144,7","id":"Line-5","transform":"translate(6.717514, 7.000000) rotate(-315.000000) translate(-6.717514, -7.000000) ","key":0}),React.createElement("path",{"d":"M-1.78248558,19 L15.2175144,19","id":"Line-5","transform":"translate(6.717514, 19.000000) rotate(-225.000000) translate(-6.717514, -19.000000) ","key":1})])]))));
	}
	
	ArrowRightBlack.defaultProps = {"width":"37px","height":"24px","viewBox":"0 0 37 24","version":"1.1"};
	
	module.exports = ArrowRightBlack;
	
	ArrowRightBlack.default = ArrowRightBlack;


/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function ArrowRightWhite (props) {
	    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"square"},React.createElement("g",{"id":"home","transform":"translate(-789.000000, -4075.000000)","stroke":"#FFFFFF"},React.createElement("g",{"id":"Group-27-Copy","transform":"translate(790.000000, 4074.000000)"},[React.createElement("path",{"d":"M0,13 L34,13","id":"Line-5","key":0}),React.createElement("g",{"id":"Group-26","transform":"translate(22.000000, 0.000000)","key":1},[React.createElement("path",{"d":"M-1.78248558,7 L15.2175144,7","id":"Line-5","transform":"translate(6.717514, 7.000000) rotate(-315.000000) translate(-6.717514, -7.000000) ","key":0}),React.createElement("path",{"d":"M-1.78248558,19 L15.2175144,19","id":"Line-5","transform":"translate(6.717514, 19.000000) rotate(-225.000000) translate(-6.717514, -19.000000) ","key":1})])]))));
	}
	
	ArrowRightWhite.defaultProps = {"width":"37px","height":"24px","viewBox":"0 0 37 24","version":"1.1"};
	
	module.exports = ArrowRightWhite;
	
	ArrowRightWhite.default = ArrowRightWhite;


/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function B2b (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"B2B."),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2},React.createElement("rect",{"id":"path-1","x":"0","y":"0","width":"367","height":"61"})),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"B2B.","transform":"translate(-16.000000, 0.000000)"},React.createElement("path",{"d":"M61.0039993,22.0380005 L61.0059998,22.0389999 C67.6020004,25.1660004 71.7410004,31.4290009 71.7410004,39.0680008 C71.7410004,50.4100006 61.9529999,59.001001 49.0319992,59.001001 L16.7679993,59.001001 L16.7679993,-10.998999 L48.3859985,-10.998999 C60.797998,-10.998999 69.8549988,-3.42599945 69.8549988,6.91600037 C69.8549988,13.1710007 66.3519989,18.7980011 61.0039993,22.0380005 Z M51.5529999,10.1100006 L51.5519989,10.1100006 C51.5519989,6.47700043 49.0639984,4.01600037 45.0309982,4.01600037 L35.2859985,4.01600037 L35.2859985,16.2040009 L45.0319992,16.2040009 C49.0649994,16.2040009 51.5529999,13.7430008 51.5529999,10.1100006 Z M45.7609985,43.1680008 C49.936998,43.1680008 52.6669983,40.5499985 52.6669983,36.773999 C52.6669983,33.0559998 49.936998,30.4380005 45.7609985,30.4380005 L35.2849991,30.4380005 L35.2849991,43.1680008 L45.7609985,43.1680008 Z M109.239191,43.2279999 L127.727188,43.2279999 L127.727188,59 L78.2671877,59 L78.2671877,54.9520004 C105.024188,23.3940002 108.709189,18.2940002 108.709189,12.5850006 C108.709189,8.97900085 106.33319,6.56100159 102.92719,6.56100159 C99.1941896,6.56100159 96.9181902,9.07900085 96.9181902,13.0820007 L96.9181902,14.3670013 L79.3391908,14.3670013 L79.3391908,13.137001 C79.3391908,-0.308999634 88.1521913,-9.19700012 102.712192,-9.19700012 C116.818192,-9.19700012 126.558191,-0.524000549 126.558191,11.9610001 C126.558191,20.3289993 123.46219,26.7529999 109.239191,43.2279999 Z M183.55638,22.0380005 L183.55838,22.0389999 C190.154381,25.1660004 194.293381,31.4290009 194.293381,39.0680008 C194.293381,50.4100006 184.505381,59.001001 171.58438,59.001001 L139.32038,59.001001 L139.32038,-10.998999 L170.938379,-10.998999 C183.350379,-10.998999 192.407379,-3.42599945 192.407379,6.91600037 C192.407379,13.1710007 188.90438,18.7980011 183.55638,22.0380005 Z M174.105381,10.1100006 L174.10438,10.1100006 C174.10438,6.47700043 171.616379,4.01600037 167.583379,4.01600037 L157.838379,4.01600037 L157.838379,16.2040009 L167.58438,16.2040009 C171.61738,16.2040009 174.105381,13.7430008 174.105381,10.1100006 Z M168.313379,43.1680008 C172.489379,43.1680008 175.219379,40.5499985 175.219379,36.773999 C175.219379,33.0559998 172.489379,30.4380005 168.313379,30.4380005 L157.83738,30.4380005 L157.83738,43.1680008 L168.313379,43.1680008 Z M203.291572,59 L203.291572,41.7210007 L221.334571,41.7210007 L221.334571,59 L203.291572,59 Z","stroke":"#FFFFFF","fillOpacity":"0","fill":"#FFFFFF","fillRule":"nonzero"})))]);
	}
	
	B2b.defaultProps = {"width":"206px","height":"60px","viewBox":"0 0 206 60","version":"1.1"};
	
	module.exports = B2b;
	
	B2b.default = B2b;


/***/ }),

/***/ 902:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function B2c (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"B2C."),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2},React.createElement("rect",{"id":"path-1","x":"0","y":"0","width":"361","height":"71"})),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","opacity":"0.70203218","key":3},React.createElement("g",{"id":"B2C.","transform":"translate(-10.000000, 0.000000)"},React.createElement("path",{"d":"M55.0039993,23.0380005 L55.0059998,23.0389999 C61.6020004,26.1660004 65.7410004,32.4290009 65.7410004,40.0680008 C65.7410004,51.4100006 55.9529999,60.001001 43.0319992,60.001001 L10.7679993,60.001001 L10.7679993,-9.99899902 L42.3859985,-9.99899902 C54.797998,-9.99899902 63.8549988,-2.42599945 63.8549988,7.91600037 C63.8549988,14.1710007 60.3519989,19.7980011 55.0039993,23.0380005 Z M45.5529999,11.1100006 L45.5519989,11.1100006 C45.5519989,7.47700043 43.0639984,5.01600037 39.0309982,5.01600037 L29.2859985,5.01600037 L29.2859985,17.2040009 L39.0319992,17.2040009 C43.0649994,17.2040009 45.5529999,14.7430008 45.5529999,11.1100006 Z M39.7609985,44.1680008 C43.936998,44.1680008 46.6669983,41.5499985 46.6669983,37.773999 C46.6669983,34.0559998 43.936998,31.4380005 39.7609985,31.4380005 L29.2849991,31.4380005 L29.2849991,44.1680008 L39.7609985,44.1680008 Z M103.239191,44.2279999 L121.727188,44.2279999 L121.727188,60 L72.2671877,60 L72.2671877,55.9520004 C99.0241884,24.3940002 102.709189,19.2940002 102.709189,13.5850006 C102.709189,9.97900085 100.33319,7.56100159 96.9271898,7.56100159 C93.1941896,7.56100159 90.9181902,10.0790009 90.9181902,14.0820007 L90.9181902,15.3670013 L73.3391908,15.3670013 L73.3391908,14.137001 C73.3391908,0.691000366 82.1521913,-8.19700012 96.7121919,-8.19700012 C110.818192,-8.19700012 120.558191,0.475999451 120.558191,12.9610001 C120.558191,21.3289993 117.46219,27.7529999 103.239191,44.2279999 Z M166.891381,61.7699997 L166.891381,61.7709976 C145.585381,61.7709976 129.673381,45.997998 129.673381,25.0589981 C129.673381,4.0039978 145.585381,-11.7690018 166.891381,-11.7690018 C185.23638,-11.7690018 199.44538,0.339997864 202.29038,18.0889984 L182.75138,18.0889984 C180.34838,10.9099991 174.30038,6.24899902 166.93338,6.24899902 C157.021381,6.24899902 149.751381,14.2189987 149.751381,25.0579987 C149.751381,35.8549988 157.021381,43.7099991 166.93338,43.7099991 C174.70038,43.7099991 180.80638,38.648999 182.76738,30.8699997 L202.491381,30.8699997 C199.830381,49.2759995 185.53638,61.7699997 166.891381,61.7699997 Z M208.491572,60 L208.491572,42.7210007 L226.534571,42.7210007 L226.534571,60 L208.491572,60 Z","stroke":"#FFFFFF","fillOpacity":"0","fill":"#D8D8D8","fillRule":"nonzero"})))]);
	}
	
	B2c.defaultProps = {"width":"218px","height":"63px","viewBox":"0 0 218 63","version":"1.1"};
	
	module.exports = B2c;
	
	B2c.default = B2c;


/***/ }),

/***/ 903:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function B2e (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"B2E."),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2},React.createElement("rect",{"id":"path-1","x":"0","y":"0","width":"310","height":"74"})),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","opacity":"0.45","key":3},React.createElement("g",{"id":"B2E.","transform":"translate(-8.000000, 0.000000)"},React.createElement("path",{"d":"M53.0039993,22.0380005 L53.0059998,22.0389999 C59.6020004,25.1660004 63.7410004,31.4290009 63.7410004,39.0680008 C63.7410004,50.4100006 53.9529999,59.001001 41.0319992,59.001001 L8.76799927,59.001001 L8.76799927,-10.998999 L40.3859985,-10.998999 C52.797998,-10.998999 61.8549988,-3.42599945 61.8549988,6.91600037 C61.8549988,13.1710007 58.3519989,18.7980011 53.0039993,22.0380005 Z M43.5529999,10.1100006 L43.5519989,10.1100006 C43.5519989,6.47700043 41.0639984,4.01600037 37.0309982,4.01600037 L27.2859985,4.01600037 L27.2859985,16.2040009 L37.0319992,16.2040009 C41.0649994,16.2040009 43.5529999,13.7430008 43.5529999,10.1100006 Z M37.7609985,43.1680008 C41.936998,43.1680008 44.6669983,40.5499985 44.6669983,36.773999 C44.6669983,33.0559998 41.936998,30.4380005 37.7609985,30.4380005 L27.2849991,30.4380005 L27.2849991,43.1680008 L37.7609985,43.1680008 Z M101.239191,43.2279999 L119.727188,43.2279999 L119.727188,59 L70.2671877,59 L70.2671877,54.9520004 C97.0241884,23.3940002 100.709189,18.2940002 100.709189,12.5850006 C100.709189,8.97900085 98.3331896,6.56100159 94.9271898,6.56100159 C91.1941896,6.56100159 88.9181902,9.07900085 88.9181902,13.0820007 L88.9181902,14.3670013 L71.3391908,14.3670013 L71.3391908,13.137001 C71.3391908,-0.308999634 80.1521913,-9.19700012 94.7121919,-9.19700012 C108.818192,-9.19700012 118.558191,-0.524000549 118.558191,11.9610001 C118.558191,20.3289993 115.46219,26.7529999 101.239191,43.2279999 Z M150.518381,42.2729996 L176.955381,42.2730011 L176.955381,59.0000015 L131.318381,59.0000015 L131.318381,-10.9999985 L176.109381,-10.9999985 L176.109381,5.67000122 L150.518381,5.67000122 L150.518381,15.976001 L173.509381,15.976001 L173.509381,31.7940002 L150.518381,31.7940002 L150.518381,42.2729996 Z M186.891572,59 L186.891572,41.7210007 L204.934571,41.7210007 L204.934571,59 L186.891572,59 Z","stroke":"#FFFFFF","fillOpacity":"0","fill":"#D8D8D8","fillRule":"nonzero"})))]);
	}
	
	B2e.defaultProps = {"width":"198px","height":"60px","viewBox":"0 0 198 60","version":"1.1"};
	
	module.exports = B2e;
	
	B2e.default = B2e;


/***/ }),

/***/ 904:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function B2me (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"B2ME."),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M45.0039993,33.0380005 L45.0059998,33.0389999 C51.6020004,36.1660004 55.7410004,42.4290009 55.7410004,50.0680008 C55.7410004,61.4100006 45.9529999,70.001001 33.0319992,70.001001 L0.767999268,70.001001 L0.767999268,0.00100097656 L32.3859985,0.00100097656 C44.797998,0.00100097656 53.8549988,7.57400055 53.8549988,17.9160004 C53.8549988,24.1710007 50.3519989,29.7980011 45.0039993,33.0380005 Z M35.5529999,21.1100006 L35.5519989,21.1100006 C35.5519989,17.4770004 33.0639984,15.0160004 29.0309982,15.0160004 L19.2859985,15.0160004 L19.2859985,27.2040009 L29.0319992,27.2040009 C33.0649994,27.2040009 35.5529999,24.7430008 35.5529999,21.1100006 Z M29.7609985,54.1680008 C33.936998,54.1680008 36.6669983,51.5499985 36.6669983,47.773999 C36.6669983,44.0559998 33.936998,41.4380005 29.7609985,41.4380005 L19.2849991,41.4380005 L19.2849991,54.1680008 L29.7609985,54.1680008 Z M93.2391908,54.2279999 L111.727188,54.2279999 L111.727188,70 L62.2671877,70 L62.2671877,65.9520004 C89.0241884,34.3940002 92.709189,29.2940002 92.709189,23.5850006 C92.709189,19.9790009 90.3331896,17.5610016 86.9271898,17.5610016 C83.1941896,17.5610016 80.9181902,20.0790009 80.9181902,24.0820007 L80.9181902,25.3670013 L63.3391908,25.3670013 L63.3391908,24.137001 C63.3391908,10.6910004 72.1521913,1.80299988 86.7121919,1.80299988 C100.818192,1.80299988 110.558191,10.4759995 110.558191,22.9610001 C110.558191,31.3289993 107.46219,37.7529999 93.2391908,54.2279999 Z M211.99738,70 L192.54038,70 L187.077379,29.6869995 L168.51238,70.1149994 L162.81538,70.1149994 L144.25938,29.7029999 L138.87338,70 L119.33138,70 L129.91838,0 L149.17638,0 L165.660379,38.0899994 L182.252379,0 L201.50938,0 L211.99738,70 Z M241.194571,53.2729996 L267.631571,53.2730011 L267.631571,70.0000015 L221.994571,70.0000015 L221.994571,1.52587882e-06 L266.785572,1.52587882e-06 L266.785572,16.6700012 L241.194571,16.6700012 L241.194571,26.976001 L264.185572,26.976001 L264.185572,42.7940002 L241.194571,42.7940002 L241.194571,53.2729996 Z M277.567762,70 L277.567762,52.7210007 L295.610761,52.7210007 L295.610761,70 L277.567762,70 Z","id":"B2ME.","fill":"#FFFFFF","fillRule":"nonzero"}))]);
	}
	
	B2me.defaultProps = {"width":"296px","height":"71px","viewBox":"0 0 296 71","version":"1.1"};
	
	module.exports = B2me;
	
	B2me.default = B2me;


/***/ }),

/***/ 232:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"info":"src-components-address-home----address-home-module---info---36ePL","list":"src-components-address-home----address-home-module---list---1mXUt","item":"src-components-address-home----address-home-module---item---24sxd","desktopTel":"src-components-address-home----address-home-module---desktopTel---2lnQP","mobileTel":"src-components-address-home----address-home-module---mobileTel---39cH1"};

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _newJerseyHome = __webpack_require__(274);
	
	var _newJerseyHome2 = _interopRequireDefault(_newJerseyHome);
	
	var _newYorkHome = __webpack_require__(275);
	
	var _newYorkHome2 = _interopRequireDefault(_newYorkHome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddressHome = function AddressHome(_ref) {
	  var location = _ref.location;
	
	  switch (location) {
	    case 'new_jersey':
	      return _react2.default.createElement(_newJerseyHome2.default, null);
	      break;
	    case 'new_york':
	      return _react2.default.createElement(_newYorkHome2.default, null);
	      break;
	    default:
	      break;
	  }
	};
	
	AddressHome.propTypes = {
	  location: _propTypes2.default.string
	};
	
	exports.default = AddressHome;
	module.exports = exports['default'];

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFittext = __webpack_require__(7);
	
	var _reactFittext2 = _interopRequireDefault(_reactFittext);
	
	var _addressHomeModule = __webpack_require__(232);
	
	var _addressHomeModule2 = _interopRequireDefault(_addressHomeModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewJerseyHome = function NewJerseyHome() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactFittext2.default,
	      { compressor: 0.4, maxFontSize: 50 },
	      _react2.default.createElement(
	        'div',
	        { className: _addressHomeModule2.default.info },
	        'new ',
	        _react2.default.createElement('br', null),
	        ' jersey'
	      )
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: _addressHomeModule2.default.list },
	      _react2.default.createElement(
	        'li',
	        { className: _addressHomeModule2.default.item },
	        '465 Amwell Road'
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: _addressHomeModule2.default.item },
	        'Hillsborough, NJ 08844'
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: _addressHomeModule2.default.item },
	        _react2.default.createElement(
	          'span',
	          { className: _addressHomeModule2.default.desktopTel },
	          '908-428-4700'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: 'tel:908-428-4700', className: _addressHomeModule2.default.mobileTel },
	          '908-428-4700'
	        )
	      )
	    )
	  );
	};
	
	exports.default = NewJerseyHome;
	module.exports = exports['default'];

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFittext = __webpack_require__(7);
	
	var _reactFittext2 = _interopRequireDefault(_reactFittext);
	
	var _addressHomeModule = __webpack_require__(232);
	
	var _addressHomeModule2 = _interopRequireDefault(_addressHomeModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewYorkHome = function NewYorkHome() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactFittext2.default,
	      { compressor: 0.4, maxFontSize: 50 },
	      _react2.default.createElement(
	        'div',
	        { className: _addressHomeModule2.default.info },
	        'new',
	        _react2.default.createElement('br', null),
	        ' york'
	      )
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: _addressHomeModule2.default.list },
	      _react2.default.createElement(
	        'li',
	        { className: _addressHomeModule2.default.item },
	        '79 Madison Avenue, 2nd Floor'
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: _addressHomeModule2.default.item },
	        'New York, NY 10016'
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: _addressHomeModule2.default.item },
	        _react2.default.createElement(
	          'span',
	          { className: _addressHomeModule2.default.desktopTel },
	          '646-854-6095'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: 'tel:646-854-6095', className: _addressHomeModule2.default.mobileTel },
	          '646-854-6095'
	        )
	      )
	    )
	  );
	};
	
	exports.default = NewYorkHome;
	module.exports = exports['default'];

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSpring = __webpack_require__(8);
	
	var _d3Ease = __webpack_require__(12);
	
	var easings = _interopRequireWildcard(_d3Ease);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RevealSlideDown = function (_Component) {
	  _inherits(RevealSlideDown, _Component);
	
	  function RevealSlideDown() {
	    _classCallCheck(this, RevealSlideDown);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  RevealSlideDown.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        delay = _props.delay,
	        isInView = _props.isInView;
	
	
	    var returnDelaySetting = function returnDelaySetting() {
	      return typeof delay !== 'undefined' ? delay : 300;
	    };
	
	    var animationConfig = {
	      delay: returnDelaySetting(),
	      duration: 900,
	      easing: easings.easeCubicOut
	    };
	
	    var renderChildren = function renderChildren(animation) {
	      var children = _react2.default.Children.map(_this2.props.children, function (child) {
	        return _react2.default.cloneElement(child, {
	          animation: animation,
	          isInView: isInView
	        });
	      });
	      return children;
	    };
	
	    return _react2.default.createElement(
	      _reactSpring.Spring,
	      {
	        from: { opacity: 0, transform: 'translateY(120px)' },
	        to: {
	          opacity: isInView ? 1 : 0,
	          transform: isInView ? 'translateY(0)' : 'translateY(120px)'
	        },
	        config: animationConfig
	      },
	      function (animation) {
	        return renderChildren(animation);
	      }
	    );
	  };
	
	  return RevealSlideDown;
	}(_react.Component);
	
	RevealSlideDown.propTypes = {
	  delay: _propTypes2.default.number,
	  isInView: _propTypes2.default.bool
	};
	
	exports.default = RevealSlideDown;
	module.exports = exports['default'];

/***/ }),

/***/ 161:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"btn":"src-components-button-arrow----button-arrow-module---btn---3nwWH","btnText":"src-components-button-arrow----button-arrow-module---btnText---2a2X9","btnBG":"src-components-button-arrow----button-arrow-module---btnBG---2hkt2","btnTransparent":"src-components-button-arrow----button-arrow-module---btnTransparent---1Q0Fq","explore":"src-components-button-arrow----button-arrow-module---explore---1uPO6","exploreArrow":"src-components-button-arrow----button-arrow-module---exploreArrow---3RNCe","icon":"src-components-button-arrow----button-arrow-module---icon---2t6sd"};

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _arrowRightBlack = __webpack_require__(182);
	
	var _arrowRightBlack2 = _interopRequireDefault(_arrowRightBlack);
	
	var _arrowRightWhite = __webpack_require__(184);
	
	var _arrowRightWhite2 = _interopRequireDefault(_arrowRightWhite);
	
	var _emotion = __webpack_require__(5);
	
	var _buttonArrowModule = __webpack_require__(161);
	
	var _buttonArrowModule2 = _interopRequireDefault(_buttonArrowModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonArrow = function (_Component) {
	  _inherits(ButtonArrow, _Component);
	
	  function ButtonArrow() {
	    _classCallCheck(this, ButtonArrow);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.onHover = function () {
	      _this.setState({
	        hover: true
	      });
	    };
	
	    _this.offHover = function () {
	      _this.setState({
	        hover: false
	      });
	    };
	
	    _this.state = {
	      hover: false
	    };
	    return _this;
	  }
	
	  ButtonArrow.prototype.render = function render() {
	    var _props = this.props,
	        message = _props.message,
	        url = _props.url,
	        external = _props.external;
	    var hover = this.state.hover;
	
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        {
	          className: _buttonArrowModule2.default.btn,
	          onMouseEnter: this.onHover,
	          onMouseLeave: this.offHover
	        },
	        external === true ? _react2.default.createElement(
	          'a',
	          { href: '' + url, target: '_blank', className: _buttonArrowModule2.default.btnText },
	          _react2.default.createElement('div', {
	            className: [_buttonArrowModule2.default.btnBG, _buttonArrowModule2.default.btnTransparent].join(' ')
	          }),
	          _react2.default.createElement(
	            'span',
	            { className: _buttonArrowModule2.default.explore },
	            message
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: _buttonArrowModule2.default.exploreArrow },
	            hover === true ? _react2.default.createElement(_arrowRightWhite2.default, null) : _react2.default.createElement(_arrowRightBlack2.default, null)
	          )
	        ) : _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' + url, className: _buttonArrowModule2.default.btnText },
	          _react2.default.createElement('div', { className: _buttonArrowModule2.default.btnBG }),
	          _react2.default.createElement(
	            'span',
	            { className: _buttonArrowModule2.default.explore },
	            message
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: _buttonArrowModule2.default.exploreArrow },
	            hover === true ? _react2.default.createElement(_arrowRightWhite2.default, null) : _react2.default.createElement(_arrowRightBlack2.default, null)
	          )
	        )
	      )
	    );
	  };
	
	  return ButtonArrow;
	}(_react.Component);
	
	exports.default = ButtonArrow;
	module.exports = exports['default'];

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"copywrite":"src-components-footer-copy-write----copy-write-module---copywrite---2r11L"};

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helperFunctions = __webpack_require__(10);
	
	var _copyWriteModule = __webpack_require__(163);
	
	var _copyWriteModule2 = _interopRequireDefault(_copyWriteModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CopyWrite = function CopyWrite() {
	  return _react2.default.createElement(
	    'span',
	    { className: _copyWriteModule2.default.copywrite },
	    '\xA9 ',
	    (0, _helperFunctions.fullYear)(),
	    ' JK Design. All rights reserved.'
	  );
	};
	
	exports.default = CopyWrite;
	module.exports = exports['default'];

/***/ }),

/***/ 164:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-footer----footer-module---wrapper---3e89s","container":"src-components-footer----footer-module---container---1-vt1","navigation":"src-components-footer----footer-module---navigation---1ugUX","award":"src-components-footer----footer-module---award---3IsM6","awards":"src-components-footer----footer-module---awards---2k16r","awardHome":"src-components-footer----footer-module---awardHome---373CA","menuInfo":"src-components-footer----footer-module---menuInfo---3861Z"};

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(4);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _letsChat = __webpack_require__(122);
	
	var _letsChat2 = _interopRequireDefault(_letsChat);
	
	var _footerMenu = __webpack_require__(125);
	
	var _footerMenu2 = _interopRequireDefault(_footerMenu);
	
	var _socialMenu = __webpack_require__(73);
	
	var _socialMenu2 = _interopRequireDefault(_socialMenu);
	
	var _infoMenu = __webpack_require__(126);
	
	var _infoMenu2 = _interopRequireDefault(_infoMenu);
	
	var _copyWrite = __webpack_require__(120);
	
	var _copyWrite2 = _interopRequireDefault(_copyWrite);
	
	var _footerModule = __webpack_require__(164);
	
	var _footerModule2 = _interopRequireDefault(_footerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(_ref) {
	  var footerMenuItems = _ref.footerMenuItems,
	      socialMenuItems = _ref.socialMenuItems,
	      infoMenuItems = _ref.infoMenuItems,
	      currentPage = _ref.currentPage,
	      awards = _ref.awards;
	
	  var renderAwards = function renderAwards() {
	    return awards.map(function (award, index) {
	      return _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '' + award.footer_award_link, key: index, className: _footerModule2.default.award },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          className: _footerModule2.default.awardImage,
	          outerWrapperClassName: _footerModule2.default.imageOuterWrapper,
	          sizes: award.footer_award_image.localFile.childImageSharp.sizes,
	          backgroundColor: true,
	          alt: 'jkdesign award'
	        })
	      );
	    });
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _footerModule2.default.wrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _footerModule2.default.container },
	        _react2.default.createElement(
	          'div',
	          { className: _footerModule2.default.awards },
	          renderAwards()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _footerModule2.default.navigation },
	          _react2.default.createElement(
	            'div',
	            { className: _footerModule2.default.info },
	            _react2.default.createElement(_letsChat2.default, null),
	            _react2.default.createElement(_footerMenu2.default, { footerMenuItems: footerMenuItems }),
	            _react2.default.createElement(_infoMenu2.default, { infoMenuItems: infoMenuItems }),
	            _react2.default.createElement(_copyWrite2.default, null),
	            _react2.default.createElement(_socialMenu2.default, { socialMenuItems: socialMenuItems })
	          )
	        )
	      )
	    ),
	    currentPage === '/' && _react2.default.createElement('div', { style: { height: '75px', width: '100%' } })
	  );
	};
	
	Footer.propTypes = {
	  footerMenuItems: _propTypes2.default.array,
	  socialMenuItems: _propTypes2.default.array,
	  infoMenuItems: _propTypes2.default.array,
	  currentPage: _propTypes2.default.string,
	  awards: _propTypes2.default.array
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(4);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _letsChatModule = __webpack_require__(165);
	
	var _letsChatModule2 = _interopRequireDefault(_letsChatModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LetsChat = function LetsChat() {
	  return _react2.default.createElement(
	    'div',
	    { className: _letsChatModule2.default.wrapper },
	    _react2.default.createElement(
	      'h3',
	      { className: _letsChatModule2.default.title },
	      'Ready to make an impact? ',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.jkdesign.com/contact', className: _letsChatModule2.default.link },
	        'Connect with us.'
	      )
	    )
	  );
	};
	
	exports.default = LetsChat;
	module.exports = exports['default'];

/***/ }),

/***/ 165:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-footer-lets-chat----lets-chat-module---wrapper---QxhL6","title":"src-components-footer-lets-chat----lets-chat-module---title---2OeU9","link":"src-components-footer-lets-chat----lets-chat-module---link---1zfn5","award":"src-components-footer-lets-chat----lets-chat-module---award---3CnO0"};

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-home-home-amplified----home-amplified-module---wrapper---37kzZ","wrapperIOS":"src-components-home-home-amplified----home-amplified-module---wrapperIOS---3A8xU","container":"src-components-home-home-amplified----home-amplified-module---container---F1HTR","contentWrapper":"src-components-home-home-amplified----home-amplified-module---contentWrapper---3e_D_","videoBGWrapper":"src-components-home-home-amplified----home-amplified-module---videoBGWrapper---3T2GZ","videoBG":"src-components-home-home-amplified----home-amplified-module---videoBG---3O3Bq","headline":"src-components-home-home-amplified----home-amplified-module---headline---2dLQF","bgCover":"src-components-home-home-amplified----home-amplified-module---bgCover---z33Mi","content":"src-components-home-home-amplified----home-amplified-module---content---6Dwoh","amp":"src-components-home-home-amplified----home-amplified-module---amp---3yHO3","message":"src-components-home-home-amplified----home-amplified-module---message---28i8V","videoBoxWrapper":"src-components-home-home-amplified----home-amplified-module---videoBoxWrapper---1ZjoP","videoBox":"src-components-home-home-amplified----home-amplified-module---videoBox---1cpOy","videoBoxPlacement":"src-components-home-home-amplified----home-amplified-module---videoBoxPlacement---3xz1O","headlineMobile":"src-components-home-home-amplified----home-amplified-module---headlineMobile---1dvNs","messageBreak":"src-components-home-home-amplified----home-amplified-module---messageBreak---HHvCe"};

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFittext = __webpack_require__(7);
	
	var _reactFittext2 = _interopRequireDefault(_reactFittext);
	
	var _scrollDown = __webpack_require__(28);
	
	var _scrollDown2 = _interopRequireDefault(_scrollDown);
	
	var _reactSpring = __webpack_require__(8);
	
	var _d3Ease = __webpack_require__(12);
	
	var easings = _interopRequireWildcard(_d3Ease);
	
	var _helperFunctions = __webpack_require__(10);
	
	var _homeAmplifiedModule = __webpack_require__(487);
	
	var _homeAmplifiedModule2 = _interopRequireDefault(_homeAmplifiedModule);
	
	var _videoSync = __webpack_require__(376);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeAmplified = function (_Component) {
	  _inherits(HomeAmplified, _Component);
	
	  function HomeAmplified() {
	    _classCallCheck(this, HomeAmplified);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = {
	      ready: false,
	      videoOne: null,
	      videoTwo: null
	    };
	    return _this;
	  }
	
	  HomeAmplified.prototype.componentDidMount = function componentDidMount() {
	    if (this.videoOne && this.videoTwo) {
	      this.setState({
	        ready: true,
	        videoOne: this.videoOne,
	        videoTwo: this.videoTwo
	      });
	    }
	  };
	
	  HomeAmplified.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        ready = _state.ready,
	        videoOne = _state.videoOne,
	        videoTwo = _state.videoTwo;
	
	    var animationConfig = {
	      delay: 200,
	      duration: 900,
	      easing: easings.easeCubicOut
	    };
	
	    setTimeout(function () {
	      syncAndPlay();
	    }, 3000);
	
	    var syncAndPlay = function syncAndPlay() {
	      if (ready) {
	        if (videoOne.paused) {
	          if (videoOne.ended) {
	            videoOne.currentTime = 0;
	            videoTwo.currentTime = 0;
	          }
	          videoTwo.currentTime = videoOne.currentTime;
	          var playVideoOnePromise = videoOne.play();
	          if (playVideoOnePromise !== null) {
	            playVideoOnePromise.catch(function () {
	              videoOne.play();
	            });
	          }
	        } else {
	          videoOne.pause();
	        }
	      }
	    };
	
	    (0, _videoSync.addEvent)(videoOne, 'play', function () {
	      var playVideoTwoPromise = videoTwo.play();
	      if (playVideoTwoPromise !== null) {
	        playVideoTwoPromise.catch(function () {
	          videoTwo.play();
	        });
	      }
	    });
	
	    (0, _videoSync.addEvent)(videoOne, 'pause', function () {
	      videoTwo.pause();
	    });
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _helperFunctions.detectBrowser)() === 'iOS' ? [_homeAmplifiedModule2.default.wrapper, _homeAmplifiedModule2.default.wrapperIOS].join(' ') : _homeAmplifiedModule2.default.wrapper
	        },
	        _react2.default.createElement(
	          _reactSpring.Spring,
	          {
	            from: { bottom: '0%' },
	            to: { bottom: this.state.allVideosLoaded ? '100%' : '0%' }
	          },
	          function (animation) {
	            return _react2.default.createElement('div', { className: _homeAmplifiedModule2.default.bgCover, style: animation });
	          }
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _homeAmplifiedModule2.default.contentWrapper },
	          _react2.default.createElement(
	            _reactSpring.Spring,
	            {
	              from: { opacity: 0, transform: 'translateY(120px)' },
	              to: {
	                opacity: 1,
	                transform: 'translateY(0)'
	              },
	              config: animationConfig
	            },
	            function (animation) {
	              return _react2.default.createElement(
	                'div',
	                { className: _homeAmplifiedModule2.default.content, style: animation },
	                _react2.default.createElement(
	                  'div',
	                  { className: _homeAmplifiedModule2.default.headline },
	                  _react2.default.createElement(
	                    _reactFittext2.default,
	                    { compressor: 0.5, maxFontSize: 100 },
	                    _react2.default.createElement(
	                      'h1',
	                      { className: _homeAmplifiedModule2.default.amp },
	                      'Your',
	                      _react2.default.createElement('br', null),
	                      'Brand,',
	                      _react2.default.createElement('br', null),
	                      'Amplified.'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _homeAmplifiedModule2.default.headlineMobile },
	                  _react2.default.createElement(
	                    _reactFittext2.default,
	                    { compressor: 0.45, maxFontSize: 50 },
	                    _react2.default.createElement(
	                      'h1',
	                      { className: _homeAmplifiedModule2.default.amp },
	                      'Your',
	                      _react2.default.createElement('br', null),
	                      'Brand,',
	                      _react2.default.createElement('br', null),
	                      'Amplified.'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  { className: _homeAmplifiedModule2.default.message },
	                  'We\u2019re a creative marketing agency.',
	                  _react2.default.createElement('span', { className: _homeAmplifiedModule2.default.messageBreak }),
	                  ' And we\u2019re here to help you make an impact.'
	                )
	              );
	            }
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _homeAmplifiedModule2.default.videoBoxWrapper },
	            (0, _helperFunctions.isMobileDevice)() ? null : _react2.default.createElement(
	              'div',
	              { className: _homeAmplifiedModule2.default.videoBox },
	              _react2.default.createElement(
	                'div',
	                { className: _homeAmplifiedModule2.default.videoBoxPlacement },
	                _react2.default.createElement(
	                  'video',
	                  {
	                    preload: 'auto',
	                    ref: function ref(videoTwo) {
	                      return _this2.videoTwo = videoTwo;
	                    },
	                    muted: 'muted',
	                    loop: true
	                  },
	                  _react2.default.createElement('source', { src: 'https://jk-wp.jkstaging.com/wp-content/uploads/2019/07/foreground_half.mp4' })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_scrollDown2.default, { color: 'white' }),
	        _react2.default.createElement(
	          'div',
	          {
	            className: _homeAmplifiedModule2.default.videoBGWrapper,
	            style: { background: '#5105c1' }
	          },
	          (0, _helperFunctions.isMobileDevice)() ? null : _react2.default.createElement(
	            'video',
	            {
	              className: _homeAmplifiedModule2.default.videoBG,
	              preload: 'auto',
	              ref: function ref(videoOne) {
	                return _this2.videoOne = videoOne;
	              },
	              muted: 'muted',
	              loop: true
	            },
	            _react2.default.createElement('source', { src: 'https://jk-wp.jkstaging.com/wp-content/uploads/2019/07/background_half.mp4' })
	          )
	        )
	      )
	    );
	  };
	
	  return HomeAmplified;
	}(_react.Component);
	
	exports.default = HomeAmplified;
	module.exports = exports['default'];

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-home-home-approach----home-approach-module---wrapper---wdvap","container":"src-components-home-home-approach----home-approach-module---container---2yrhL","message":"src-components-home-home-approach----home-approach-module---message---3KvVo","title":"src-components-home-home-approach----home-approach-module---title---1ZVhu","content":"src-components-home-home-approach----home-approach-module---content---1_fup","description":"src-components-home-home-approach----home-approach-module---description---V7LnN"};

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFittext = __webpack_require__(7);
	
	var _reactFittext2 = _interopRequireDefault(_reactFittext);
	
	var _homeSectionTitle = __webpack_require__(72);
	
	var _homeSectionTitle2 = _interopRequireDefault(_homeSectionTitle);
	
	var _reveal = __webpack_require__(9);
	
	var _reveal2 = _interopRequireDefault(_reveal);
	
	var _revealSlideDown = __webpack_require__(15);
	
	var _revealSlideDown2 = _interopRequireDefault(_revealSlideDown);
	
	var _gradientBgTransition = __webpack_require__(34);
	
	var _gradientBgTransition2 = _interopRequireDefault(_gradientBgTransition);
	
	var _homeApproachModule = __webpack_require__(488);
	
	var _homeApproachModule2 = _interopRequireDefault(_homeApproachModule);
	
	var _b2me = __webpack_require__(904);
	
	var _b2me2 = _interopRequireDefault(_b2me);
	
	var _b2b = __webpack_require__(901);
	
	var _b2b2 = _interopRequireDefault(_b2b);
	
	var _b2c = __webpack_require__(902);
	
	var _b2c2 = _interopRequireDefault(_b2c);
	
	var _b2e = __webpack_require__(903);
	
	var _b2e2 = _interopRequireDefault(_b2e);
	
	var _reactSpring = __webpack_require__(8);
	
	var _d3Ease = __webpack_require__(12);
	
	var easings = _interopRequireWildcard(_d3Ease);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Description = function Description(props) {
	  var animation = props.animation;
	
	  return _react2.default.createElement(
	    _reactFittext2.default,
	    { compressor: 1.35, minFontSize: 16, maxFontSize: 26 },
	    _react2.default.createElement(
	      'p',
	      { className: _homeApproachModule2.default.description, style: animation },
	      'Whether it\u2019s B2B, B2C, or B2E, we can help you make the connections that matter-to the people who matter to your business.'
	    )
	  );
	};
	
	var Title = function Title(props) {
	  var isInView = props.isInView;
	
	  var b2meTitles = [{ component: _react2.default.createElement(_b2me2.default, null), multiplier: 500 }, { component: _react2.default.createElement(_b2b2.default, null), multiplier: 750 }, { component: _react2.default.createElement(_b2c2.default, null), multiplier: 1000 }, { component: _react2.default.createElement(_b2e2.default, null), multiplier: 1250 }];
	  return b2meTitles.map(function (logo, index) {
	    var animationConfig = {
	      duration: 1000,
	      easing: easings.easeCubicOut
	    };
	    return _react2.default.createElement(
	      _reactSpring.Spring,
	      {
	        key: index,
	        from: { opacity: '0' },
	        to: {
	          opacity: isInView ? '1' : '0'
	        },
	        delay: b2meTitles[index].multiplier
	      },
	      function (animation) {
	        return _react2.default.createElement(
	          'div',
	          { style: { opacity: animation.opacity } },
	          logo.component
	        );
	      }
	    );
	  });
	};
	
	var HomeApproachContent = function HomeApproachContent(props) {
	  var isInView = props.isInView;
	
	  var settings = {
	    sectionTitle: 'Our Approach'
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _homeApproachModule2.default.wrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _homeApproachModule2.default.container },
	      _react2.default.createElement(
	        'div',
	        { className: _homeApproachModule2.default.message },
	        _react2.default.createElement(Title, { isInView: isInView })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _homeApproachModule2.default.content },
	        _react2.default.createElement(
	          _revealSlideDown2.default,
	          { isInView: isInView, delay: 400 },
	          _react2.default.createElement(_homeSectionTitle2.default, {
	            sectionName: settings.sectionTitle,
	            isInView: isInView,
	            white: true
	          }),
	          _react2.default.createElement(Description, null)
	        )
	      )
	    ),
	    _react2.default.createElement(_gradientBgTransition2.default, null)
	  );
	};
	
	var HomeApproach = function HomeApproach(props) {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reveal2.default,
	      null,
	      _react2.default.createElement(HomeApproachContent, props)
	    )
	  );
	};
	
	exports.default = HomeApproach;
	module.exports = exports['default'];

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-home-home-clients----home-clients-module---wrapper---3JMV4","container":"src-components-home-home-clients----home-clients-module---container---gbtUK","contentWrapperThree":"src-components-home-home-clients----home-clients-module---contentWrapperThree---22ikD","contentWrapperSix":"src-components-home-home-clients----home-clients-module---contentWrapperSix---_2I1K","row":"src-components-home-home-clients----home-clients-module---row---3OCyV","content":"src-components-home-home-clients----home-clients-module---content---3-Mrs","contentThree":"src-components-home-home-clients----home-clients-module---contentThree---3cpx4","contentSix":"src-components-home-home-clients----home-clients-module---contentSix---2o1rq","squareBlock":"src-components-home-home-clients----home-clients-module---squareBlock---L0_mK","copy":"src-components-home-home-clients----home-clients-module---copy---1m_Fm","title":"src-components-home-home-clients----home-clients-module---title---EbxGo","message":"src-components-home-home-clients----home-clients-module---message---3B7Qv"};

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helperFunctions = __webpack_require__(10);
	
	var _homeSectionTitle = __webpack_require__(72);
	
	var _homeSectionTitle2 = _interopRequireDefault(_homeSectionTitle);
	
	var _adp = __webpack_require__(881);
	
	var _adp2 = _interopRequireDefault(_adp);
	
	var _firmenich = __webpack_require__(887);
	
	var _firmenich2 = _interopRequireDefault(_firmenich);
	
	var _johnsonJohnson = __webpack_require__(889);
	
	var _johnsonJohnson2 = _interopRequireDefault(_johnsonJohnson);
	
	var _lg = __webpack_require__(179);
	
	var _lg2 = _interopRequireDefault(_lg);
	
	var _merck = __webpack_require__(890);
	
	var _merck2 = _interopRequireDefault(_merck);
	
	var _ohaus = __webpack_require__(891);
	
	var _ohaus2 = _interopRequireDefault(_ohaus);
	
	var _philips = __webpack_require__(180);
	
	var _philips2 = _interopRequireDefault(_philips);
	
	var _sothebys = __webpack_require__(898);
	
	var _sothebys2 = _interopRequireDefault(_sothebys);
	
	var _prudential = __webpack_require__(894);
	
	var _prudential2 = _interopRequireDefault(_prudential);
	
	var _centrica = __webpack_require__(884);
	
	var _centrica2 = _interopRequireDefault(_centrica);
	
	var _dupont = __webpack_require__(885);
	
	var _dupont2 = _interopRequireDefault(_dupont);
	
	var _priceline = __webpack_require__(893);
	
	var _priceline2 = _interopRequireDefault(_priceline);
	
	var _pfitzer = __webpack_require__(892);
	
	var _pfitzer2 = _interopRequireDefault(_pfitzer);
	
	var _bnsf = __webpack_require__(883);
	
	var _bnsf2 = _interopRequireDefault(_bnsf);
	
	var _ieee = __webpack_require__(888);
	
	var _ieee2 = _interopRequireDefault(_ieee);
	
	var _basf = __webpack_require__(882);
	
	var _basf2 = _interopRequireDefault(_basf);
	
	var _ets = __webpack_require__(886);
	
	var _ets2 = _interopRequireDefault(_ets);
	
	var _ricoh = __webpack_require__(896);
	
	var _ricoh2 = _interopRequireDefault(_ricoh);
	
	var _quest = __webpack_require__(895);
	
	var _quest2 = _interopRequireDefault(_quest);
	
	var _steveMadden = __webpack_require__(899);
	
	var _steveMadden2 = _interopRequireDefault(_steveMadden);
	
	var _reveal = __webpack_require__(9);
	
	var _reveal2 = _interopRequireDefault(_reveal);
	
	var _reactSpring = __webpack_require__(8);
	
	var _d3Ease = __webpack_require__(12);
	
	var easings = _interopRequireWildcard(_d3Ease);
	
	var _homeClientsModule = __webpack_require__(489);
	
	var _homeClientsModule2 = _interopRequireDefault(_homeClientsModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeClientsContent = function HomeClientsContent(props) {
	  var isInView = props.isInView;
	
	  var settings = {
	    sectionTitle: 'Brands We\'ve<br> Amplified'
	  };
	
	  var content = [{ logo: _react2.default.createElement(_firmenich2.default, null), id: 0 }, { logo: _react2.default.createElement(_johnsonJohnson2.default, null), id: 1 }, { logo: _react2.default.createElement(_adp2.default, null), id: 2 }, { logo: _react2.default.createElement(_merck2.default, null), id: 3 }, { logo: _react2.default.createElement(_ohaus2.default, null), id: 4 }, { logo: _react2.default.createElement(_philips2.default, null), id: 5 }, { logo: _react2.default.createElement(_sothebys2.default, null), id: 6 }, { logo: _react2.default.createElement(_prudential2.default, null), id: 7 }, { logo: _react2.default.createElement(_centrica2.default, null), id: 8 }, { logo: _react2.default.createElement(_dupont2.default, null), id: 9 }, { logo: _react2.default.createElement(_pfitzer2.default, null), id: 10 }, { logo: _react2.default.createElement(_priceline2.default, null), id: 11 }, { logo: _react2.default.createElement(_ieee2.default, null), id: 12 }, { logo: _react2.default.createElement(_basf2.default, null), id: 13 }, { logo: _react2.default.createElement(_ets2.default, null), id: 14 }, { logo: _react2.default.createElement(_ricoh2.default, null), id: 15 }, { logo: _react2.default.createElement(_quest2.default, null), id: 16 }, { logo: _react2.default.createElement(_steveMadden2.default, null), id: 17 }];
	
	  var renderRows = function renderRows(numberOfRows) {
	    var newContent = (0, _helperFunctions.chunk)(content, numberOfRows);
	    var newContentLastObject = newContent.length - 1;
	
	    var emptyPlaceholder = function emptyPlaceholder() {
	      var numberOfContentBlocks = newContent[newContentLastObject].length;
	
	      if (numberOfContentBlocks < numberOfRows) {
	        var emptyArr = [];
	        var empty = { message: null };
	        for (var i = 0; i < numberOfRows - numberOfContentBlocks; i++) {
	          emptyArr.push(empty);
	        }
	        return [].concat(newContent[newContentLastObject], emptyArr);
	      }
	    };
	
	    if (newContent[newContentLastObject].length !== numberOfRows) {
	      newContent[newContentLastObject] = emptyPlaceholder();
	    }
	
	    var clientRowsDelays = newContent.map(function (value, index) {
	      return { delay: 450 * (index + 1) };
	    });
	
	    return newContent.map(function (content, index) {
	      var animationConfig = {
	        delay: clientRowsDelays[index].delay,
	        duration: 1000,
	        easing: easings.easeCubicOut
	      };
	      return _react2.default.createElement(
	        _reactSpring.Spring,
	        {
	          key: index,
	          from: { opacity: '0' },
	          to: {
	            opacity: isInView ? '1' : '0'
	          },
	          config: animationConfig
	        },
	        function (animation) {
	          return _react2.default.createElement(
	            'div',
	            { className: _homeClientsModule2.default.row, key: index, style: animation },
	            renderContentBlocks(newContent[index], numberOfRows)
	          );
	        }
	      );
	    });
	  };
	
	  var renderContent = function renderContent(content) {
	    return _react2.default.createElement(
	      'div',
	      { className: _homeClientsModule2.default.squareBlock },
	      content.logo
	    );
	  };
	
	  var renderContentBlocks = function renderContentBlocks(content, rows) {
	    return content.map(function (logo, index) {
	      return _react2.default.createElement(
	        'div',
	        {
	          key: index,
	          className: rows === 3 ? [_homeClientsModule2.default.content, _homeClientsModule2.default.contentThree].join(' ') : rows === 6 ? [_homeClientsModule2.default.content, _homeClientsModule2.default.contentSix].join(' ') : _homeClientsModule2.default.content
	        },
	        renderContent(logo)
	      );
	    });
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _homeClientsModule2.default.wrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _homeClientsModule2.default.container },
	        _react2.default.createElement(_homeSectionTitle2.default, {
	          sectionName: settings.sectionTitle,
	          isInView: isInView
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            className: [_homeClientsModule2.default.contentWrapper, _homeClientsModule2.default.contentWrapperThree].join(' ')
	          },
	          renderRows(3)
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: [_homeClientsModule2.default.contentWrapper, _homeClientsModule2.default.contentWrapperSix].join(' ')
	          },
	          renderRows(6)
	        )
	      )
	    )
	  );
	};
	
	var HomeClients = function HomeClients(props) {
	  return _react2.default.createElement(
	    _reveal2.default,
	    null,
	    _react2.default.createElement(HomeClientsContent, props)
	  );
	};
	
	exports.default = HomeClients;
	module.exports = exports['default'];

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-home-home-connect----home-connect-module---wrapper---1WdB_","container":"src-components-home-home-connect----home-connect-module---container---qHLtp","locations":"src-components-home-home-connect----home-connect-module---locations---1lDv1","bgCover":"src-components-home-home-connect----home-connect-module---bgCover---1GVlw","address":"src-components-home-home-connect----home-connect-module---address---2P6Vu","bgImageWrapper":"src-components-home-home-connect----home-connect-module---bgImageWrapper---c_aHM","bgImage":"src-components-home-home-connect----home-connect-module---bgImage---3O0RC","location":"src-components-home-home-connect----home-connect-module---location---2Zebn"};

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(4);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactSpring = __webpack_require__(8);
	
	var _d3Ease = __webpack_require__(12);
	
	var easings = _interopRequireWildcard(_d3Ease);
	
	var _homeConnectModule = __webpack_require__(490);
	
	var _homeConnectModule2 = _interopRequireDefault(_homeConnectModule);
	
	var _addressHome = __webpack_require__(273);
	
	var _addressHome2 = _interopRequireDefault(_addressHome);
	
	var _reveal = __webpack_require__(9);
	
	var _reveal2 = _interopRequireDefault(_reveal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeConnectContent = function HomeConnectContent(_ref) {
	  var locationImages = _ref.locationImages,
	      browserDetect = _ref.browserDetect,
	      mappedIndex = _ref.mappedIndex,
	      isInView = _ref.isInView;
	
	  var settings = {
	    njImage: locationImages.new_jersey,
	    nyImage: locationImages.new_york
	  };
	
	  var renderLocation = function renderLocation(delay, locationName, image) {
	    var animationConfig = {
	      delay: delay,
	      duration: 800,
	      easing: easings.easeCubicOut
	    };
	    return _react2.default.createElement(
	      _reactSpring.Spring,
	      {
	        from: { opacity: 0, transform: 'translateY(120px)' },
	        to: {
	          opacity: isInView ? 1 : 0,
	          transform: isInView ? 'translateY(0)' : 'translateY(120px)'
	        },
	        config: animationConfig
	      },
	      function (animation) {
	        return _react2.default.createElement(
	          'div',
	          { className: _homeConnectModule2.default.location, style: animation },
	          _react2.default.createElement(
	            'div',
	            { className: _homeConnectModule2.default.address },
	            _react2.default.createElement(_addressHome2.default, { location: locationName })
	          ),
	          _react2.default.createElement('div', { className: _homeConnectModule2.default.bgCover }),
	          _react2.default.createElement(_gatsbyImage2.default, {
	            sizes: image.localFile.childImageSharp.sizes,
	            backgroundColor: true,
	            style: { position: 'absolute' },
	            outerWrapperClassName: _homeConnectModule2.default.bgImageWrapper,
	            className: _homeConnectModule2.default.bgImage
	          })
	        );
	      }
	    );
	  };
	
	  var renderLocations = function renderLocations() {
	    return _react2.default.createElement(
	      'div',
	      { className: _homeConnectModule2.default.wrapper },
	      renderLocation(200, 'new_jersey', settings.njImage),
	      renderLocation(500, 'new_york', settings.nyImage)
	    );
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _homeConnectModule2.default.locations },
	    _react2.default.createElement(
	      'div',
	      { className: _homeConnectModule2.default.container },
	      renderLocations()
	    )
	  );
	};
	
	var HomeConnect = function HomeConnect(props) {
	  return _react2.default.createElement(
	    _reveal2.default,
	    null,
	    _react2.default.createElement(HomeConnectContent, props)
	  );
	};
	
	HomeConnect.propTypes = {
	  locationImages: _propTypes2.default.object,
	  headerHeight: _propTypes2.default.number,
	  browserDetect: _propTypes2.default.string
	};
	
	exports.default = HomeConnect;
	module.exports = exports['default'];

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"title":"src-components-home-home-culture-home-culture-title----home-culture-title-module---title---kl51H","titleDesktop":"src-components-home-home-culture-home-culture-title----home-culture-title-module---titleDesktop----PI_K","titleMobile":"src-components-home-home-culture-home-culture-title----home-culture-title-module---titleMobile---lNPTW"};

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFittext = __webpack_require__(7);
	
	var _reactFittext2 = _interopRequireDefault(_reactFittext);
	
	var _homeCultureTitleModule = __webpack_require__(491);
	
	var _homeCultureTitleModule2 = _interopRequireDefault(_homeCultureTitleModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeCultureTitle = function HomeCultureTitle(props) {
	  var animation = props.animation;
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _homeCultureTitleModule2.default.titleDesktop, style: animation },
	      _react2.default.createElement(
	        _reactFittext2.default,
	        { compressor: 0.9, maxFontSize: 80 },
	        _react2.default.createElement(
	          'h2',
	          { className: _homeCultureTitleModule2.default.title },
	          'Being awesome',
	          _react2.default.createElement('br', null),
	          ' is encouraged.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _homeCultureTitleModule2.default.titleMobile, style: animation },
	      _react2.default.createElement(
	        _reactFittext2.default,
	        { compressor: 1, maxFontSize: 60 },
	        _react2.default.createElement(
	          'h2',
	          { className: _homeCultureTitleModule2.default.title },
	          'Being awesome',
	          _react2.default.createElement('br', null),
	          ' is encouraged.'
	        )
	      )
	    )
	  );
	};
	
	HomeCultureTitle.propTypes = {
	  animation: _propTypes2.default.object
	};
	
	exports.default = HomeCultureTitle;
	module.exports = exports['default'];

/***/ }),

/***/ 492:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-home-home-culture----home-culture-module---wrapper---3NEeN","container":"src-components-home-home-culture----home-culture-module---container---rPk8E","content":"src-components-home-home-culture----home-culture-module---content---yaWRA","message":"src-components-home-home-culture----home-culture-module---message---8khJq","image":"src-components-home-home-culture----home-culture-module---image---hv4gZ","learnMore":"src-components-home-home-culture----home-culture-module---learnMore---2j6FI","titleDesktop":"src-components-home-home-culture----home-culture-module---titleDesktop---2wXA3","titleMobile":"src-components-home-home-culture----home-culture-module---titleMobile---396-T"};

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _homeSectionTitle = __webpack_require__(72);
	
	var _homeSectionTitle2 = _interopRequireDefault(_homeSectionTitle);
	
	var _homeCultureTitle = __webpack_require__(299);
	
	var _homeCultureTitle2 = _interopRequireDefault(_homeCultureTitle);
	
	var _gatsbyImage = __webpack_require__(4);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reveal = __webpack_require__(9);
	
	var _reveal2 = _interopRequireDefault(_reveal);
	
	var _revealEdges = __webpack_require__(26);
	
	var _revealEdges2 = _interopRequireDefault(_revealEdges);
	
	var _revealSlideDown = __webpack_require__(15);
	
	var _revealSlideDown2 = _interopRequireDefault(_revealSlideDown);
	
	var _homeCultureModule = __webpack_require__(492);
	
	var _homeCultureModule2 = _interopRequireDefault(_homeCultureModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CultureImage = function CultureImage(props) {
	  var culture = props.culture,
	      animation = props.animation,
	      isInView = props.isInView;
	
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: _homeCultureModule2.default.image,
	      style: {
	        position: 'relative',
	        opacity: animation.opacity,
	        transform: animation.transform
	      }
	    },
	    _react2.default.createElement(_revealEdges2.default, { isInView: isInView }),
	    _react2.default.createElement(_gatsbyImage2.default, {
	      className: _homeCultureModule2.default.image,
	      outerWrapperClassName: _homeCultureModule2.default.imageOuterWrapper,
	      sizes: culture.localFile.childImageSharp.sizes,
	      backgroundColor: true,
	      alt: 'Culture'
	    })
	  );
	};
	
	var CultureLink = function CultureLink(props) {
	  var animation = props.animation;
	
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: '/about', className: _homeCultureModule2.default.learnMore, style: animation },
	    'It\u2019s the JK Way \u203A'
	  );
	};
	
	var HomeCultureContent = function HomeCultureContent(props) {
	  var isInView = props.isInView;
	
	
	  var settings = {
	    sectionTitle: 'Our Culture'
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _homeCultureModule2.default.wrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _homeCultureModule2.default.container },
	      _react2.default.createElement(
	        'div',
	        { className: _homeCultureModule2.default.content },
	        _react2.default.createElement(
	          'div',
	          { className: _homeCultureModule2.default.message },
	          _react2.default.createElement(_homeSectionTitle2.default, {
	            sectionName: settings.sectionTitle,
	            isInView: isInView
	          }),
	          _react2.default.createElement(
	            _revealSlideDown2.default,
	            { isInView: isInView },
	            _react2.default.createElement(_homeCultureTitle2.default, null)
	          ),
	          _react2.default.createElement(
	            _revealSlideDown2.default,
	            { isInView: isInView, delay: 400 },
	            _react2.default.createElement(CultureLink, null)
	          )
	        ),
	        _react2.default.createElement(
	          _revealSlideDown2.default,
	          { isInView: isInView },
	          _react2.default.createElement(CultureImage, props)
	        )
	      )
	    )
	  );
	};
	
	var HomeCulture = function HomeCulture(props) {
	  return _react2.default.createElement(
	    _reveal2.default,
	    null,
	    _react2.default.createElement(HomeCultureContent, props)
	  );
	};
	
	CultureImage.propTypes = {
	  animation: _propTypes2.default.object,
	  culture: _propTypes2.default.object,
	  isInView: _propTypes2.default.bool
	};
	
	exports.default = HomeCulture;
	module.exports = exports['default'];

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headline":"src-components-home-home-projects-home-projects-col----home-projects-col-module---headline---2hoWe","description":"src-components-home-home-projects-home-projects-col----home-projects-col-module---description---23fPe","first":"src-components-home-home-projects-home-projects-col----home-projects-col-module---first---1Bj7a","projectImage":"src-components-home-home-projects-home-projects-col----home-projects-col-module---projectImage---2qzs1","logo":"src-components-home-home-projects-home-projects-col----home-projects-col-module---logo---1-jDM","imageOuterWrapper":"src-components-home-home-projects-home-projects-col----home-projects-col-module---imageOuterWrapper---2tOLB","image":"src-components-home-home-projects-home-projects-col----home-projects-col-module---image---1xjRu","info":"src-components-home-home-projects-home-projects-col----home-projects-col-module---info---3mjNi"};

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(4);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _logos = __webpack_require__(48);
	
	var _logos2 = _interopRequireDefault(_logos);
	
	var _homeProjectsColModule = __webpack_require__(493);
	
	var _homeProjectsColModule2 = _interopRequireDefault(_homeProjectsColModule);
	
	var _reactFittext = __webpack_require__(7);
	
	var _reactFittext2 = _interopRequireDefault(_reactFittext);
	
	var _reveal = __webpack_require__(9);
	
	var _reveal2 = _interopRequireDefault(_reveal);
	
	var _revealSlideDown = __webpack_require__(15);
	
	var _revealSlideDown2 = _interopRequireDefault(_revealSlideDown);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _emotion = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectsCol = function ProjectsCol(props) {
	  var projects = props.projects;
	
	  return projects.map(function (project, index) {
	    return _react2.default.createElement(
	      _reveal2.default,
	      { key: index },
	      _react2.default.createElement(
	        _revealSlideDown2.default,
	        { isInView: props.isInView, delay: 200 },
	        _react2.default.createElement(ProjectColCard, { project: project, index: index })
	      )
	    );
	  });
	};
	
	var ProjectColCard = function ProjectColCard(props) {
	  var _props$project$node = props.project.node,
	      acf = _props$project$node.acf,
	      slug = _props$project$node.slug;
	  var index = props.index,
	      animation = props.animation;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: [_homeProjectsColModule2.default.project, index === 0 ? _homeProjectsColModule2.default.first : null].join(' '),
	      style: animation
	    },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: _homeProjectsColModule2.default.projectImage, to: 'our-work/' + slug },
	      _react2.default.createElement(
	        'div',
	        { className: _homeProjectsColModule2.default.logo },
	        _react2.default.createElement(_logos2.default, { slug: slug })
	      ),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        className: _homeProjectsColModule2.default.image,
	        outerWrapperClassName: _homeProjectsColModule2.default.imageOuterWrapper,
	        sizes: acf.home_image.localFile.childImageSharp.sizes,
	        backgroundColor: true,
	        alt: 'Culture'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _homeProjectsColModule2.default.info },
	      _react2.default.createElement(
	        _reactFittext2.default,
	        { compressor: 0.95, maxFontSize: 40 },
	        _react2.default.createElement(
	          'h3',
	          { className: _homeProjectsColModule2.default.headline },
	          acf.headline
	        )
	      ),
	      _react2.default.createElement(
	        _reactFittext2.default,
	        { compressor: 1.75, maxFontSize: 20 },
	        _react2.default.createElement(
	          'p',
	          { className: _homeProjectsColModule2.default.description },
	          acf.home_description
	        )
	      )
	    )
	  );
	};
	
	ProjectColCard.propTypes = {
	  project: _propTypes2.default.object.isRequired
	};
	
	exports.default = ProjectsCol;
	module.exports = exports['default'];

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-home-home-projects----home-projects-module---wrapper---19YnU","container":"src-components-home-home-projects----home-projects-module---container---2ZL8S","projects":"src-components-home-home-projects----home-projects-module---projects---HyUeD","first":"src-components-home-home-projects----home-projects-module---first---3I9Y-","viewAll":"src-components-home-home-projects----home-projects-module---viewAll---2jycC","col":"src-components-home-home-projects----home-projects-module---col---3kfEb"};

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _homeSectionTitle = __webpack_require__(72);
	
	var _homeSectionTitle2 = _interopRequireDefault(_homeSectionTitle);
	
	var _reveal = __webpack_require__(9);
	
	var _reveal2 = _interopRequireDefault(_reveal);
	
	var _homeProjectsModule = __webpack_require__(494);
	
	var _homeProjectsModule2 = _interopRequireDefault(_homeProjectsModule);
	
	var _helperFunctions = __webpack_require__(10);
	
	var _homeProjectsCol = __webpack_require__(301);
	
	var _homeProjectsCol2 = _interopRequireDefault(_homeProjectsCol);
	
	var _buttonArrow = __webpack_require__(118);
	
	var _buttonArrow2 = _interopRequireDefault(_buttonArrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeProjects = function HomeProjects(props) {
	  var projects = props.projects;
	
	  var settings = {
	    sectionTitle: 'Our Work'
	  };
	
	  var chunkProjects = (0, _helperFunctions.chunk)(projects, 2);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _homeProjectsModule2.default.wrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _homeProjectsModule2.default.container },
	      _react2.default.createElement(
	        'div',
	        { className: _homeProjectsModule2.default.projects },
	        _react2.default.createElement(
	          'div',
	          { className: _homeProjectsModule2.default.col },
	          _react2.default.createElement(
	            _reveal2.default,
	            null,
	            _react2.default.createElement(_homeSectionTitle2.default, {
	              sectionName: settings.sectionTitle,
	              isInView: props.isInView
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _homeProjectsModule2.default.first },
	            _react2.default.createElement(_homeProjectsCol2.default, { projects: chunkProjects[0] })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _homeProjectsModule2.default.col },
	          _react2.default.createElement(
	            'div',
	            { className: _homeProjectsModule2.default.second },
	            _react2.default.createElement(_homeProjectsCol2.default, { projects: chunkProjects[1] })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _homeProjectsModule2.default.viewAll },
	        _react2.default.createElement(_buttonArrow2.default, { message: 'View All Work', url: 'our-work' })
	      )
	    )
	  );
	};
	
	exports.default = HomeProjects;
	module.exports = exports['default'];

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-home-home-section-message----home-section-message-module---wrapper---3iW40","copy":"src-components-home-home-section-message----home-section-message-module---copy---buQpz","white":"src-components-home-home-section-message----home-section-message-module---white---2kbiM","break":"src-components-home-home-section-message----home-section-message-module---break---36GBg"};

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _homeSectionMessageModule = __webpack_require__(495);
	
	var _homeSectionMessageModule2 = _interopRequireDefault(_homeSectionMessageModule);
	
	var _reactSpring = __webpack_require__(8);
	
	var _d3Ease = __webpack_require__(12);
	
	var easings = _interopRequireWildcard(_d3Ease);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionMessage = function SectionMessage(props) {
	  var sectionMessage = props.sectionMessage,
	      white = props.white,
	      isInView = props.isInView;
	
	  var whiteColor = '#ffffff';
	  var animationConfig = {
	    delay: 400,
	    duration: 800,
	    easing: easings.easeLinear
	  };
	
	  var renderMessage = function renderMessage() {
	    var animationConfig = {
	      delay: 200,
	      duration: 700,
	      easing: easings.easeLinear
	    };
	    return _react2.default.createElement(
	      _reactSpring.Spring,
	      {
	        from: { opacity: '0' },
	        to: {
	          opacity: isInView ? '1' : '0'
	        },
	        config: animationConfig
	      },
	      function (animation) {
	        return _react2.default.createElement('div', {
	          className: white ? [_homeSectionMessageModule2.default.copy, _homeSectionMessageModule2.default.white].join(' ') : _homeSectionMessageModule2.default.copy,
	          dangerouslySetInnerHTML: { __html: sectionMessage },
	          style: animation
	        });
	      }
	    );
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _homeSectionMessageModule2.default.wrapper },
	    renderMessage()
	  );
	};
	
	SectionMessage.propTypes = {
	  sectionMessage: _propTypes2.default.string,
	  white: _propTypes2.default.bool
	};
	
	exports.default = SectionMessage;
	module.exports = exports['default'];

/***/ }),

/***/ 496:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-home-home-section-title----home-section-title-module---wrapper---2i9UV","copy":"src-components-home-home-section-title----home-section-title-module---copy---2VHMo","white":"src-components-home-home-section-title----home-section-title-module---white---1Lg08","dash":"src-components-home-home-section-title----home-section-title-module---dash---1zSjy","dashWhite":"src-components-home-home-section-title----home-section-title-module---dashWhite---2g_p0"};

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _homeSectionTitleModule = __webpack_require__(496);
	
	var _homeSectionTitleModule2 = _interopRequireDefault(_homeSectionTitleModule);
	
	var _reactSpring = __webpack_require__(8);
	
	var _d3Ease = __webpack_require__(12);
	
	var easings = _interopRequireWildcard(_d3Ease);
	
	var _emotion = __webpack_require__(5);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionTitle = function SectionTitle(props) {
	  var sectionName = props.sectionName,
	      white = props.white,
	      isInView = props.isInView;
	
	  var whiteColor = '#ffffff';
	  var animationConfig = {
	    delay: 400,
	    duration: 800,
	    easing: easings.easeLinear
	  };
	
	  var renderDash = function renderDash() {
	    var animationConfig = {
	      delay: 400,
	      duration: 800,
	      easing: easings.easeLinear
	    };
	    return _react2.default.createElement(
	      _reactSpring.Spring,
	      {
	        from: { opacity: '0', width: '0vw' },
	        to: {
	          opacity: isInView ? '1' : '0',
	          width: isInView ? '10vw' : '0vw'
	        },
	        config: animationConfig
	      },
	      function (animation) {
	        return _react2.default.createElement('span', {
	          className: white ? [_homeSectionTitleModule2.default.dash, _homeSectionTitleModule2.default.dashWhite].join(' ') : _homeSectionTitleModule2.default.dash,
	          style: animation
	        });
	      }
	    );
	  };
	
	  var renderTitle = function renderTitle() {
	    var animationConfig = {
	      delay: 200,
	      duration: 700,
	      easing: easings.easeLinear
	    };
	    return _react2.default.createElement(
	      _reactSpring.Spring,
	      {
	        from: { opacity: '0' },
	        to: {
	          opacity: isInView ? '1' : '0'
	        },
	        config: animationConfig
	      },
	      function (animation) {
	        return _react2.default.createElement('div', {
	          className: white ? [_homeSectionTitleModule2.default.copy, _homeSectionTitleModule2.default.white].join(' ') : _homeSectionTitleModule2.default.copy,
	          dangerouslySetInnerHTML: { __html: sectionName },
	          style: animation
	        });
	      }
	    );
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _homeSectionTitleModule2.default.wrapper },
	    renderTitle(),
	    renderDash()
	  );
	};
	
	SectionTitle.propTypes = {
	  sectionName: _propTypes2.default.string,
	  white: _propTypes2.default.bool
	};
	
	exports.default = SectionTitle;
	module.exports = exports['default'];

/***/ }),

/***/ 497:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"services":"src-components-home-home-services-home-services-cards----home-services-cards-module---services---3hqqk","card":"src-components-home-home-services-home-services-cards----home-services-cards-module---card---1MyIo","learn":"src-components-home-home-services-home-services-cards----home-services-cards-module---learn---2NInX","cardLogo":"src-components-home-home-services-home-services-cards----home-services-cards-module---cardLogo---6si2N","title":"src-components-home-home-services-home-services-cards----home-services-cards-module---title---2xBsu","internalInfoList":"src-components-home-home-services-home-services-cards----home-services-cards-module---internalInfoList---1JWtL","infoTitle":"src-components-home-home-services-home-services-cards----home-services-cards-module---infoTitle---11xXg","cardBG":"src-components-home-home-services-home-services-cards----home-services-cards-module---cardBG---1XVba"};

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _homeServicesCardsModule = __webpack_require__(497);
	
	var _homeServicesCardsModule2 = _interopRequireDefault(_homeServicesCardsModule);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logos = __webpack_require__(48);
	
	var _logos2 = _interopRequireDefault(_logos);
	
	var _helperFunctions = __webpack_require__(10);
	
	var _reactSpring = __webpack_require__(8);
	
	var _d3Ease = __webpack_require__(12);
	
	var easings = _interopRequireWildcard(_d3Ease);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeServicesCards = function HomeServicesCards(props) {
	  var servicesWithMultiplier = props.servicesWithMultiplier,
	      isInView = props.isInView;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _homeServicesCardsModule2.default.services },
	    servicesWithMultiplier.map(function (service, index) {
	      var _service$node = service.node,
	          title = _service$node.title,
	          slug = _service$node.slug,
	          acf = _service$node.acf;
	
	      var animationConfig = {
	        duration: 1000,
	        easing: easings.easeCubicOut
	      };
	      return _react2.default.createElement(
	        _reactSpring.Spring,
	        {
	          key: index,
	          from: { opacity: '0' },
	          to: {
	            opacity: isInView ? '1' : '0'
	          },
	          config: animationConfig,
	          delay: servicesWithMultiplier[index].multiplier
	        },
	        function (animation) {
	          return _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: 'capabilities/' + slug,
	              className: _homeServicesCardsModule2.default.card,
	              style: { opacity: animation.opacity }
	            },
	            _react2.default.createElement('div', { className: _homeServicesCardsModule2.default.cardBG }),
	            _react2.default.createElement(
	              'div',
	              { className: _homeServicesCardsModule2.default.cardLogo },
	              _react2.default.createElement(_logos2.default, { slug: slug })
	            ),
	            _react2.default.createElement('h3', {
	              className: _homeServicesCardsModule2.default.title,
	              dangerouslySetInnerHTML: { __html: title }
	            }),
	            _react2.default.createElement(
	              'ul',
	              { className: _homeServicesCardsModule2.default.internalInfoList },
	              acf.internal_info.map(function (info, index) {
	                return _react2.default.createElement('li', {
	                  key: index,
	                  className: _homeServicesCardsModule2.default.infoTitle,
	                  dangerouslySetInnerHTML: {
	                    __html: (0, _helperFunctions.replaceBreakWithSpace)(info.title)
	                  }
	                });
	              })
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: _homeServicesCardsModule2.default.learn },
	              'Learn More'
	            )
	          );
	        }
	      );
	    })
	  );
	};
	
	exports.default = HomeServicesCards;
	module.exports = exports['default'];

/***/ }),

/***/ 498:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-home-home-services----home-services-module---wrapper---3YGiL","container":"src-components-home-home-services----home-services-module---container---2NG0y"};

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reveal = __webpack_require__(9);
	
	var _reveal2 = _interopRequireDefault(_reveal);
	
	var _homeSectionTitle = __webpack_require__(72);
	
	var _homeSectionTitle2 = _interopRequireDefault(_homeSectionTitle);
	
	var _homeSectionMessage = __webpack_require__(303);
	
	var _homeSectionMessage2 = _interopRequireDefault(_homeSectionMessage);
	
	var _homeServicesCards = __webpack_require__(304);
	
	var _homeServicesCards2 = _interopRequireDefault(_homeServicesCards);
	
	var _homeServicesModule = __webpack_require__(498);
	
	var _homeServicesModule2 = _interopRequireDefault(_homeServicesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeServices = function HomeServices(_ref) {
	  var services = _ref.services;
	
	  var settings = {
	    sectionTitle: 'Our Capabilities',
	    sectionMessage: 'Need big-picture strategy? Or one shareable video?<span style="display: block;"></span>\n    We\'re ready to build a strong partnership with you&mdash; one great project at a time.\n    '
	  };
	
	  var servicesWithMultiplier = services.map(function (service, index) {
	    return _extends({}, service, { multiplier: 250 * (index + 1) });
	  });
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _homeServicesModule2.default.wrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _homeServicesModule2.default.container },
	        _react2.default.createElement(
	          _reveal2.default,
	          null,
	          _react2.default.createElement(_homeSectionTitle2.default, { sectionName: settings.sectionTitle, white: true }),
	          _react2.default.createElement(_homeSectionMessage2.default, {
	            sectionMessage: settings.sectionMessage,
	            white: true
	          })
	        ),
	        _react2.default.createElement(
	          _reveal2.default,
	          null,
	          _react2.default.createElement(_homeServicesCards2.default, {
	            servicesWithMultiplier: servicesWithMultiplier
	          })
	        )
	      )
	    )
	  );
	};
	
	HomeServices.propTypes = {
	  services: _propTypes2.default.array
	};
	
	exports.default = HomeServices;
	module.exports = exports['default'];

/***/ }),

/***/ 166:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"src-components-menus-footer-menu----footer-menu-module---list---1QvYA","item":"src-components-menus-footer-menu----footer-menu-module---item---2nomC","link":"src-components-menus-footer-menu----footer-menu-module---link---3k7JJ"};

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _footerMenuModule = __webpack_require__(166);
	
	var _footerMenuModule2 = _interopRequireDefault(_footerMenuModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterMenu = function FooterMenu(_ref) {
	  var footerMenuItems = _ref.footerMenuItems;
	
	  var renderMenuItems = function renderMenuItems() {
	    if (footerMenuItems.length) {
	      return footerMenuItems.map(function (item, index) {
	        return _react2.default.createElement(
	          'li',
	          { key: index, className: _footerMenuModule2.default.item },
	          item.title === 'Dissection Podcast' ? _react2.default.createElement(
	            'a',
	            {
	              href: item.url,
	              target: '_blank',
	              rel: 'noopener noreferrer',
	              className: _footerMenuModule2.default.link
	            },
	            item.title
	          ) : _react2.default.createElement(
	            'a',
	            {
	              href: 'https://www.jkdesign.com' + item.url,
	              className: _footerMenuModule2.default.link
	            },
	            item.title
	          )
	        );
	      });
	    }
	  };
	
	  return _react2.default.createElement(
	    'ul',
	    { className: _footerMenuModule2.default.list },
	    renderMenuItems()
	  );
	};
	
	FooterMenu.propTypes = {
	  footerMenuItems: _propTypes2.default.array
	};
	
	exports.default = FooterMenu;
	module.exports = exports['default'];

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _infoMenuModule = __webpack_require__(167);
	
	var _infoMenuModule2 = _interopRequireDefault(_infoMenuModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InfoMenu = function InfoMenu(_ref) {
	  var infoMenuItems = _ref.infoMenuItems;
	
	  var renderMenuItems = function renderMenuItems() {
	    if (infoMenuItems.length) {
	      return infoMenuItems.map(function (item, index) {
	        return _react2.default.createElement(
	          'li',
	          { key: index, className: _infoMenuModule2.default.item },
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://www.jkdesign.com' + item.url,
	              className: _infoMenuModule2.default.link
	            },
	            item.title
	          )
	        );
	      });
	    }
	  };
	
	  return _react2.default.createElement(
	    'ul',
	    { className: _infoMenuModule2.default.list },
	    renderMenuItems()
	  );
	};
	
	InfoMenu.propTypes = {
	  infoMenuItems: _propTypes2.default.array
	};
	
	exports.default = InfoMenu;
	module.exports = exports['default'];

/***/ }),

/***/ 167:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"src-components-menus-info-menu----info-menu-module---list---3sfhF","item":"src-components-menus-info-menu----info-menu-module---item---dgVI6","link":"src-components-menus-info-menu----info-menu-module---link---idaag"};

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _io = __webpack_require__(60);
	
	var _socialMenuModule = __webpack_require__(89);
	
	var _socialMenuModule2 = _interopRequireDefault(_socialMenuModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialMenu = function SocialMenu(_ref) {
	  var socialMenuItems = _ref.socialMenuItems;
	
	  var getSocialIcon = function getSocialIcon(key) {
	    switch (key) {
	      case 'facebook':
	        return _react2.default.createElement(_io.IoLogoFacebook, null);
	      case 'twitter':
	        return _react2.default.createElement(_io.IoLogoTwitter, null);
	      case 'linkedin':
	        return _react2.default.createElement(_io.IoLogoLinkedin, null);
	      case 'instagram':
	        return _react2.default.createElement(_io.IoLogoInstagram, null);
	      case 'youtube':
	        return _react2.default.createElement(_io.IoLogoYoutube, null);
	      default:
	        break;
	    }
	  };
	
	  var renderMenuItems = function renderMenuItems() {
	    if (socialMenuItems.length) {
	      return socialMenuItems.map(function (item, index) {
	        return _react2.default.createElement(
	          'li',
	          { key: index, className: _socialMenuModule2.default.item },
	          _react2.default.createElement(
	            'a',
	            {
	              href: item.url,
	              target: '_blank',
	              rel: 'noopener noreferrer',
	              'aria-label': item.object_slug,
	              className: _socialMenuModule2.default.link
	            },
	            getSocialIcon(item.object_slug)
	          )
	        );
	      });
	    }
	  };
	
	  return _react2.default.createElement(
	    'ul',
	    { className: _socialMenuModule2.default.list },
	    renderMenuItems()
	  );
	};
	
	SocialMenu.propTypes = {
	  socialMenuItems: _propTypes2.default.array
	};
	
	exports.default = SocialMenu;
	module.exports = exports['default'];

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"src-components-menus-social-menu----social-menu-module---list---O769F","item":"src-components-menus-social-menu----social-menu-module---item---2MBy7","link":"src-components-menus-social-menu----social-menu-module---link---2SRyq"};

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.homeQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _footer = __webpack_require__(121);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _helperFunctions = __webpack_require__(10);
	
	var _homeAmplified = __webpack_require__(295);
	
	var _homeAmplified2 = _interopRequireDefault(_homeAmplified);
	
	var _homeProjects = __webpack_require__(302);
	
	var _homeProjects2 = _interopRequireDefault(_homeProjects);
	
	var _homeServices = __webpack_require__(305);
	
	var _homeServices2 = _interopRequireDefault(_homeServices);
	
	var _homeApproach = __webpack_require__(296);
	
	var _homeApproach2 = _interopRequireDefault(_homeApproach);
	
	var _homeClients = __webpack_require__(297);
	
	var _homeClients2 = _interopRequireDefault(_homeClients);
	
	var _homeCulture = __webpack_require__(300);
	
	var _homeCulture2 = _interopRequireDefault(_homeCulture);
	
	var _homeConnect = __webpack_require__(298);
	
	var _homeConnect2 = _interopRequireDefault(_homeConnect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _Component.call(this));
	  }
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window !== 'undefined') {
	      window.location = 'https://www.jkdesign.com';
	    }
	    (0, _helperFunctions.resetScrollPos)();
	    this.props.displayHomeBanner(true);
	  };
	
	  IndexPage.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.props.displayHomeBanner(false);
	  };
	
	  IndexPage.prototype.render = function render() {
	    var menuList = this.props.data.allWordpressWpApiMenusMenusItems.edges;
	    var acf = this.props.data.allWordpressPage.edges[0].node.acf;
	    var _props = this.props,
	        data = _props.data,
	        browserDetect = _props.browserDetect;
	
	
	    var settings = {
	      menus: {
	        socialMenuItems: menuList[1].node.items,
	        footerMenuItems: menuList[2].node.items,
	        infoMenuItems: menuList[3].node.items
	      },
	      currentPage: 'IndexPage',
	      allWorkData: data.allWordpressWpWork.edges,
	      projectList: ['ricoh', 'adp', 'weichert-franchising', 'ad'],
	      services: data.allWordpressWpServices.edges,
	      awards: acf.footer_awards,
	      culture: acf.culture,
	      metaTitle: 'JK Design | Creative Marketing Agency',
	      meta: [{
	        title: 'JK Design | Creative Marketing Agency',
	        name: 'description',
	        content: 'JK helps you find new, creative ways to connect with the people who matter to your business - with our branding & messaging, employee experience, strategic marketing, and digital services.'
	      }]
	    };
	
	    var projects = (0, _helperFunctions.filterProjects)(settings.allWorkData, settings.projectList);
	    var projectsReArranged = [].concat(projects[3], projects[1], projects[2], projects[0]);
	
	    var _props2 = this.props,
	        headerHeight = _props2.headerHeight,
	        showHeaderBackdrop = _props2.showHeaderBackdrop,
	        hideHeaderBackdrop = _props2.hideHeaderBackdrop,
	        location = _props2.location;
	    var _settings$menus = settings.menus,
	        footerMenuItems = _settings$menus.footerMenuItems,
	        socialMenuItems = _settings$menus.socialMenuItems,
	        infoMenuItems = _settings$menus.infoMenuItems;
	    var awards = settings.awards;
	
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: settings.metaTitle, meta: settings.meta }),
	      _react2.default.createElement(_homeAmplified2.default, null),
	      _react2.default.createElement(_homeProjects2.default, { projects: projectsReArranged }),
	      _react2.default.createElement(_homeServices2.default, { services: settings.services }),
	      _react2.default.createElement(_homeApproach2.default, null),
	      _react2.default.createElement(_homeClients2.default, null),
	      _react2.default.createElement(_homeCulture2.default, { culture: settings.culture }),
	      _react2.default.createElement(_homeConnect2.default, { locationImages: acf, browserDetect: browserDetect }),
	      _react2.default.createElement(_footer2.default, {
	        footerMenuItems: footerMenuItems,
	        socialMenuItems: socialMenuItems,
	        infoMenuItems: infoMenuItems,
	        awards: awards
	      })
	    );
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	IndexPage.propTypes = {
	  setBrowser: _propTypes2.default.func,
	  showHeaderBackdrop: _propTypes2.default.func,
	  hideHeaderBackdrop: _propTypes2.default.func,
	  currentPage: _propTypes2.default.string
	};
	
	exports.default = IndexPage;
	var homeQuery = exports.homeQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 376:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEvent = exports.addEvent = function () {
	  if (typeof window !== 'undefined') {
	    if (document.addEventListener) {
	      return function (el, type, fn) {
	        if (el && el.nodeName || el === window) {
	          el.addEventListener(type, fn, false);
	        } else if (el && el.length) {
	          for (var i = 0; i < el.length; i++) {
	            addEvent(el[i], type, fn);
	          }
	        }
	      };
	    } else {
	      return function (el, type, fn) {
	        if (el && el.nodeName || el === window) {
	          el.attachEvent('on' + type, function () {
	            return fn.call(el, window.event);
	          });
	        } else if (el && el.length) {
	          for (var i = 0; i < el.length; i++) {
	            addEvent(el[i], type, fn);
	          }
	        }
	      };
	    }
	  }
	}();
	
	var asTime = exports.asTime = function asTime(t) {
	  t = Math.round(t);
	  var s = t % 60;
	  var m = Math.round(t / 60);
	
	  return two(m) + ':' + two(s);
	};
	
	var two = exports.two = function two(s) {
	  s += '';
	  if (s.length < 2) s = '0' + s;
	  return s;
	};
	
	var prefetch_file = exports.prefetch_file = function prefetch_file(url, fetched_callback, progress_callback, error_callback) {
	  var xhr = new XMLHttpRequest();
	  xhr.open('GET', url, true);
	  xhr.responseType = 'blob';
	
	  xhr.addEventListener('load', function () {
	    if (xhr.status === 200) {
	      var URL = window.URL || window.webkitURL;
	      var blob_url = URL.createObjectURL(xhr.response);
	      fetched_callback(blob_url);
	    } else {
	      error_callback();
	    }
	  }, false);
	
	  var prev_pc = 0;
	  xhr.addEventListener('progress', function (event) {
	    if (event.lengthComputable) {
	      var pc = Math.round(event.loaded / event.total * 100);
	      if (pc != prev_pc) {
	        prev_pc = pc;
	        progress_callback(pc);
	      }
	    }
	  });
	  xhr.send();
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-7524f72bdc90188a3375.js